import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.blog": "Blog",
      "nav.discover": "Découvrir",
      "nav.admin": "Admin",
      "nav.login": "Se connecter",
      "nav.logout": "Déconnexion",
      "nav.comparison": "Comparaison",
      "nav.howItWorks": "Comment ça marche",
      "nav.examples": "Exemples",
      "nav.whyUs": "Pourquoi nous",
      "nav.faq": "FAQ",
      "nav.questionnaire": "Questionnaire",

      // User Preferences
      "preferences.currency": "Devise",
      "preferences.chooseCurrency": "Choisir une devise",
      "preferences.language": "Langue",
      "preferences.chooseLanguage": "Choisir une langue",
      "preferences.temperature": "Température",
      
      // Currencies
      "currency.EUR": "Euro",
      "currency.USD": "Dollar américain",
      "currency.GBP": "Livre sterling",
      
      // Languages
      "language.fr": "Français",
      "language.en": "English",
      "language.es": "Español",
      
      // User Menu
      "userMenu.blog": "Blog",
      
      // User Menu
      "userMenu.newTrip": "Nouveau voyage",
      "userMenu.myTrips": "Mes voyages",
      "userMenu.planner": "Planificateur",
      "userMenu.settings": "Paramètres",
      "userMenu.about": "À propos",
      "userMenu.contact": "Contact",
      "userMenu.terms": "CGV",
      "userMenu.login": "Se connecter",
      "userMenu.logout": "Se déconnecter",

      // Hero Section
      "hero.title": "Ton voyage,",
      "hero.title.ai": "optimisé par l'IA",
      "hero.subtitle":
        "Découvre ton prochain itinéraire personnalisé — vols, hôtels, météo, activités, tout en un seul clic.",
      "hero.subtitle.user":
        "{{name}}, découvre ton prochain itinéraire personnalisé — vols, hôtels, météo, activités, tout en un seul clic.",
      "hero.cta": "Crée ton itinéraire",

      // How it works
      "howItWorks.title": "Comment ça marche ?",
      "howItWorks.description": "simplifie ton voyage en 4 étapes :",
      "howItWorks.step1": "Tu indiques tes envies (destination, budget, style).",
      "howItWorks.step2": "Nous comparons en temps réel vols, hébergements et activités (prix, météo, distances).",
      "howItWorks.step3":
        "Nous créons pour toi un itinéraire jour-par-jour clair, optimisé et respectueux de ton budget.",
      "howItWorks.step4":
        "Tu reçois une proposition personnalisée avec un prix détaillé et un seul lien pour tout réserver en quelques clics.",
      "howItWorks.tagline": "Moins d'onglets, plus d'aventure.",

      // Steps details
      "step1.title": "Vos envies",
      "step1.description": "Partage-nous tes envies de voyage pour un itinéraire 100% personnalisé.",
      "step1.dest": "Indique ta destination :",
      "step1.dest.desc":
        "que ce soit Lisbonne, Tokyo ou juste l'aéroport de départ, pour que Travliaq trouve les meilleures options.",
      "step1.dates": "Précise tes dates :",
      "step1.dates.desc": "fixes ou flexibles, pour optimiser prix et météo, et te garantir un timing parfait.",
      "step1.budget": "Partage ton budget et ton style de voyage :",
      "step1.budget.desc": "solo, sac à dos, confort ou premium, on adapte chaque étape à ton rythme et à tes envies.",

      "step2.title": "Recherche intelligente",
      "step2.description": "Notre IA analyse des milliers d'options pour trouver les meilleures combinaisons.",
      "step2.scan": "On scanne les meilleures options :",
      "step2.scan.desc": "vols, hébergements et activités, via des sources fiables et mises à jour en temps réel.",
      "step2.cross": "On croise prix, météo et logistique :",
      "step2.cross.desc": "pour que chaque étape s'enchaîne naturellement, sans perte de temps ni de budget.",
      "step2.filter": "On filtre selon ton profil :",
      "step2.filter.desc": "solo, backpacker, confort ou premium, chaque résultat est ajusté à tes priorités.",

      "step3.title": "Itinéraire optimisé",
      "step3.description": "Reçois un programme détaillé jour par jour, parfaitement adapté à tes préférences.",
      "step3.program": "Programme jour par jour :",
      "step3.program.desc":
        "activités, visites, pauses et repas organisés dans un ordre logique, pour profiter sans te presser.",
      "step3.budget": "Budget maîtrisé :",
      "step3.budget.desc": "chaque étape est chiffrée pour éviter les mauvaises surprises, du vol au café du coin.",
      "step3.tips": "Astuces locales intégrées :",
      "step3.tips.desc": "spots photo, restaurants cachés, transports malins... comme si un ami sur place te guidait.",

      "step4.title": "Voyage prêt à réserver",
      "step4.description": "Tout est prêt ! Il ne te reste plus qu'à réserver en quelques clics.",
      "step4.email": "Itinéraire complet envoyé par e-mail :",
      "step4.email.desc": "prêt à être consulté en ligne ou hors connexion.",
      "step4.links": "Liens directs pour réserver :",
      "step4.links.desc": "vols, hébergements, activités, tout est à portée de clic.",
      "step4.modular": "100% modulable :",
      "step4.modular.desc": "tu peux ajuster les dates, changer une activité ou relancer une recherche en un instant.",

      // Why Travliaq
      "whyTravliaq.title": "Pourquoi Travliaq ?",
      "whyTravliaq.subtitle": "La révolution du voyage intelligent est arrivée",
      "whyTravliaq.noPlan.title": "Fini la galère de planification",
      "whyTravliaq.noPlan.desc":
        "Plus de 20 onglets ouverts, plus de comparaisons interminables. L'IA analyse tout pour toi : prix, météo, distances, disponibilités.",
      "whyTravliaq.local.title": "Voyager comme un local",
      "whyTravliaq.local.desc":
        "Nos recommandations te mènent vers les vrais trésors cachés, loin des pièges à touristes. Authentique, pas artificiel.",
      "whyTravliaq.stat": "d'économies en temps de recherche",
      "whyTravliaq.guarantees": "Nos garanties",
      "whyTravliaq.guarantee1": "Meilleurs prix garantis",
      "whyTravliaq.guarantee2": "Itinéraire en moins de 24h",
      "whyTravliaq.guarantee3": "100% personnalisable",
      "whyTravliaq.guarantee4": "Support 7j/7",
      "whyTravliaq.testimonial":
        "« J'ai économisé 15 heures de recherche et 300€ sur mon voyage à Tokyo. Travliaq a trouvé des spots que même mes amis japonais ne connaissaient pas ! »",
      "whyTravliaq.testimonial.author": "Sarah, 26 ans — Tokyo & Kyoto, 10 jours",

      // CTA
      "cta.start": "Commencer mon voyage",
      "cta.create": "Crée ton itinéraire",

      // Comparison Section
      "comparison.title": "Avant / Après Travliaq",
      "comparison.subtitle": "Découvre comment Travliaq transforme ta façon de planifier tes voyages",
      "comparison.before.badge": "Sans Travliaq",
      "comparison.before.title": "Planification traditionnelle",
      "comparison.before.point1": "Des heures passées à comparer des centaines d'onglets",
      "comparison.before.point2": "Risque de surpayer vols et hébergements",
      "comparison.before.point3": "Itinéraire improvisé et stressant",
      "comparison.before.point4": "Aucune garantie de cohérence ou d'optimisation",
      "comparison.after.badge": "Avec Travliaq",
      "comparison.after.title": "Planification intelligente",
      "comparison.after.point1": "Quelques clics pour un itinéraire complet",
      "comparison.after.point2": "Meilleurs prix garantis par l'IA",
      "comparison.after.point3": "Programme optimisé jour par jour",
      "comparison.after.point4": "Support 7j/7 et modifications illimitées",

      // Examples Section
      "examples.title": "Découvre nos voyages",
      "examples.subtitle": "Des exemples concrets d'itinéraires créés par Travliaq",
      "examples.tokyo.title": "Tokyo & Kyoto",
      "examples.tokyo.description": "Culture, gastronomie et temples traditionnels au cœur du Japon.",
      "examples.tokyo.duration": "10 jours",
      "examples.tokyo.travelers": "2 voyageurs",
      "examples.algeria.title": "Sidi Bel Abbès",
      "examples.algeria.description": "Découverte authentique de l'Algérie et de son patrimoine.",
      "examples.algeria.duration": "7 jours",
      "examples.algeria.travelers": "1 voyageur",
      "examples.custom.title": "Ton voyage sur mesure",
      "examples.custom.description": "Crée l'itinéraire parfait selon tes envies et ton budget.",
      "examples.custom.anywhere": "Partout dans le monde",
      "examples.viewTrip": "Voir le voyage",
      "examples.createYours": "Créer mon voyage",

      // Video Section
      "video.title": "Découvre Travliaq en vidéo",
      "video.subtitle": "Vois comment nous simplifions la planification de tes voyages",
      "video.coming": "Vidéo de démonstration",
      "video.demo": "Bientôt disponible",

      // FAQ Section
      "faq.title": "Questions fréquentes",
      "faq.subtitle": "Tout ce que tu dois savoir sur Travliaq",
      "faq.q1": "Comment fonctionne Travliaq ?",
      "faq.a1": "Travliaq utilise l'intelligence artificielle pour analyser tes préférences de voyage (destination, budget, dates, style) et compare en temps réel des milliers d'options de vols, d'hébergements et d'activités. En moins de 24h, tu reçois un itinéraire optimisé jour par jour avec tous les liens de réservation.",
      "faq.q2": "Combien coûte le service ?",
      "faq.a2": "L'utilisation de Travliaq est actuellement gratuite. Tu payes uniquement tes réservations (vols, hôtels, activités) directement auprès des prestataires.",
      "faq.q3": "Puis-je modifier mon itinéraire après réception ?",
      "faq.a3": "Absolument ! Ton itinéraire est 100% modulable. Tu peux ajuster les dates, changer une activité, modifier un hébergement ou même relancer une recherche complète à tout moment.",
      "faq.q4": "Quelles destinations sont disponibles ?",
      "faq.a4": "Travliaq couvre le monde entier ! Que tu rêves de Tokyo, New York, Marrakech ou d'un road trip en Patagonie, notre IA trouve les meilleures options pour n'importe quelle destination.",
      "faq.q5": "Les prix sont-ils vraiment les meilleurs ?",
      "faq.a5": "Oui ! Notre IA compare en temps réel des centaines de sources (compagnies aériennes, plateformes de réservation, hôtels) pour te garantir les meilleurs tarifs. Et si tu trouves moins cher ailleurs, on ajuste ton itinéraire.",
      "faq.q6": "Combien de temps faut-il pour recevoir mon itinéraire ?",
      "faq.a6": "En général, tu reçois ta première proposition dans les 24 heures suivant la soumission de ton questionnaire. Pour les demandes urgentes, nous pouvons accélérer le processus.",
      "faq.more": "Tu as d'autres questions ?",
      "faq.contact": "Contacte-nous",

      // Toast
      "toast.login": "Connectez-vous avec Google pour sauvegarder vos préférences",
      "toast.loginButton": "Se connecter",
      "toast.loginError": "Erreur de connexion: {{error}}",

      // Auth page
      "auth.welcome": "Bienvenue sur Travliaq",
      "auth.subtitle": "Créez votre itinéraire personnalisé en quelques clics",
      "auth.continueWithGoogle": "Continuer avec Google",
      "auth.continueWithLinkedIn": "Continuer avec LinkedIn",
      "auth.continueWithFacebook": "Continuer avec Facebook",
      "auth.useMagicLink": "Connexion sans mot de passe",
      "auth.hideMagicLink": "Masquer le magic link",
      "auth.magicLinkTitle": "Connexion par lien magique",
      "auth.sendMagicLink": "Envoyer le lien",
      "auth.magicLinkSent": "Lien magique envoyé !",
      "auth.magicLinkSentMessage": "Vérifiez votre boîte mail et cliquez sur le lien pour vous connecter.",
      "auth.sendAnotherLink": "Envoyer un autre lien",
      "auth.magicLinkError": "Erreur lors de l'envoi du lien magique",
      "auth.useEmail": "Ou utiliser un email",
      "auth.hideEmailOption": "Masquer l'option email",
      "auth.oauthError": "Erreur lors de la connexion",
      "auth.loginWithEmail": "Connexion par email",
      "auth.signupWithEmail": "Inscription par email",
      "auth.email": "Email",
      "auth.emailPlaceholder": "votre@email.com",
      "auth.password": "Mot de passe",
      "auth.passwordSecure": "Mot de passe sécurisé",
      "auth.passwordMinLength": "Le mot de passe doit contenir au moins 8 caractères",
      "auth.passwordLowercase": "Le mot de passe doit contenir au moins une minuscule",
      "auth.passwordUppercase": "Le mot de passe doit contenir au moins une majuscule",
      "auth.passwordNumber": "Le mot de passe doit contenir au moins un chiffre",
      "auth.login": "Se connecter",
      "auth.signup": "S'inscrire",
      "auth.forgotPassword": "Mot de passe oublié ?",
      "auth.noAccount": "Pas encore de compte ?",
      "auth.signupLink": "S'inscrire",
      "auth.hasAccount": "Déjà un compte ?",
      "auth.loginLink": "Se connecter",
      "auth.footerNote": "En continuant, vous acceptez nos conditions d'utilisation",
      "auth.googleError": "Erreur lors de la connexion avec Google",
      "auth.fillAllFields": "Veuillez remplir tous les champs",
      "auth.invalidEmail": "Adresse email invalide",
      "auth.passwordCriteria": "Le mot de passe ne respecte pas les critères de sécurité",
      "auth.invalidCredentials": "Email ou mot de passe incorrect. Vérifiez que vous avez bien confirmé votre email si vous venez de vous inscrire.",
      "auth.emailNotConfirmed": "Veuillez confirmer votre email avant de vous connecter. Vérifiez votre boîte mail.",
      "auth.sessionError": "Erreur de session. Veuillez réessayer.",
      "auth.loginSuccess": "Connexion réussie",
      "auth.emailAlreadyUsed": "Cette adresse email est déjà utilisée. Si vous vous êtes inscrit avec Google, veuillez vous connecter avec Google.",
      "auth.signupSuccess": "Inscription réussie ! Vérifiez votre email pour confirmer votre compte avant de vous connecter.",
      "auth.signupAutoLogin": "Inscription réussie ! Connexion automatique...",
      "auth.loginError": "Erreur lors de la connexion",
      "auth.signupError": "Erreur lors de l'inscription",

      // Hero name suffix
      "hero.subtitle.afterName":
        ", découvre ton prochain itinéraire personnalisé — vols, hôtels, météo, activités, tout en un seul clic.",

      // Footer
      "footer.ribbon": "Gratuit • Sans engagement • Résultat en 24h",
      "footer.tagline": "L'intelligence artificielle au service de vos voyages exceptionnels",
      "footer.nav": "Navigation",
      "footer.contact": "Contact",
      "footer.legal": "Informations légales",
      "footer.follow": "Suivez-nous",
      "footer.create": "Créer un itinéraire",

      // Common
      "common.back": "Retour",
      "common.backToTop": "Retour en haut",

      // Blog
      "blog.backToBlog": "Retour au blog",
      "blog.readingTime": "{{time}} min de lecture",
      "blog.views": "{{count}} vues",
      "footer.terms": "Conditions Générales de Vente",
      "footer.imprint": "Mentions légales",
      "footer.privacy": "Politique de confidentialité",
      "footer.copyright": "© 2025 Travliaq. Tous droits réservés. Fait avec ❤️ pour les voyageurs authentiques",

      // Discover page
      "discover.title": "DÉCOUVREZ LES VOYAGES",
      "discover.subtitle":
        "Explorez notre collection de voyages uniques, conçus sur mesure pour des expériences inoubliables",
      "discover.searchPlaceholder": "Rechercher une destination, un style de voyage...",
      "discover.filters.budget": "< 800€",
      "discover.filters.group": "En groupe",
      "discover.filters.adventure": "Aventure",
      "discover.filters.nature": "Nature",
      "discover.filters.culture": "Culture",
      "discover.filters.exploration": "Exploration",
      "discover.noTrips": "Aucun voyage trouvé",
      "discover.newBadge": "NOUVEAU",
      "discover.shareLink": "Copier le lien",
      "discover.days": "jours",
      "discover.from": "À partir de",
      "discover.discover": "Découvrir",
      "discover.shareText": "Découvrez ce voyage incroyable : {{destination}}",
      "discover.error": "Erreur",
      "discover.errorLoading": "Impossible de charger les voyages",
      "discover.linkCopied": "Lien copié ! 🎉",
      "discover.linkCopiedDescription": "Le lien du voyage a été copié dans ton presse-papier",

      // Questionnaire
      "q.title": "VOTRE VOYAGE SUR MESURE",
      "q.back": "Retour",
      "q.continue": "Continuer",
      "q.send": "Envoyer 🚀",
      "q.sending": "Envoi en cours...",

      // Q1: Who's traveling
      "q.step1.title": "Qui voyage ? 👥",
      "q.step1.solo": "Solo",
      "q.step1.duo": "Duo",
      "q.step1.group": "Groupe 3-5",
      "q.step1.family": "Famille (enfants <12)",
      "q.step1b.group.title": "Nombre de voyageurs",
      "q.step1b.family.title": "Nombre de personnes (enfants inclus) 👨‍👩‍👧‍👦",

      // Q2: Help needed
      "q.step2.title": "Comment Travliaq peut vous aider ? 🎯",
      "q.step2.desc": "Sélectionnez tous les services nécessaires",
      "q.step2.flights": "Vols",
      "q.step2.accommodation": "Hébergement",
      "q.step2.activities": "Activités & Suggestions",

      // Q3: Destination
      "q.step3.title": "Où souhaitez-vous aller ? 🌍",
      "q.step3.desc": "Destination finale de votre voyage",
      "q.step3.yes": "Oui, j'ai une destination en tête",
      "q.step3.no": "Non, je ne sais pas encore",
      "q.step3.search": "Rechercher une destination...",
      "q.step3.popular": "Destinations populaires",

      // Q4: Departure location
      "q.step4.title": "D'où partez-vous ? ✈️",
      "q.step4.search": "Rechercher votre ville de départ...",
      "q.step4.detect": "Détecter automatiquement",
      "q.step4.detecting": "Détection en cours...",

      // Q5: Climate
      "q.step5.title": "Quel climat préférez-vous ? 🌡️",
      "q.step5.desc": "Sélectionnez tous les climats qui vous plaisent",
      "q.step5.hot": "Chaud (plage, soleil)",
      "q.step5.mild": "Tempéré (doux, agréable)",
      "q.step5.cold": "Froid (montagne, neige)",
      "q.step5.mix": "Mixte (variété)",

      // Q6: Travel affinities
      "q.step6.title": "Quelles sont vos affinités de voyage ? 💫",
      "q.step6.desc": "Choisissez 3 maximum",
      "q.step6.culture": "Culture (musées, monuments)",
      "q.step6.nature": "Nature (randonnée, parcs)",
      "q.step6.gastro": "Gastronomie",
      "q.step6.beach": "Plage & Détente",
      "q.step6.nightlife": "Vie nocturne",
      "q.step6.shopping": "Shopping",
      "q.step6.adventure": "Aventure",
      "q.step6.wellbeing": "Bien-être (spa, yoga)",

      // Q7: Travel ambiance
      "q.step7.title": "Ambiance de voyage souhaitée 🎨",
      "q.step7.romantic": "Romantique (couple)",
      "q.step7.family": "Famille (enfants)",
      "q.step7.friends": "Entre amis (fête)",
      "q.step7.relax": "Détente absolue",
      "q.step7.cultural": "Culturel (apprentissage)",
      "q.step7.adventure": "Aventure (sport)",

      // Q8: Dates
      "q.step8.title": "Quand souhaitez-vous partir ? 📅",
      "q.step8.exact": "J'ai des dates précises",
      "q.step8.approx": "J'ai une période approximative",
      "q.step8.flexible": "Je suis flexible",
      "q.step8.departure": "Date de départ",
      "q.step8.return": "Date de retour",
      "q.step8.approx.title": "Avez-vous une période approximative de départ ?",
      "q.step8.approx.yes": "Oui, j'ai une idée",
      "q.step8.approx.no": "Non, je suis totalement flexible",
      "q.step8.approx.when": "Vers quand souhaiteriez-vous partir ?",
      "q.step8.flex.title": "Quel est votre niveau de flexibilité ? ⏰",
      "q.step8.flex.days": "±3 jours",
      "q.step8.flex.week": "±1 semaine",
      "q.step8.flex.2weeks": "±2 semaines",
      "q.step8.flex.month": "±1 mois",

      // Q9: Duration
      "q.step9.title": "Durée du séjour 📆",
      "q.step9.1week": "1 semaine (5-7 jours)",
      "q.step9.2weeks": "2 semaines (10-14 jours)",
      "q.step9.3weeks": "3 semaines (18-21 jours)",
      "q.step9.custom": "Durée personnalisée",
      "q.step9.nights": "Nombre exact de nuits",

      // Q10: Budget
      "q.step10.title": "Budget par personne 💰",
      "q.step10.desc": "Estimation approximative",
      "q.step10.low": "Petit budget (< 1000€)",
      "q.step10.mid": "Moyen (1000-3000€)",
      "q.step10.high": "Confortable (3000-5000€)",
      "q.step10.premium": "Premium (> 5000€)",
      "q.step10.exact": "Budget précis",
      "q.step10.custom.title": "Budget exact par personne",
      "q.step10.total": "Budget total",
      "q.step10.perperson": "Budget par personne",
      "q.step10.amount": "Montant",
      "q.step10.currency": "Devise",

      // Q11: Travel styles
      "q.step11.title": "Styles de voyage 🎒",
      "q.step11.desc": "Sélectionnez tous ceux qui correspondent",
      "q.step11.backpacker": "Backpacker (auberges, routard)",
      "q.step11.comfort": "Confort (hôtels 3-4⭐)",
      "q.step11.premium": "Premium (hôtels 5⭐, luxe)",
      "q.step11.authentic": "Authentique (local, immersion)",
      "q.step11.classic": "Classique (incontournables)",
      "q.step11.offbeat": "Insolite (hors sentiers battus)",

      // Q12: Rhythm
      "q.step12.title": "Rythme du voyage 🕐",
      "q.step12.slow": "Slow travel (prendre son temps)",
      "q.step12.balanced": "Équilibré (mix détente/visites)",
      "q.step12.intense": "Intense (programme chargé)",

      // Q13: Flight preference
      "q.step13.title": "Préférence de vol ✈️",
      "q.step13.direct": "Direct uniquement",
      "q.step13.1stop": "1 escale max",
      "q.step13.any": "Peu importe (meilleur prix)",

      // Q14: Luggage
      "q.step14.title": "Bagages par voyageur 🧳",
      "q.step14.cabin": "Bagage cabine",
      "q.step14.hold": "Bagage soute",
      "q.step14.both": "Cabine + Soute",

      // Q15: Mobility
      "q.step15.title": "Mobilité & Accessibilité ♿",
      "q.step15.desc": "Sélectionnez tout ce qui s'applique",
      "q.step15.none": "Aucune contrainte",
      "q.step15.wheelchair": "Fauteuil roulant",
      "q.step15.walking": "Difficulté à marcher longtemps",
      "q.step15.elevator": "Besoin ascenseur",
      "q.step15.stairs": "Éviter les escaliers",

      // Q16: Accommodation type
      "q.step16.title": "Type d'hébergement 🏨",
      "q.step16.desc": "Choisissez tous ceux qui vous conviennent",
      "q.step16.hotel": "Hôtel",
      "q.step16.airbnb": "Airbnb/Location",
      "q.step16.hostel": "Auberge de jeunesse",
      "q.step16.resort": "Resort/All-inclusive",
      "q.step16.boutique": "Hôtel boutique",
      "q.step16b.title": "Préférences pour l'hôtel 🏨",
      "q.step16b.desc": "Sélectionnez ce qui vous intéresse",
      "q.step16b.breakfast": "Petit-déjeuner inclus",
      "q.step16b.halfboard": "Demi-pension",
      "q.step16b.fullboard": "Pension complète",
      "q.step16b.allinc": "All-inclusive",
      "q.step16b.room": "Room service",

      // Q17: Comfort
      "q.step17.title": "Niveau de confort attendu 🛏️",
      "q.step17.simple": "Simple (propreté de base)",
      "q.step17.standard": "Standard (confortable)",
      "q.step17.superior": "Supérieur (très confortable)",
      "q.step17.luxury": "Luxe (5 étoiles)",

      // Q18: Neighborhood
      "q.step18.title": "Emplacement de l'hébergement 📍",
      "q.step18.center": "Centre-ville (accès facile)",
      "q.step18.quiet": "Quartier calme (éloigné)",
      "q.step18.transport": "Près des transports",
      "q.step18.attractions": "Près des attractions",

      // Q19: Amenities
      "q.step19.title": "Équipements souhaités 🏊",
      "q.step19.desc": "Sélectionnez tous ceux importants pour vous",
      "q.step19.wifi": "Wi-Fi",
      "q.step19.pool": "Piscine",
      "q.step19.gym": "Salle de sport",
      "q.step19.spa": "Spa",
      "q.step19.restaurant": "Restaurant sur place",
      "q.step19.parking": "Parking",
      "q.step19.ac": "Climatisation",
      "q.step19.kitchen": "Cuisine équipée",

      // Q20: Constraints
      "q.step20.title": "Contraintes & préférences 🎯",
      "q.step20.desc": "Sélectionnez toutes les options importantes",
      "q.step20.halal": "Halal",
      "q.step20.kosher": "Casher",
      "q.step20.vege": "Végétarien",
      "q.step20.vegan": "Vegan",
      "q.step20.gluten": "Sans gluten",
      "q.step20.allergies": "Allergies alimentaires",
      "q.step20.none": "Aucune contrainte",

      // Q21: Additional info
      "q.step21.title": "Informations complémentaires 📝",
      "q.step21.desc": "Précisez vos attentes, contraintes ou préférences particulières (optionnel)",
      "q.step21.placeholder": "Ex: anniversaire, allergies alimentaires, accessibilité spécifique...",

      // Q22: Open comments
      "q.step22.title": "Zone libre 💭",
      "q.step22.desc": "Ajoutez tout commentaire, question ou information utile (optionnel)",
      "q.step22.placeholder": "Partagez vos envies, inspirations, contraintes particulières...",

      // Q23: Email
      "q.step23.title": "Dernière étape ! 📧",
      "q.step23.desc": "Où devons-nous envoyer votre itinéraire personnalisé ?",
      "q.step23.email": "Votre email",
      "q.step23.name": "Votre nom (optionnel)",

      // Errors & Success
      "q.error.quota": "Quota atteint 🚫",
      "q.error.quota.desc":
        "Vous avez atteint votre quota de 2 questionnaires par jour. Revenez demain pour planifier un autre voyage !",
      "q.error.auth": "Connexion requise 🔒",
      "q.error.auth.desc": "Vous devez être connecté pour soumettre un questionnaire.",
      "q.error.validation": "Erreur de validation",
      "q.error.validation.desc": "Certains champs contiennent des données invalides.",
      "q.error.generic": "Erreur",
      "q.error.generic.desc": "Une erreur est survenue lors de l'envoi du questionnaire. Veuillez réessayer.",
      "q.success": "Questionnaire envoyé ! 🎉",
      "q.success.desc": "Nous vous enverrons votre itinéraire personnalisé sous 48h.",

      "questionnaire.pleaseAnswer": "Réponse requise",
      "questionnaire.answerRequired": "Veuillez répondre à cette question avant de continuer",

      // Progress milestones
      "questionnaire.progress.profile": "Profil",
      "questionnaire.progress.destination": "Destination",
      "questionnaire.progress.dates": "Dates",
      "questionnaire.progress.budget": "Budget",
      "questionnaire.progress.flights": "Vols",
      "questionnaire.progress.activities": "Activités",
      "questionnaire.progress.preferences": "Préférences",
      "questionnaire.progress.accommodation": "Hébergement",
      "questionnaire.progress.finalization": "Finalisation",

      // Help with descriptions
      "questionnaire.flights.desc": "Billets d'avion",
      "questionnaire.accommodation.desc": "Hôtels & logements",
      "questionnaire.activities.desc": "Visites & expériences",

      // Luggage details
      "questionnaire.luggage.personalItem.desc": "Sous le siège",
      "questionnaire.luggage.cabin.desc": "Compartiment supérieur",
      "questionnaire.luggage.hold.desc": "Enregistré en soute",
      "questionnaire.luggage.cabinHold.desc": "Cabine + Soute",

      // Mobility options
      "questionnaire.mobility.dontMind": "Peu importe",
      "questionnaire.mobility.walking": "Marche",
      "questionnaire.mobility.publicTransport.full": "Marche/TC principalement",
      "questionnaire.mobility.rentalCar.full": "Location voiture",
      "questionnaire.mobility.taxi.full": "Taxi/VTC",
      "questionnaire.mobility.bike.full": "Vélo",
      "questionnaire.mobility.walking.full": "À pied",
      "questionnaire.mobility.atypical.full": "Transport atypique",
      "questionnaire.mobility.ferry.full": "Bateau/ferry",
      "questionnaire.mobility.electricScooter": "Trottinette électrique",
      "questionnaire.mobility.motorbikeScooter": "Moto/scooter",
      "questionnaire.mobility.touristBus": "Bus touristique",
      "questionnaire.mobility.trainMetro": "Train/métro",

      // Questionnaire - Additional keys
      "questionnaire.connectionRequired": "Connexion requise 🔒",
      "questionnaire.mustBeConnected": "Tu dois être connecté pour soumettre un questionnaire.",
      "questionnaire.submittedTitle": "Questionnaire envoyé ! 🎉",
      "questionnaire.submittedDescription": "Nous t'enverrons ton itinéraire personnalisé sous 48h.",
      "questionnaire.quotaReached": "Quota atteint 🚫",
      "questionnaire.quotaExceeded":
        "Tu as atteint ton quota de 2 questionnaires par jour. Reviens demain pour planifier un autre voyage !",
      "questionnaire.validationError": "Erreur de validation",
      "questionnaire.invalidData": "Certains champs contiennent des données invalides.",
      "questionnaire.error": "Erreur",
      "questionnaire.submissionError": "Une erreur est survenue lors de l'envoi du questionnaire. Veuillez réessayer.",
      "questionnaire.saveAndReturn": "💾 Sauvegarder et revenir plus tard",
      "questionnaire.draftSaved": "Brouillon sauvegardé ! 💾",
      "questionnaire.draftSavedDesc": "Vous pouvez reprendre le questionnaire plus tard",
      "questionnaire.draftRestored": "Brouillon restauré ! 📋",
      "questionnaire.draftRestoredDesc": "Vous avez repris là où vous vous êtes arrêté",
      "questionnaire.resumeDraft": "Reprendre le brouillon ?",
      "questionnaire.whoTraveling": "Qui voyage ? 👥",

      // Review step
      "questionnaire.review.title": "Récapitulatif de ton voyage 📋",
      "questionnaire.review.description": "Vérifie tes réponses avant d'envoyer",
      "questionnaire.review.group": "Groupe de voyageurs",
      "questionnaire.review.destination": "Destination",
      "questionnaire.review.dates": "Dates",
      "questionnaire.review.budget": "Budget",
      "questionnaire.review.preferences": "Préférences",
      "questionnaire.review.accommodation": "Hébergement",
      "questionnaire.review.constraints": "Contraintes",
      "questionnaire.review.contact": "Contact",
      "questionnaire.review.edit": "Modifier",
      "questionnaire.review.emailDesc": "Nous enverrons ton itinéraire à cette adresse",
      "questionnaire.submit": "Envoyer mon questionnaire",
      "questionnaire.submitting": "Envoi en cours...",
      "questionnaire.email": "Email",
      "questionnaire.emailPlaceholder": "ton@email.com",
      "questionnaire.travelGroup": "Groupe de voyage",
      "questionnaire.numberOfTravelers": "Nombre de voyageurs",
      "questionnaire.hasDestination": "Destination en tête",
      "questionnaire.destination": "Destination",
      "questionnaire.departureLocation": "Lieu de départ",
      "questionnaire.datesType": "Type de dates",
      "questionnaire.departureDate": "Date de départ",
      "questionnaire.returnDate": "Date de retour",
      "questionnaire.duration": "Durée",
      "questionnaire.budget": "Budget",
      "questionnaire.budgetAmount": "Montant du budget",
      "questionnaire.budgetCurrency": "Devise",
      "questionnaire.travelAmbiance": "Ambiance de voyage",
      "questionnaire.styles": "Styles",
      "questionnaire.rhythm": "Rythme",
      "questionnaire.schedulePrefs": "Préférences horaires",
      "questionnaire.accommodationType": "Type d'hébergement",
      "questionnaire.hotelPreferences": "Préférences hôtel",
      "questionnaire.comfort": "Confort",
      "questionnaire.security": "Sécurité",
      "questionnaire.mobility": "Mobilité",
      "questionnaire.constraints": "Contraintes",
      "questionnaire.numberOfPeople": "Nombre de personnes 👥",
      "questionnaire.continue": "Continuer",
      "questionnaire.howManyPeople": "Combien de personnes exactement ? 👥",
      "questionnaire.destinationInMind": "Une destination en tête ? 🌍",
      "questionnaire.destinationInMind.description": "Ville ou pays de destination",
      "questionnaire.howCanHelp": "Comment vous aider ? 🎯",
      "questionnaire.howCanHelp.description": "Sélectionnez les services nécessaires",
      "questionnaire.multipleSelectionPossible": "Sélection multiple possible",
      "questionnaire.solo": "Solo",
      "questionnaire.duo": "Duo",
      "questionnaire.group35": "Groupe 3-5",
      "questionnaire.family": "Famille (enfants <12)",
      "questionnaire.3people": "3 personnes",
      "questionnaire.4people": "4 personnes",
      "questionnaire.5people": "5 personnes",
      "questionnaire.yes": "Oui",
      "questionnaire.no": "Non",
      "questionnaire.flights": "Vols",
      "questionnaire.accommodation": "Hébergement",
      "questionnaire.activities": "Activités",
      "questionnaire.destinationDetails": "Renseigne les détails de ta destination 🌍",
      "questionnaire.whereFrom": "Ville de départ ? 📍",
      "questionnaire.cityTooltip":
        "Tu peux saisir n'importe quelle ville, même si elle n'apparaît pas dans la liste. L'IA comprendra ton point de départ si tu l'orthographies correctement.",
      "questionnaire.detecting": "Détection...",
      "questionnaire.myPosition": "Ma position",
      "questionnaire.departureCity": "Ville de départ",
      "questionnaire.whereGoing": "Où vas-tu ? 🌍",
      "questionnaire.destinationTooltip":
        "Tu peux saisir n'importe quelle ville, même si elle n'apparaît pas dans la liste. L'IA comprendra ta destination si tu l'orthographies correctement.",
      "questionnaire.destinationCity": "Ville de destination...",
      "questionnaire.citiesMustBeDifferent": "Les villes de départ et de destination doivent être différentes",
      "questionnaire.climatePreference": "Climat préféré ? 🌡️",
      "questionnaire.climatePreference.description": "Choix multiples possibles",
      "questionnaire.customTrip": "TON VOYAGE SUR MESURE",
      "questionnaire.back": "Retour",
      "questionnaire.backToReview": "Retour au récapitulatif",
      "questionnaire.noCityFound": "Aucune ville trouvée pour",

      // Travelers step
      "questionnaire.travelers.addTravelers": "Ajoute les voyageurs un par un",
      "questionnaire.travelers.adult": "adulte",
      "questionnaire.travelers.adults": "adultes",
      "questionnaire.travelers.child": "enfant",
      "questionnaire.travelers.children": "enfants",
      "questionnaire.travelers.addAdult": "+ Adulte",
      "questionnaire.travelers.addChild": "+ Enfant (<18 ans)",
      "questionnaire.travelers.adultLabel": "Adulte",
      "questionnaire.travelers.childLabel": "Enfant",
      "questionnaire.travelers.childAge": "Âge de l'enfant",
      "questionnaire.travelers.agePlaceholder": "Âge",
      "questionnaire.travelers.childNeedsAdult": "Un enfant doit être accompagné d'au moins un adulte",
      "questionnaire.travelers.childMinAge": "L'âge minimum d'un enfant est 1 an",

      // Climate options
      "questionnaire.climate.hotSunny": "Chaud & ensoleillé",
      "questionnaire.climate.hotSunny.desc": "25-35°C",
      "questionnaire.climate.mildSweet": "Tempéré & doux",
      "questionnaire.climate.mildSweet.desc": "15-25°C",
      "questionnaire.climate.coldSnowy": "Froid & neigeux",
      "questionnaire.climate.coldSnowy.desc": "<10°C",
      "questionnaire.climate.tropicalHumid": "Tropical & humide",
      "questionnaire.climate.tropicalHumid.desc": "Plages & jungle",
      "questionnaire.climate.mountainAltitude": "Montagne & altitude",
      "questionnaire.climate.mountainAltitude.desc": "Air pur",
      "questionnaire.climate.dontMind": "Peu importe",
      "questionnaire.climate.dontMind.desc": "Je suis flexible",

      // Travel affinities
      "questionnaire.affinities.title": "Centres d'intérêt ? 🎯",
      "questionnaire.affinities.description": "Sélectionnez jusqu'à 5 options",
      "questionnaire.affinities.selectUpTo5": "Sélectionne jusqu'à 5 affinités",
      "questionnaire.affinities.dontMind": "Peu importe",
      "questionnaire.affinities.paradiseBeaches": "Plages paradisiaques",
      "questionnaire.affinities.historicCities": "Villes historiques",
      "questionnaire.affinities.natureHiking": "Nature & randonnées",
      "questionnaire.affinities.skiWinterSports": "Ski & sports d'hiver",
      "questionnaire.affinities.safariAnimals": "Safari & animaux",
      "questionnaire.affinities.localGastronomy": "Gastronomie locale",
      "questionnaire.affinities.shoppingFashion": "Shopping & mode",
      "questionnaire.affinities.festivalsEvents": "Festivals & événements",
      "questionnaire.affinities.modernArchitecture": "Architecture moderne",
      "questionnaire.affinities.templesSpirituality": "Temples & spiritualité",
      "questionnaire.affinities.amusementParks": "Parcs d'attractions",
      "questionnaire.affinities.divingSnorkeling": "Plongée & snorkeling",
      "questionnaire.affinities.roadTripFreedom": "Road trip & liberté",
      "questionnaire.affinities.vineyardsWine": "Vignobles & œnotourisme",
      "questionnaire.affinities.desertsLunar": "Déserts & paysages lunaires",
      "questionnaire.affinities.islandsArchipelagos": "Îles & archipels",
      "questionnaire.affinities.photography": "Photographie",
      "questionnaire.affinities.artMuseums": "Art & musées",
      "questionnaire.affinities.waterSports": "Sports nautiques",
      "questionnaire.affinities.fishing": "Pêche",
      "questionnaire.affinities.spasThermal": "Spas & thermalisme",
      "questionnaire.affinities.cruises": "Croisières",
      "questionnaire.affinities.localMarkets": "Marchés locaux",

      // Travel ambiance
      "questionnaire.ambiance.title": "Ambiance souhaitée ? 🎨",
      "questionnaire.ambiance.description": "Type de voyage",
      "questionnaire.ambiance.adventureExotic": "Aventure & dépaysement",
      "questionnaire.ambiance.adventureExotic.desc": "Sortir de ma zone de confort",
      "questionnaire.ambiance.relaxation": "Détente & relaxation",
      "questionnaire.ambiance.relaxation.desc": "Me ressourcer totalement",
      "questionnaire.ambiance.romanceIntimacy": "Romance & intimité",
      "questionnaire.ambiance.romanceIntimacy.desc": "Moments à deux",
      "questionnaire.ambiance.culturalDiscovery": "Découverte culturelle",
      "questionnaire.ambiance.culturalDiscovery.desc": "Apprendre et m'enrichir",
      "questionnaire.ambiance.partyNightlife": "Fête & vie nocturne",
      "questionnaire.ambiance.partyNightlife.desc": "Faire la fête",
      "questionnaire.ambiance.familyConviviality": "Famille & convivialité",
      "questionnaire.ambiance.familyConviviality.desc": "Moments en famille",

      // Dates
      "questionnaire.dates.title": "Dates de voyage ? 📅",
      "questionnaire.dates.description": "Dates fixes ou flexibles",
      "questionnaire.dates.fixed": "Dates fixes",
      "questionnaire.dates.flexible": "Je suis flexible",
      "questionnaire.dates.selectDates": "Sélectionner les dates 🗓️",
      "questionnaire.dates.selectDates.description": "Date de départ puis de retour",
      "questionnaire.dates.selectRange": "Clique et fais glisser pour sélectionner une plage de dates",
      "questionnaire.dates.selected": "Dates sélectionnées :",
      "questionnaire.dates.departure": "Départ :",
      "questionnaire.dates.return": "Retour :",
      "questionnaire.dates.nights": "nuits",
      "questionnaire.dates.reset": "Réinitialiser les dates",
      "questionnaire.dates.pickDeparture": "Sélectionne ta date de départ",
      "questionnaire.dates.pickReturn": "Maintenant, sélectionne ta date de retour",
      "questionnaire.dates.selectedMsg": "Dates sélectionnées !",

      // Flexibility
      "questionnaire.flexibility.title": "Flexibilité des dates ? ⏰",
      "questionnaire.flexibility.description": "Décalage possible pour meilleurs prix",
      "questionnaire.flexibility.souplesse": "Quelle souplesse ? 🔄",
      "questionnaire.flexibility.0days": "±1j",
      "questionnaire.flexibility.3days": "±3j",
      "questionnaire.flexibility.7days": "±7j",
      "questionnaire.flexibility.14days": "±14j",
      "questionnaire.flexibility.30days": "±30j",
      "questionnaire.flexibility.week": "±1 semaine",
      "questionnaire.flexibility.2weeks": "±2 semaines",
      "questionnaire.flexibility.month": "±1 mois",
      "questionnaire.flexibility.hasApproxDate": "Départ approximatif ? 📅",
      "questionnaire.flexibility.hasApproxDate.description": "Avez-vous une idée du moment ?",
      "questionnaire.flexibility.hasApproxDate.yes": "Oui, j'ai une idée",
      "questionnaire.flexibility.hasApproxDate.no": "Non, pas encore",
      "questionnaire.flexibility.approxDate": "Quelle est ta date de départ approximative ? 📆",
      "questionnaire.flexibility.clickDate":
        "Clique sur une date (cette date servira de référence pour ta flexibilité)",
      "questionnaire.flexibility.dateSelected": "Date sélectionnée :",
      "questionnaire.dates.clickInstruction": "Clique sur ta date de départ puis sur ta date de retour ✈️",
      "questionnaire.dates.duration": "Durée du séjour :",
      "questionnaire.dates.days": "jours",

      // Duration
      "questionnaire.duration.title": "Durée du voyage ? 🌙",
      "questionnaire.duration.description": "Nombre de nuits",
      "questionnaire.duration.2nights": "2 nuits",
      "questionnaire.duration.3nights": "3 nuits",
      "questionnaire.duration.4nights": "4 nuits",
      "questionnaire.duration.5nights": "5 nuits",
      "questionnaire.duration.6nights": "6 nuits",
      "questionnaire.duration.7nights": "7 nuits",
      "questionnaire.duration.8to10": "8-10 nuits",
      "questionnaire.duration.11to14": "11-14 nuits",
      "questionnaire.duration.more14": ">14 nuits",
      "questionnaire.duration.exactNights": "Nombre exact de nuits ? 🌉",
      "questionnaire.duration.exactNights.description": "Minimum 15 nuits",
      "questionnaire.duration.specify8to10": "Précise le nombre de nuits 🛏️",
      "questionnaire.duration.specify8to10.description": "Choisis entre 8, 9 ou 10 nuits",
      "questionnaire.duration.specify11to14": "Précise le nombre de nuits 🛏️",
      "questionnaire.duration.specify11to14.description": "Choisis entre 11, 12, 13 ou 14 nuits",
      "questionnaire.duration.8nights": "8 nuits",
      "questionnaire.duration.9nights": "9 nuits",
      "questionnaire.duration.10nights": "10 nuits",
      "questionnaire.duration.11nights": "11 nuits",
      "questionnaire.duration.12nights": "12 nuits",
      "questionnaire.duration.13nights": "13 nuits",
      "questionnaire.duration.14nights": "14 nuits",

      // Budget
      "questionnaire.budget.title": "Budget par personne ? 💰",
      "questionnaire.budget.description": "Budget total hors achats personnels",
      "questionnaire.budget.sliderDescription": "Déplace le curseur pour définir ton budget par personne",
      "questionnaire.budget.perPerson": "par personne",
      "questionnaire.budget.excluding": "Hors achats personnels",
      "questionnaire.budget.less300": "<300€",
      "questionnaire.budget.300to600": "300-600€",
      "questionnaire.budget.600to900": "600-900€",
      "questionnaire.budget.900to1200": "900-1 200€",
      "questionnaire.budget.1200to1800": "1 200-1 800€",
      "questionnaire.budget.more1800": ">1 800€",
      "questionnaire.budget.dontKnow": "Je ne sais pas",
      "questionnaire.budget.precise": "Budget précis",
      "questionnaire.budget.totalBudget": "Budget exact ? 💵",
      "questionnaire.budget.totalBudget.description": "Par personne pour l'ensemble du voyage",
      "questionnaire.budget.entireTrip": "Pour l'ensemble du voyage",
      "questionnaire.budget.amount": "Montant",
      "questionnaire.budget.currency": "Devise",
      "questionnaire.budget.enterPrecise": "Saisir un budget précis",
      "questionnaire.budget.backToSlider": "Retour au curseur",

      // Travel styles
      "questionnaire.styles.title": "Centres d'intérêt activités ? 🎨",
      "questionnaire.styles.description": "Sélectionnez jusqu'à 5 options",
      "questionnaire.styles.selectUpTo5": "Sélectionne jusqu'à 5 styles",
      "questionnaire.styles.nature": "Nature",
      "questionnaire.styles.cultureMuseums": "Culture & musées",
      "questionnaire.styles.food": "Food",
      "questionnaire.styles.beach": "Plage",
      "questionnaire.styles.mountainHiking": "Montagne & rando",
      "questionnaire.styles.photoSpots": "Photo spots",
      "questionnaire.styles.localMarkets": "Vie locale & marchés",
      "questionnaire.styles.sportOutdoor": "Sport & outdoor",
      "questionnaire.styles.wellnessSpa": "Bien-être & spa",
      "questionnaire.styles.nightlife": "Vie nocturne",

      // Rhythm
      "questionnaire.rhythm.title": "Rythme souhaité ? ⏱️",
      "questionnaire.rhythm.description": "Activités par jour",
      "questionnaire.rhythm.selectRhythm": "Sélectionne ton rythme",
      "questionnaire.rhythm.cool": "Cool",
      "questionnaire.rhythm.cool.desc": "1-2 activités/jour",
      "questionnaire.rhythm.relaxed": "Détendu",
      "questionnaire.rhythm.relaxed.desc": "1-2 activités/jour",
      "questionnaire.rhythm.balanced": "Équilibré",
      "questionnaire.rhythm.balanced.desc": "2-3 activités/jour",
      "questionnaire.rhythm.intense": "Intense",
      "questionnaire.rhythm.intense.desc": "3+ activités/jour",

      // Schedule preferences
      "questionnaire.optional": "Optionnel",
      "questionnaire.schedule.title": "Préférences horaires",
      "questionnaire.schedule.description": "Sélectionne jusqu’à 3 options",
      "questionnaire.schedule.maxReached": "Maximum 3 préférences",
      "questionnaire.schedule.earlyBird": "Matinal",
      "questionnaire.schedule.nightOwl": "Couche-tard",
      "questionnaire.schedule.needsSiesta": "Sieste nécessaire",
      "questionnaire.schedule.needsBreaks": "Besoin de pauses",
      "questionnaire.schedule.needsFreeTime": "Besoin de temps libre",
      "questionnaire.schedule.flexibleSchedule": "Horaires flexibles",

      // Flights
      "questionnaire.flights.title": "Préférence vols ? ✈️",
      "questionnaire.flights.description": "Direct ou avec escales",
      "questionnaire.flights.directOnly": "Direct uniquement",
      "questionnaire.flights.max1Stop": "Max 1 escale",
      "questionnaire.flights.dontMind": "Peu importe",

      // Luggage
      "questionnaire.luggage.title": "Bagages par voyageur ? 🧳",
      "questionnaire.luggage.description": "Impacte le prix des vols",
      "questionnaire.luggage.travelers": "voyageur",
      "questionnaire.luggage.travelers_plural": "voyageurs",
      "questionnaire.luggage.traveler": "Voyageur",
      "questionnaire.luggage.personalItem": "Objet personnel uniquement",
      "questionnaire.luggage.cabin": "Bagage cabine uniquement",
      "questionnaire.luggage.hold": "Bagage soute uniquement",
      "questionnaire.luggage.cabinHold": "Cabine + Soute",

      // Mobility
      "questionnaire.mobility.title": "Mobilité ? 🚶",
      "questionnaire.mobility.description": "Modes de transport sur place",
      "questionnaire.mobility.selectMultiple": "Sélection multiple possible",
      "questionnaire.mobility.publicTransport": "Transports en commun",
      "questionnaire.mobility.rentalCar": "Voiture de location",
      "questionnaire.mobility.taxi": "Taxi/VTC",
      "questionnaire.mobility.bike": "Vélo",
      "questionnaire.mobility.atypical": "Transport atypique",
      "questionnaire.mobility.atypical.desc": "Tuk-tuk, scooter, etc.",
      "questionnaire.mobility.ferry": "Bateau/ferry",
      "questionnaire.mobility.incompleteSelection": "Sélection incomplète",
      "questionnaire.mobility.selectOtherTransport":
        "Sélectionne au moins un autre mode de transport en plus du transport atypique ou bateau/ferry.",

      // Accommodation type
      "questionnaire.accommodationType.title": "Type d'hébergement ? 🏨",
      "questionnaire.accommodationType.description": "Sélectionnez 1 ou 2 types",
      "questionnaire.accommodationType.select1or2": "Sélectionnez 1 ou 2 types",
      "questionnaire.accommodationType.hotel": "Hôtel",
      "questionnaire.accommodationType.apartment": "Appartement",
      "questionnaire.accommodationType.villa": "Villa",
      "questionnaire.accommodationType.chalet": "Chalet",
      "questionnaire.accommodationType.condominium": "Condominium",
      "questionnaire.accommodationType.hostel": "Auberge",
      "questionnaire.accommodationType.guesthouse": "Maison d'hôtes/riad",
      "questionnaire.accommodationType.lodge": "Lodge/eco-stay",
      "questionnaire.accommodationType.camping": "Camping/glamping",
      "questionnaire.accommodationType.bedBreakfast": "Chambre d'hôtes",
      "questionnaire.accommodationType.resort": "Resort",
      "questionnaire.accommodationType.dontMind": "Peu importe",

      // Hotel preferences
      "questionnaire.hotelPreferences.title": "Préférences hôtel ? 🏨",
      "questionnaire.hotelPreferences.description": "Services et équipements",
      "questionnaire.hotelPreferences.selectInterested": "Sélectionne ce qui t'intéresse",
      "questionnaire.hotelPreferences.dontMind": "Peu importe",
      "questionnaire.hotelPreferences.breakfast": "Petit-déjeuner inclus",
      "questionnaire.hotelPreferences.halfBoard": "Demi-pension",
      "questionnaire.hotelPreferences.fullBoard": "Pension complète",
      "questionnaire.hotelPreferences.allInclusive": "All-inclusive",
      "questionnaire.hotelPreferences.roomService": "Room service",
      "questionnaire.hotelPreferences.minibar": "Minibar",
      "questionnaire.hotelPreferences.view": "Vue mer/montagne",
      "questionnaire.hotelPreferences.balcony": "Balcon/terrasse",
      "questionnaire.hotelPreferences.concierge": "Service de conciergerie",

      // Comfort
      "questionnaire.comfort.title": "Confort minimum ? ⭐",
      "questionnaire.comfort.description": "Note minimale souhaitée",
      "questionnaire.comfort.rating75": "Note ≥7.5",
      "questionnaire.comfort.rating80": "Note ≥8.0",
      "questionnaire.comfort.rating85": "Note ≥8.5",
      "questionnaire.comfort.dontMind": "Peu importe",

      // Neighborhood
      "questionnaire.neighborhood.title": "Quartier préféré ? 🗺️",
      "questionnaire.neighborhood.description": "Type d'emplacement",
      "questionnaire.neighborhood.quiet": "Calme",
      "questionnaire.neighborhood.centralLively": "Central & animé",
      "questionnaire.neighborhood.nearNatureBeach": "Proche nature/plage",
      "questionnaire.neighborhood.atypicalCharm": "Atypique/charme local",

      // Amenities
      "questionnaire.amenities.title": "Équipements souhaités ? 🛠️",
      "questionnaire.amenities.description": "Choix multiples possibles",
      "questionnaire.amenities.selectAll": "Sélectionne tous ceux qui t'importent",
      "questionnaire.amenities.dontMind": "Peu importe",
      "questionnaire.amenities.reliableWifi": "Wi-Fi fiable",
      "questionnaire.amenities.airConditioning": "Climatisation",
      "questionnaire.amenities.kitchen": "Cuisine",
      "questionnaire.amenities.washingMachine": "Machine à laver",
      "questionnaire.amenities.parking": "Parking",
      "questionnaire.amenities.elevator": "Ascenseur",
      "questionnaire.amenities.reception24": "Réception 24/7",
      "questionnaire.amenities.babyCrib": "Lit bébé",
      "questionnaire.amenities.familyRoom": "Chambre famille",
      "questionnaire.amenities.pool": "Piscine",
      "questionnaire.amenities.gym": "Salle de sport",
      "questionnaire.amenities.spa": "Spa/jacuzzi",
      "questionnaire.amenities.gardenTerrace": "Jardin/terrasse",

      // Children details (for family)
      "questionnaire.children.title": "Détails sur les enfants 👶",
      "questionnaire.children.description": "Pour mieux adapter l'itinéraire",
      "questionnaire.children.howMany": "Combien d'enfants parmi les voyageurs ?",
      "questionnaire.children.child": "Enfant",
      "questionnaire.children.age": "Âge",
      "questionnaire.children.years": "an(s)",
      "questionnaire.children.addChild": "+ Ajouter un enfant",
      "questionnaire.children.removeChild": "Retirer",

      // Security & Safety
      "questionnaire.security.title": "Sécurité & Phobies 🛡️",
      "questionnaire.security.description": "Pour éviter des situations inconfortables",
      "questionnaire.security.selectAll": "Sélectionne ce qui s'applique",
      "questionnaire.security.none": "Aucune contrainte particulière",
      "questionnaire.security.crowds": "Éviter les foules",
      "questionnaire.security.heights": "Peur du vide/hauteurs",
      "questionnaire.security.tunnels": "Phobie des tunnels",
      "questionnaire.security.water": "Peur de l'eau/nager",
      "questionnaire.security.animals": "Peur de certains animaux",
      "questionnaire.security.darkness": "Peur du noir/espaces clos",
      "questionnaire.security.unsafeAreas": "Éviter zones peu sûres",
      "questionnaire.security.extremeActivities": "Pas d'activités extrêmes",

      // Biological clock & Habits
      "questionnaire.biorhythm.title": "Horloge biologique & Habitudes 🕐",
      "questionnaire.biorhythm.description": "Pour un rythme qui te correspond",
      "questionnaire.biorhythm.selectAll": "Sélectionne ce qui te correspond",
      "questionnaire.biorhythm.earlyBird": "Lève-tôt (matin actif)",
      "questionnaire.biorhythm.nightOwl": "Couche-tard (nuit tardive)",
      "questionnaire.biorhythm.naps": "Besoin de siestes",
      "questionnaire.biorhythm.dailyFreeTime": "Temps libre quotidien indispensable",
      "questionnaire.biorhythm.earlyTolerant": "Tolérant aux réveils matinaux",
      "questionnaire.biorhythm.regularMeals": "Repas à heures régulières",
      "questionnaire.biorhythm.flexible": "Flexible, je m'adapte",

      // Constraints
      "questionnaire.constraints.title": "Des contraintes ? 🎯",
      "questionnaire.constraints.description": "Alimentaires, religieuses, accessibilité",
      "questionnaire.constraints.selectAllImportant": "Sélectionne toutes les options importantes",
      "questionnaire.constraints.halal": "Halal",
      "questionnaire.constraints.kosher": "Casher",
      "questionnaire.constraints.vegetarian": "Végétarien",
      "questionnaire.constraints.vegan": "Vegan",
      "questionnaire.constraints.glutenFree": "Sans gluten",
      "questionnaire.constraints.noPork": "Sans porc",
      "questionnaire.constraints.noAlcohol": "Sans alcool",
      "questionnaire.constraints.prayerPlaces": "Lieux de prière",
      "questionnaire.constraints.buddhistTraditions": "Respect traditions bouddhistes",
      "questionnaire.constraints.accessibility": "Accessibilité PMR",
      "questionnaire.constraints.safezones": "Zones sûres",
      "questionnaire.constraints.avoidCar": "Éviter voiture",
      "questionnaire.constraints.localTraditions": "Respect traditions locales",
      "questionnaire.constraints.foodAllergies": "Allergies alimentaires",
      "questionnaire.constraints.dontMind": "Peu importe",

      // Additional info
      "questionnaire.additionalInfo.title": "Infos complémentaires ? 💬",
      "questionnaire.additionalInfo.description": "Précisions importantes à respecter (optionnel)",
      "questionnaire.additionalInfo.descriptionExtended": "Ex : éviter escales, allergies, événement spécial",
      "questionnaire.additionalInfo.optional": "Zone libre (optionnel)",
      "questionnaire.additionalInfo.placeholder": "Partage tes besoins spécifiques...",
      "questionnaire.additionalInfo.skip": "Passer",
      "questionnaire.additionalInfo.characters": "caractères",

      // Email step
      "questionnaire.email.title": "Recevoir mon itinéraire 📧",
      "questionnaire.email.description": "Nous t'enverrons ton itinéraire personnalisé sous 48h",
      "questionnaire.email.placeholder": "ton@email.com",
      "questionnaire.email.send": "Envoyer 🚀",
      "questionnaire.email.sending": "Envoi en cours...",

      // Trip Details page
      "tripDetails.notFound": "Voyage non trouvé",
      "tripDetails.backToTrip": "Retour au voyage",
      "tripDetails.preBookingInfo": "Informations pré-réservation",
      "tripDetails.tripSummary": "Récapitulatif du voyage",
      "tripDetails.days": "jours",
      "tripDetails.travelers": "voyageurs",
      "tripDetails.duration": "Durée",
      "tripDetails.travelersLabel": "Voyageurs",
      "tripDetails.activities": "Activités",
      "tripDetails.totalPrice": "Prix total",
      "tripDetails.included": "Inclus dans le voyage",
      "tripDetails.excluded": "Non inclus",
      "tripDetails.responsibilities": "Responsabilités & Organisation",
      "tripDetails.organizer": "Organisateur du voyage",
      "tripDetails.organizerDesc": "Travliaq SAS agit en qualité d'organisateur de voyage au sens de la directive européenne 2015/2302. À ce titre, nous sommes responsables de la bonne exécution de l'ensemble des prestations incluses dans votre forfait.",
      "tripDetails.globalResponsibility": "Responsabilité globale du séjour",
      "tripDetails.globalResponsibilityDesc": "En cas de problème avec un prestataire (hôtel, compagnie aérienne, etc.), vous vous adressez directement à Travliaq. Nous gérons les réclamations et assurons la coordination avec tous les partenaires.",
      "tripDetails.cancellation": "Politique d'annulation",
      "tripDetails.noRefundPolicy": "Aucun remboursement en cas d'annulation",
      "tripDetails.noRefundDesc": "Les réservations sont fermes et définitives. Aucun remboursement ne sera effectué en cas d'annulation, quelle que soit la raison ou le délai avant le départ.",
      "tripDetails.insuranceRecommendation": "Nous vous recommandons fortement de souscrire une assurance voyage annulation auprès de votre assureur pour vous protéger contre les imprévus.",
      "tripDetails.guarantees": "Garanties & Protections",
      "tripDetails.insolvencyGuarantee": "Garantie contre l'insolvabilité",
      "tripDetails.insolvencyGuaranteeDesc": "Conformément à la réglementation européenne, Travliaq dispose d'une garantie financière qui assure le remboursement des sommes versées et le rapatriement des voyageurs en cas de défaillance de l'entreprise.",
      "tripDetails.rcProInsurance": "Assurance Responsabilité Civile Professionnelle",
      "tripDetails.rcProInsuranceDesc": "Travliaq est couvert par une assurance RC Pro spécifique au secteur du voyage, couvrant les dommages pouvant survenir dans le cadre de l'organisation de votre séjour.",
      "tripDetails.acceptTerms": "J'ai lu et j'accepte les",
      "tripDetails.termsLink": "Conditions Générales de Vente",
      "tripDetails.acceptTerms2": "ainsi que les informations relatives aux responsabilités et garanties détaillées ci-dessus.",
      "tripDetails.proceedToBooking": "Procéder à la réservation",
      "tripDetails.footerNote": "Conformément à la directive européenne 2015/2302 relative aux voyages à forfait, vous bénéficiez de l'ensemble des droits prévus pour les consommateurs.",

      // Travel Co-Pilot
      "copilot.pageTitle": "Travel Co-Pilot",
      "copilot.pageDescription": "Planifiez votre voyage avec notre assistant IA intelligent",
      "copilot.title": "Travel Co-Pilot",
      "copilot.subtitle": "Votre assistant voyage IA",
      "copilot.welcome": "Bonjour ! 👋 Je suis votre co-pilote de voyage. Dites-moi où vous souhaitez aller et je vous aiderai à planifier votre voyage parfait.",
      "copilot.thinking": "Je réfléchis...",
      "copilot.inputPlaceholder": "Dites-moi vos envies de voyage...",
      "copilot.quickDestination": "Je veux partir à...",
      "copilot.quickDates": "Mes dates de voyage",
      "copilot.tabs.flights": "Vols",
      "copilot.tabs.hotels": "Hébergements",
      "copilot.tabs.activities": "Activités",
      "copilot.tabs.trip": "Mon Voyage",
      "copilot.panel.flights": "Vols disponibles",
      "copilot.panel.hotels": "Hébergements",
      "copilot.panel.activities": "Activités & Expériences",
      "copilot.panel.trip": "Récapitulatif du voyage",
      "copilot.noFlights": "Dites-moi votre destination pour voir les vols",
      "copilot.noHotels": "Sélectionnez une destination pour voir les hôtels",
      "copilot.noActivities": "Explorez les activités après avoir choisi votre destination",
      "copilot.noTrip": "Votre itinéraire apparaîtra ici",
      "copilot.direct": "Vol direct",
      "copilot.stops": "escale(s)",
      "copilot.selectedAirport": "Aéroport sélectionné",
      "copilot.selectedDates": "Dates sélectionnées",
      "copilot.response.destination": "Super choix ! 🗽 La carte affiche maintenant New York. D'où souhaitez-vous partir ?",
      "copilot.response.hotels": "Voici les hôtels disponibles à Manhattan. Cliquez sur un marqueur sur la carte ou dans la liste pour voir les détails.",
      "copilot.response.activities": "Voici des activités populaires ! Les spectacles de Broadway, la Statue de la Liberté et Central Park sont incontournables.",
      "copilot.response.dates": "Parfait ! Sélectionnez vos dates de voyage :",
      "copilot.response.generic": "Je vous écoute ! Dites-moi votre destination, vos dates ou ce que vous recherchez comme hébergement ou activités.",
      "copilot.response.airportSelected": "Parfait, départ depuis {{airport}} ! Je recherche les meilleurs vols pour vous.",
      "copilot.response.datesSelected": "Dates enregistrées ! Je mets à jour les disponibilités pour ces dates.",

      // Planner Chat translations
      "planner.welcome": "Bonjour ! 👋 Je suis votre assistant voyage. Où souhaitez-vous partir ?",
      "planner.askDestination": "Où souhaitez-vous aller ?",
      "planner.askDates": "Quand souhaitez-vous partir ?",
      "planner.askTravelers": "Combien êtes-vous à voyager ?",
      "planner.askDeparture": "D'où partez-vous ?",
      "planner.confirmTrip": "Parfait ! Récapitulatif de votre voyage :",
      "planner.countryDetected": "{{country}} est une destination fascinante ! Voici les principales villes :",
      "planner.datesConfirmed": "Parfait ! Dates enregistrées.",
      "planner.travelersConfirmed": "Super ! Voyageurs configurés.",
      "planner.searchReady": "Tout est prêt ! Cliquez pour lancer la recherche. 🚀",
      "planner.chooseForMe": "Choisis pour moi",
      "planner.travelers": "{{count}} voyageur",
      "planner.travelers_plural": "{{count}} voyageurs",
      "planner.departure": "Départ",
      "planner.return": "Retour",
      "planner.roundtrip": "Aller-retour",
      "planner.oneway": "Aller simple",
      "planner.adults": "adulte",
      "planner.adults_plural": "adultes",
      "planner.children": "enfant",
      "planner.children_plural": "enfants",
      "planner.infants": "bébé",
      "planner.infants_plural": "bébés",
      "planner.selectCity": "Sélectionnez une ville",
      "planner.selectDates": "Sélectionnez vos dates",
      "planner.selectTravelers": "Indiquez les voyageurs",
      "planner.launchSearch": "Lancer la recherche",
      "planner.searchFlights": "Rechercher les vols maintenant",
      "planner.modifySearch": "Modifier la recherche",
      "planner.inspireMe": "Inspirez-moi !",
      "planner.newConversation": "Nouvelle conversation",
      "planner.history": "Historique",
      "planner.inputPlaceholder": "Décrivez votre voyage idéal...",
      "planner.closeChat": "Fermer le chat",
      // Error messages
      "planner.error.generic": "Désolé, une erreur s'est produite. Veuillez réessayer.",
      "planner.error.noResponse": "Désolé, je n'ai pas pu répondre.",
      "planner.error.noDestinations": "Désolé, je n'ai pas pu trouver de destinations correspondant à vos critères. Essayez d'abord de me donner vos préférences de voyage avec 'Inspire-moi !' 🌍",
      "planner.error.destinationSearch": "Une erreur est survenue lors de la recherche de destinations. Veuillez réessayer.",
      "planner.error.citySearch": "Une erreur est survenue lors de la recherche des villes.",
      // Inspire flow messages
      "planner.inspire.title1": "✨ **Parfait, laissez-moi vous inspirer !**\n\nPour créer un voyage qui vous ressemble, commençons par découvrir votre style de voyage. Choisissez ce qui vous correspond le mieux :",
      "planner.inspire.title2": "🌍 **L'aventure commence ici !**\n\nPour vous proposer des destinations uniques, j'ai besoin de mieux vous connaître. Quel type de voyageur êtes-vous ?",
      "planner.inspire.title3": "🎯 **Trouvons votre voyage idéal !**\n\nVotre prochain voyage sera à votre image. Indiquez-moi votre style pour des suggestions personnalisées :",
      "planner.inspire.title4": "💫 **Créons ensemble votre prochaine escapade !**\n\nChaque voyageur est unique. Partagez vos préférences pour que je puisse vous proposer des expériences sur mesure :",
      "planner.inspire.title5": "🗺️ **Prêt pour l'inspiration ?**\n\nPour vous guider vers la destination parfaite, dites-moi d'abord quel type d'expérience vous recherchez :",
      // Destination selection
      "planner.destination.found": "Voici {{count}} destination parfaite pour vous, basée sur votre profil ({{score}}% de complétion) :",
      "planner.destination.found_plural": "Voici {{count}} destinations parfaites pour vous, basées sur votre profil ({{score}}% de complétion) :",
      "planner.destination.excellent": "Excellent choix ! **{{country}}** est une destination parfaite pour vous.",
      "planner.destination.searchingCities": "Je recherche les villes principales...",
      "planner.destination.whichCity": "Quelle ville souhaitez-vous visiter ?",
      "planner.destination.typeCity": "Quelle ville souhaitez-vous visiter ? Tapez le nom dans le chat.",
      // Trip summary
      "planner.trip.configured": "Super ! Votre voyage **{{from}} → {{to}}** est configuré :",
      "planner.trip.ready": "Parfait ! Votre itinéraire **{{from}} → {{to}}** est prêt !",
      "planner.trip.selectAirports": "Sélectionnez vos aéroports ci-dessous :",
      "planner.trip.selectAirportsPanel": "Veuillez sélectionner vos aéroports dans le panneau de droite.",
      // Widgets
      "planner.widget.selectDepartureDate": "Choisir la date de départ",
      "planner.widget.selectReturnDate": "Choisir la date de retour",
      "planner.widget.selectInterests": "Sélectionnez vos centres d'intérêt :",
      "planner.widget.adjustStyle": "Ajustez votre style de voyage :",
      // Quick suggestions
      "planner.suggestion.noMore": "Rien d'autre à ajouter. Fais-moi 3 recommandations de destinations selon mon profil.",
      "planner.suggestion.specifyInterests": "J'aimerais préciser mes centres d'intérêt.",
      "planner.suggestion.adjustStyle": "J'aimerais ajuster mon style de voyage.",
      "planner.suggestion.mustHaves": "J'ai des critères obligatoires à préciser.",
      "planner.suggestion.dietary": "J'ai des restrictions alimentaires à préciser.",
      "planner.suggestion.chooseForMe": "Choisis la meilleure destination pour moi parmi celles affichées et explique pourquoi.",
      "planner.suggestion.nothingElse": "Rien d'autre, suggérer !",
      // Preference flow messages
      "planner.preference.styleTitle": "Votre style de voyage",
      "planner.preference.continue": "Continuer",
      "planner.preference.selectInterests": "Maintenant, sélectionnez vos centres d'intérêt :",
      "planner.preference.anythingElse": "Avez-vous autre chose à signaler ? (critères obligatoires, restrictions alimentaires...)",
      "planner.preference.afterMustHaves": "Parfait ! Autre chose à signaler ?",
      "planner.preference.searchingDestinations": "Je recherche les meilleures destinations pour vous...",
      "planner.preference.mustHavesConfigured": "Critères obligatoires configurés",
      "planner.preference.dietaryConfigured": "Restrictions alimentaires : {{restrictions}}",
      "planner.preference.selectUpTo": "Sélectionnez jusqu'à {{max}}",
      // Style axes labels
      "planner.style.chill": "Détente",
      "planner.style.intense": "Intense",
      "planner.style.urban": "Urbain",
      "planner.style.nature": "Nature",
      "planner.style.budget": "Économique",
      "planner.style.luxury": "Luxe",
      "planner.style.tourist": "Touristique",
      "planner.style.authentic": "Authentique",
      // Interests labels
      "planner.interest.culture": "Culture",
      "planner.interest.food": "Gastronomie",
      "planner.interest.nature": "Nature",
      "planner.interest.beach": "Plage",
      "planner.interest.wellness": "Bien-être",
      "planner.interest.sport": "Sport",
      "planner.interest.adventure": "Aventure",
      "planner.interest.nightlife": "Sorties",
      "planner.interest.shopping": "Shopping",
      "planner.interest.history": "Histoire",
      // Must-haves labels
      "planner.mustHaves.title": "Critères obligatoires",
      "planner.mustHaves.selected": "{{count}} sélectionné",
      "planner.mustHaves.selected_plural": "{{count}} sélectionnés",
      "planner.mustHaves.accessibility": "Accessibilité PMR",
      "planner.mustHaves.petFriendly": "Animaux acceptés",
      "planner.mustHaves.familyFriendly": "Adapté aux familles",
      "planner.mustHaves.highSpeedWifi": "WiFi rapide",
      // Dietary labels
      "planner.dietary.title": "Restrictions alimentaires",
      "planner.dietary.selected": "{{count}} sélectionnée",
      "planner.dietary.selected_plural": "{{count}} sélectionnées",
      // Date picker
      "planner.datePicker.departure": "Départ",
      "planner.datePicker.return": "Retour",
      "planner.datePicker.confirm": "Confirmer",
      "planner.datePicker.selectedDate": "Date sélectionnée",
      // Travelers widget
      "planner.travelers.title": "Voyageurs",
      "planner.travelers.adults": "Adultes",
      "planner.travelers.children": "Enfants",
      "planner.travelers.infants": "Bébés",
      "planner.travelers.confirm": "Confirmer",
      "planner.travelers.solo": "Je voyage seul(e)",
      "planner.travelers.edit": "Modifier le nombre de voyageurs",
      // City selection
      "planner.city.recommended": "Meilleur choix",
      "planner.city.otherDestinations": "Autres destinations",
      "planner.city.selected": "Ville sélectionnée",
      // Destination suggestions
      "planner.destinations.loading": "Je recherche les meilleures destinations selon votre profil...",
      "planner.destinations.swipeHint": "Glissez pour voir plus",
      "planner.destinations.noResults": "Aucune destination trouvée. Essayez d'ajuster vos préférences.",
      "planner.destinations.profileBased": "Basé sur {{score}}% de votre profil",
      "planner.destinations.select": "Sélectionner",
      "planner.destinations.limitExceeded": "Je ne peux afficher que 5 destinations maximum, mais voici mes {{count}} meilleures recommandations pour vous...",
      "planner.destinations.searching": "Je recherche {{count}} destinations parfaites pour vous...",
      // Additional travelers widget keys
      "planner.travelers.countTitle": "Nombre de voyageurs",
      "planner.travelers.editTitle": "Modifier le nombre de voyageurs",
      "planner.travelers.adultsDesc": "12 ans et +",
      "planner.travelers.childrenDesc": "2-11 ans",
      "planner.travelers.infantsDesc": "Moins de 2 ans",
      "planner.travelers.confirmCount": "Confirmer ({{count}} voyageur)",
      "planner.travelers.confirmCount_plural": "Confirmer ({{count}} voyageurs)",
      "planner.travelers.soloQuestion": "Vous partez seul(e) ?",
      "planner.travelers.yesSolo": "Oui, je pars seul(e)",
      "planner.travelers.noEdit": "Non, modifier",
      // City selection additional keys
      "planner.city.loadingCities": "Chargement des villes...",
      "planner.city.chooseIn": "Choisir une ville en {{country}}",
      "planner.city.recommendedLabel": "Recommandée",
      "planner.city.bestChoice": "Meilleur choix",
      "planner.city.popularDestination": "Destination la plus populaire et mieux desservie",
      // Date picker additional keys
      "planner.datePicker.weekdays": "Lu,Ma,Me,Je,Ve,Sa,Di",
      "planner.datePicker.selectDeparture": "Sélectionnez le départ",
      "planner.datePicker.selectReturn": "Sélectionnez le retour",
      "planner.datePicker.selectDate": "Sélectionnez une date",
      "planner.datePicker.confirmDate": "Confirmer : {{date}}",
      "planner.datePicker.confirmRange": "Confirmer : {{start}} → {{end}}",
      "planner.datePicker.selectReturnDate": "Sélectionnez la date de retour",
      "planner.datePicker.selectDepartureDate": "Sélectionnez la date de départ",
      // Top bar tabs
      "planner.tabs.flights": "Vols",
      "planner.tabs.stays": "Hébergements",
      "planner.tabs.activities": "Activités",
      "planner.tabs.preferences": "Préférences",
      "planner.tabs.backToHome": "Retour à l'accueil",
      "planner.tabs.openChat": "Ouvrir le chat",
      "planner.tabs.leaveConfirm": "Quitter le planner ?",
      "planner.myTrip": "Mon Voyage",
      // Step suggestions
      "planner.step.selectDestination": "Commençons par choisir votre destination",
      "planner.step.selectDates": "Parfait ! Maintenant, sélectionnons vos dates de voyage",
      "planner.step.selectTravelers": "Combien de voyageurs serez-vous ?",
      "planner.step.searchFlights": "Tout est prêt ! Recherchons les meilleurs vols",
      "planner.step.selectHotel": "Vol sélectionné ! Trouvons maintenant un hébergement",
      "planner.step.selectActivities": "Excellent choix ! Ajoutons des activités à votre séjour",
      "planner.step.tripComplete": "Votre voyage est prêt ! Voici le récapitulatif",
      "planner.step.buttonDestination": "Choisir une destination",
      "planner.step.buttonDates": "Choisir les dates",
      "planner.step.buttonTravelers": "Indiquer les voyageurs",
      "planner.step.buttonSearch": "Rechercher les vols",
      "planner.step.buttonHotel": "Voir les hôtels",
      "planner.step.buttonActivities": "Découvrir les activités",
      "planner.step.buttonSummary": "Voir le récapitulatif",
      // Chat UI labels
      "planner.chat.newConversation": "Nouvelle conversation",
      "planner.chat.history": "Historique",
      "planner.chat.closeChat": "Fermer le chat",
      "planner.chat.inputPlaceholder": "Envoyer un message...",
      "planner.chat.inputLoading": "Réponse en cours...",
      "planner.chat.inputHelper": "Tapez une destination ou demandez des vols, activités, hébergements",
      "planner.chat.send": "Envoyer",
      "planner.chat.noConversation": "Aucune conversation",
      "planner.chat.creating": "Création...",
      "planner.chat.deleting": "Suppression...",
      "planner.chat.deleteAll": "Tout supprimer",
      "planner.chat.createdToast": "Nouvelle conversation créée",
      "planner.chat.creatingToast": "Création de la conversation...",
      "planner.chat.deletedToast": "Historique supprimé",
      "planner.chat.deletingToast": "Suppression de l'historique...",
      // Dialog labels
      "planner.dialog.deleteTitle": "Supprimer cette conversation ?",
      "planner.dialog.deleteDesc": "Cette action est irréversible. La conversation sera définitivement supprimée.",
      "planner.dialog.newTitle": "Nouvelle conversation ?",
      "planner.dialog.newDesc": "Réinitialiser vols, hébergements, activités et préférences ?",
      "planner.dialog.deleteAllTitle": "Supprimer tout l'historique ?",
      "planner.dialog.deleteAllDesc": "Cette action est irréversible. Toutes les conversations, vols, hébergements et préférences seront définitivement supprimés.",
      "planner.dialog.cancel": "Annuler",
      "planner.dialog.confirm": "Confirmer",
      "planner.dialog.delete": "Supprimer",
      // Quick replies
      "planner.quick.whenToGo": "Quand partir?",
      "planner.quick.howMuch": "Combien ça coûte?",
      
      // ScrollToBottomButton
      "planner.chat.scrollToBottom": "Retour en bas",
      "planner.chat.newMessage": "{{count}} nouveau message",
      "planner.chat.newMessages": "{{count}} nouveaux messages",
      
      // Chat system messages
      "planner.messages.tripConfigured": "Super ! Votre voyage **{{from}} → {{to}}** est configuré :",
      "planner.messages.departureDate": "📅 Départ : {{date}}",
      "planner.messages.returnDate": "📅 Retour : {{date}}",
      "planner.messages.travelers": "👥 {{count}} voyageur",
      "planner.messages.travelersPlural": "👥 {{count}} voyageurs",
      "planner.messages.selectAirports": "Sélectionnez vos aéroports ci-dessous :",
      "planner.messages.selectAirportsPanel": "Veuillez sélectionner vos aéroports dans le panneau de droite.",
      "planner.messages.searchReady": "Parfait ! Votre itinéraire **{{from}} → {{to}}** est prêt !",
      "planner.messages.clickToSearch": "Cliquez ci-dessous pour lancer la recherche. 🚀",
      "planner.messages.destinationsFound": "Voici {{count}} destination parfaite pour vous, basée sur votre profil ({{score}}% de complétion) :",
      "planner.messages.destinationsFoundPlural": "Voici {{count}} destinations parfaites pour vous, basées sur votre profil ({{score}}% de complétion) :",
      "planner.messages.noDestinations": "Désolé, je n'ai pas pu trouver de destinations correspondant à vos critères. Essayez d'ajuster vos préférences.",
      "planner.messages.noDestinationsHint": "Désolé, je n'ai pas pu trouver de destinations correspondant à vos critères. Essayez d'abord de me donner vos préférences de voyage avec 'Inspire-moi !' 🌍",
      "planner.messages.errorDestinations": "Une erreur est survenue lors de la recherche de destinations. Veuillez réessayer.",
      "planner.messages.searchingDestinations": "Je recherche {{count}} destinations parfaites pour vous...",
      "planner.messages.defaultError": "Désolé, je n'ai pas pu répondre.",
      "planner.messages.exceededLimit": "Je ne peux afficher que 5 destinations maximum, mais voici mes {{count}} meilleures recommandations pour vous...",
      
      // FlightRouteBuilder & FlightsPanel
      "planner.flights.searching": "Recherche...",
      "planner.flights.minChars": "Tapez au moins 3 caractères",
      "planner.flights.noResults": "Aucun résultat trouvé",
      "planner.flights.airport": "Aéroport",
      "planner.flights.country": "Pays",
      "planner.flights.city": "Ville",
      "planner.flights.departure": "Départ",
      "planner.flights.destination": "Destination",
      "planner.flights.swapCities": "Inverser départ et destination",
      "planner.flights.outbound": "Aller",
      "planner.flights.inbound": "Retour",
      "planner.flights.date": "Date",
      "planner.flights.closeCalendar": "Fermer le calendrier",
      "planner.flights.addDestination": "Ajouter une destination",
      "planner.flights.roundtrip": "Aller-retour",
      "planner.flights.oneway": "Aller simple",
      "planner.flights.multiCity": "Multi-destinations",
      "planner.flights.passengers": "Passagers & Bagages",
      "planner.flights.addPassenger": "+ Ajouter",
      "planner.flights.adult": "Adulte",
      "planner.flights.child": "Enfant",
      "planner.flights.cabin": "Cabine",
      "planner.flights.hold": "Soute",
        "planner.flights.cabinBag": "Cabine",
        "planner.flights.checkedBag": "Soute",
      "planner.flights.cabinClass": "Classe",
      "planner.flights.economy": "Économique",
      "planner.flights.business": "Affaires",
      "planner.flights.first": "Première",
      "planner.flights.options": "Options",
      "planner.flights.directOnly": "Vols directs uniquement",
      "planner.flights.flexibleDates": "Dates flexibles (±3 jours)",
      "planner.flights.search": "Rechercher",
      "planner.flights.searchingAirports": "Recherche des aéroports...",
      "planner.flights.modify": "Modifier",
      "planner.flights.selected": "vols sélectionnés",
      "planner.flights.bookItinerary": "Réserver l'itinéraire complet",
      "planner.flights.closePanel": "Fermer le panneau",
      
      // FlightResults component
      "planner.flightResults.bestPrice": "Meilleur prix",
      "planner.flightResults.fastest": "Plus rapide",
      "planner.flightResults.lowestCO2": "Moins de CO₂",
      "planner.flightResults.nightLayover": "Escale de nuit",
      "planner.flightResults.direct": "Direct",
      "planner.flightResults.stop": "{{count}} escale",
      "planner.flightResults.stops": "{{count}} escales",
      "planner.flightResults.select": "Sélectionner",
      "planner.flightResults.perPerson": "/pers.",
      "planner.flightResults.hideDetails": "Masquer les détails",
      "planner.flightResults.showDetails": "Voir les détails",
      "planner.flightResults.outboundFlight": "Vol aller",
      "planner.flightResults.returnFlight": "Vol retour",
      "planner.flightResults.aircraft": "Appareil",
      "planner.flightResults.legroom": "Espace jambes",
      "planner.flightResults.comfort": "Confort",
      "planner.flightResults.layoverAt": "Escale à {{city}}",
      "planner.flightResults.baggage": "Bagages",
      "planner.flightResults.carryOn": "Cabine",
      "planner.flightResults.checked": "Soute",
      "planner.flightResults.emissions": "Émissions",
      "planner.flightResults.lessThanAvg": "de moins que la moyenne",
      "planner.flightResults.moreThanAvg": "de plus que la moyenne",
      "planner.flightResults.selfTransfer": "Correspondance autonome",
      "planner.flightResults.selfTransferNote": "Bagages à récupérer entre les vols",
      "planner.flightResults.noResults": "Aucun vol trouvé",
      "planner.flightResults.noResultsDesc": "Essayez de modifier vos critères de recherche",
      "planner.flightResults.loading": "Recherche des vols...",
      "planner.flightResults.flightFound": "vol trouvé",
      "planner.flightResults.flightsFound": "vols trouvés",
      "planner.flightResults.scrollMore": "Scroll pour plus",
      "planner.flightResults.notIncluded": "Non inclus",
      "planner.flightResults.carryOnIncluded": "Bagage cabine inclus",
      
      // DestinationPopup
      "planner.destination.close": "Fermer",
      "planner.destination.discover": "Découvrir",
      
      // BaseStep (preferences)
      "planner.presets.quickStart": "Démarrage rapide",
      "planner.presets.close": "Fermer",
      "planner.presets.oneClick": "Remplir en 1 clic",
      "planner.presets.romantic": "Escapade romantique",
      "planner.presets.adventure": "Aventure entre amis",
      "planner.presets.family": "Vacances en famille",
      "planner.presets.workation": "Workation",
      "planner.presets.travelers": "Voyageurs",
      "planner.presets.occasion": "Occasion du voyage",
      "planner.presets.optional": "optionnel",
      "planner.presets.defineStyle": "Définir votre style",
      
      // PreferenceSummary
      "planner.summary.generating": "Génération du profil...",
      "planner.summary.analyzing": "Analyse de ton style...",
      "planner.summary.yourProfile": "Ton profil voyageur",
      "planner.summary.regenerate": "Régénérer le profil",
      "planner.summary.placeholder": "Affinez vos préférences pour découvrir votre profil voyageur unique...",
      "planner.summary.energy.zen": "zen et détente",
      "planner.summary.energy.balanced": "équilibrée",
      "planner.summary.energy.dynamic": "dynamique",
      "planner.summary.energy.intense": "intense et sportive",
      "planner.summary.terrain.urban": "urbain et culturel",
      "planner.summary.terrain.mixed": "mixte ville/nature",
      "planner.summary.terrain.open": "grands espaces",
      "planner.summary.terrain.wild": "nature sauvage",
      "planner.summary.budget.budget": "économique",
      "planner.summary.budget.smart": "malin",
      "planner.summary.budget.comfortable": "confortable",
      "planner.summary.budget.luxury": "luxueux",
      "planner.summary.auth.classic": "incontournables",
      "planner.summary.auth.balanced": "équilibré",
      "planner.summary.auth.local": "expériences locales",
      "planner.summary.auth.authentic": "aventure authentique",
      "planner.quick.seeActivities": "Voir les activités",
      "planner.quick.cheapestFlight": "Vol le moins cher",
      "planner.quick.fastestFlight": "Vol le plus rapide",
      "planner.quick.findHotel": "Chercher un hôtel",
      "planner.quick.travelers": "Nombre de voyageurs",
      "planner.quick.flexible": "Dates flexibles?",
      "planner.quick.discoverActivities": "Découvrir les activités",
      "planner.quick.otherHotels": "Autres hôtels",
      "planner.quick.summary": "Récapitulatif",
      "planner.quick.help": "Aide",
      "planner.quick.inspireMe": "Inspire-moi",
      
      // Onboarding Tour
      "planner.onboarding.stepLabels": "Intro,Chat,Outils,Carte,Vols,Séjours,Activités,Préfs,Fin",
      "planner.onboarding.skipGuide": "Passer le guide",
      "planner.onboarding.next": "Suivant →",
      "planner.onboarding.prev": "← Précédent",
      "planner.onboarding.done": "C'est parti ! ✨",
      "planner.onboarding.step0.title": "✨ Bienvenue sur Travliaq !",
      "planner.onboarding.step0.desc": "Planifiez votre voyage idéal en quelques minutes grâce à notre assistant intelligent.",
      "planner.onboarding.step0.info": "Ce guide rapide vous présente les fonctionnalités principales en 30 secondes.",
      "planner.onboarding.step0.skip": "Vous pouvez passer ce guide à tout moment avec le bouton ×",
      "planner.onboarding.step1.title": "💬 Assistant IA",
      "planner.onboarding.step1.badge": "Chat intelligent",
      "planner.onboarding.step1.desc": "Parlez naturellement pour planifier votre voyage.",
      "planner.onboarding.step1.item1": "Demandez des recommandations personnalisées",
      "planner.onboarding.step1.item2": "Configurez vos vols, hébergements, activités",
      "planner.onboarding.step1.item3": "L'IA synchronise tout automatiquement dans les widgets",
      "planner.onboarding.step1.tip": "Exemple : \"Je veux partir à Bali en avril pour 2 semaines\"",
      "planner.onboarding.step2.title": "🛠️ Barre d'Outils",
      "planner.onboarding.step2.badge": "Accès instantané",
      "planner.onboarding.step2.desc": "Utilisez ces boutons pour passer d'un widget à l'autre, sans perdre le fil de votre conversation.",
      "planner.onboarding.step2.flights": "✈️ Vols — configurer itinéraire, dates, passagers",
      "planner.onboarding.step2.stays": "🏨 Hébergements — choisir une zone + filtrer selon vos critères",
      "planner.onboarding.step2.activities": "🎭 Activités — explorer, filtrer et ajouter à l'itinéraire",
      "planner.onboarding.step2.preferences": "⚙️ Préférences — affiner le style de voyage pour guider l'IA",
      "planner.onboarding.step2.tip": "Astuce : cliquez sur un onglet, puis dites à l'IA ce que vous voulez — tout se remplit automatiquement.",
      "planner.onboarding.step3.title": "🗺️ Carte Interactive",
      "planner.onboarding.step3.badge": "Visualisation en temps réel",
      "planner.onboarding.step3.desc": "Explorez votre voyage sur la carte :",
      "planner.onboarding.step3.item1": "Prix en direct — cliquez sur une destination pour voir les tarifs",
      "planner.onboarding.step3.item2": "Itinéraires — vos trajets s'affichent automatiquement",
      "planner.onboarding.step3.item3": "Zoom — découvrez plus de destinations en zoomant",
      "planner.onboarding.step4.title": "✈️ Widget Vols",
      "planner.onboarding.step4.badge": "Recherchez et comparez",
      "planner.onboarding.step4.desc": "Ce panneau complet vous permet de configurer tous les détails de vos vols.",
      "planner.onboarding.step4.item1": "Type de voyage — aller-retour, aller simple, multi-destinations",
      "planner.onboarding.step4.item2": "Origine & destination — aéroports ou villes",
      "planner.onboarding.step4.item3": "Dates & voyageurs — flexible ou fixe",
      "planner.onboarding.step4.item4": "Options avancées — vols directs, bagages, classe…",
      "planner.onboarding.step4.tip": "Les résultats apparaissent ici même après la recherche",
      "planner.onboarding.step5.title": "🏨 Widget Hébergements",
      "planner.onboarding.step5.badge": "Trouvez votre logement idéal",
      "planner.onboarding.step5.desc": "Recherchez parmi des milliers d'options d'hébergement.",
      "planner.onboarding.step5.item1": "Destination — synchronisée avec vos vols automatiquement",
      "planner.onboarding.step5.item2": "Budget & confort — définissez votre fourchette de prix",
      "planner.onboarding.step5.item3": "Type — hôtel, appartement, villa, auberge…",
      "planner.onboarding.step5.item4": "Équipements — piscine, WiFi, parking, petit-déj…",
      "planner.onboarding.step5.tip": "Les prix s'affichent aussi sur la carte",
      "planner.onboarding.step6.title": "🎭 Widget Activités",
      "planner.onboarding.step6.badge": "Découvrez quoi faire",
      "planner.onboarding.step6.desc": "Explorez les meilleures activités de votre destination.",
      "planner.onboarding.step6.item1": "Catégories — culture, nature, gastronomie, aventure…",
      "planner.onboarding.step6.item2": "Filtres — prix, durée, popularité, accessibilité",
      "planner.onboarding.step6.item3": "Localisation — visualisez les activités sur la carte",
      "planner.onboarding.step6.item4": "Détails — photos, avis, horaires, réservation",
      "planner.onboarding.step6.tip": "Ajoutez des activités à votre itinéraire d'un clic",
      "planner.onboarding.step7.title": "⚙️ Widget Préférences",
      "planner.onboarding.step7.badge": "Personnalisez l'expérience",
      "planner.onboarding.step7.desc": "Vos préférences guident l'IA pour des recommandations sur-mesure.",
      "planner.onboarding.step7.item1": "Rythme — détente, modéré ou intensif",
      "planner.onboarding.step7.item2": "Budget — économique, confort ou premium",
      "planner.onboarding.step7.item3": "Intérêts — culture, plage, montagne, vie nocturne…",
      "planner.onboarding.step7.item4": "Style — solo, couple, famille, groupe d'amis",
      "planner.onboarding.step7.tip": "Plus vos préférences sont précises, meilleures sont les suggestions",
      "planner.onboarding.step8.title": "🚀 Vous êtes prêt !",
      "planner.onboarding.step8.desc": "Votre assistant de voyage vous attend.",
      "planner.onboarding.step8.tip": "Pour commencer : dites bonjour à l'assistant ou configurez directement vos vols !",
      "planner.onboarding.step8.info": "Vous pouvez relancer ce guide depuis les paramètres à tout moment.",
      
      // PlannerPanel flights additional
      "planner.flights.segmentsToSearch": "Segments à rechercher",
      "planner.flights.searchNFlights": "Rechercher {{count}} vols",
      "planner.flights.searchFlights": "Rechercher des vols",
      "planner.flights.missingInfo": "Manque : {{info}}",
      "planner.flights.incompleteSegments": "{{count}} segment(s) incomplet(s)",
      "planner.flights.nearbyAirports": "Aéroports proches",
      "planner.flights.noEveningFlights": "Pas de vol le soir",
      
      // AccommodationPanel
      "planner.accommodation.searching": "Recherche...",
      "planner.accommodation.minChars": "Tapez au moins 3 caractères",
      "planner.accommodation.noResults": "Aucun résultat",
      "planner.accommodation.whereTo": "Ville ou destination",
      "planner.accommodation.adults": "Adultes",
      "planner.accommodation.adultsDesc": "18 ans et plus",
      "planner.accommodation.childrenLabel": "Enfants",
      "planner.accommodation.childrenDesc": "0 - 17 ans",
      "planner.accommodation.childrenAges": "Âge des enfants",
      "planner.accommodation.year": "an",
      "planner.accommodation.years": "ans",
      "planner.accommodation.adult": "adulte",
      "planner.accommodation.child": "enfant",
      "planner.accommodation.rooms.single": "1 chambre simple",
      "planner.accommodation.rooms.double": "1 chambre double",
      "planner.accommodation.rooms.family": "1 chambre familiale",
      "planner.accommodation.rooms.count": "{{count}} chambres",
      "planner.accommodation.rooms.room": "Chambre {{num}}",
      "planner.accommodation.rooms.remove": "Supprimer",
      "planner.accommodation.rooms.add": "Ajouter une chambre",
      "planner.accommodation.rooms.autoConfig": "Configuration auto",
      "planner.accommodation.rooms.enabled": "Activé",
      "planner.accommodation.rooms.disabled": "Désactivé",
      "planner.accommodation.rooms.mismatch": "{{inRooms}} personnes en chambres / {{travelers}} voyageurs",
      "planner.accommodation.dates.selectDates": "Sélectionnez vos dates",
      "planner.accommodation.dates.selectReturn": "Choisissez la date de départ",
      "planner.accommodation.dates.nightsSelected": "{{count}} nuit sélectionnée",
      "planner.accommodation.dates.nightsSelectedPlural": "{{count}} nuits sélectionnées",
      "planner.accommodation.dates.syncedWithFlight": "Dates synchronisées avec vos vols",
      "planner.accommodation.dates.arrivalSynced": "Date d'arrivée synchronisée avec le vol",
      "planner.accommodation.dates.stayDates": "Dates du séjour",
      "planner.accommodation.dates.return": "Retour ?",
      "planner.accommodation.dates.canModify": "Modifiez-les librement si nécessaire",
      "planner.accommodation.type.hotel": "Hôtel",
      "planner.accommodation.type.apartment": "Appart",
      "planner.accommodation.type.villa": "Villa",
      "planner.accommodation.type.hostel": "Auberge",
      "planner.accommodation.type.guesthouse": "Maison",
      "planner.accommodation.type.any": "Tous",
      "planner.accommodation.type.label": "Type",
      "planner.accommodation.budget.perNight": "Budget par nuit",
      "planner.accommodation.budget.eco": "Économique",
      "planner.accommodation.budget.comfort": "Confort",
      "planner.accommodation.budget.premium": "Premium",
      "planner.accommodation.rating.min": "Note minimum",
      "planner.accommodation.rating.all": "Tous",
      "planner.accommodation.amenities.label": "Équipements",
      "planner.accommodation.amenities.wifi": "WiFi",
      "planner.accommodation.amenities.parking": "Parking",
      "planner.accommodation.amenities.breakfast": "Petit-déj",
      "planner.accommodation.amenities.ac": "Clim",
      "planner.accommodation.amenities.pool": "Piscine",
      "planner.accommodation.amenities.kitchen": "Cuisine",
      "planner.accommodation.filters.advanced": "Filtres avancés",
      "planner.accommodation.filters.mealPlan": "Formule repas",
      "planner.accommodation.filters.halfBoard": "Demi-pension",
      "planner.accommodation.filters.fullBoard": "Pension complète",
      "planner.accommodation.filters.allInclusive": "All-inclusive",
      "planner.accommodation.filters.views": "Vue",
      "planner.accommodation.filters.sea": "Mer",
      "planner.accommodation.filters.mountain": "Montagne",
      "planner.accommodation.filters.city": "Ville",
      "planner.accommodation.filters.garden": "Jardin",
      "planner.accommodation.filters.poolView": "Piscine",
      "planner.accommodation.filters.services": "Services",
      "planner.accommodation.filters.roomService": "Room service",
      "planner.accommodation.filters.spa": "Spa",
      "planner.accommodation.filters.gym": "Gym",
      "planner.accommodation.filters.shuttle": "Navette",
      "planner.accommodation.filters.accessibility": "Accessibilité",
      "planner.accommodation.filters.pmr": "PMR",
      "planner.accommodation.filters.baby": "Bébé",
      "planner.accommodation.filters.pets": "Animaux",
      "planner.accommodation.search": "Rechercher les hébergements",
      "planner.accommodation.searching.hotels": "Recherche d'hôtels...",
      "planner.accommodation.addDestination": "Ajouter une destination",
      "planner.accommodation.syncedFlights": "Synchronisé avec vos vols",
      "planner.accommodation.destinationIncomplete": "Destination incomplète",
      "planner.accommodation.destinationIncompleteDesc": "Sélectionnez une ville dans la liste (pas seulement du texte) pour récupérer le pays et les coordonnées.",
      "planner.accommodation.datesMissing": "Dates manquantes",
      "planner.accommodation.datesMissingDesc": "Choisissez une date d'arrivée et une date de départ pour lancer la recherche d'hébergements.",
      "planner.accommodation.noResults.title": "Aucun résultat",
      "planner.accommodation.noResults.desc": "Aucun hôtel trouvé pour ces critères",
      "planner.accommodation.synced": "Hébergements synchronisés",
      "planner.accommodation.syncedDesc": "{{count}} destination mise à jour depuis vos vols",
      "planner.accommodation.syncedDescPlural": "{{count}} destinations mises à jour depuis vos vols",
      "planner.accommodation.locationError": "Localisation impossible",
      "planner.accommodation.locationErrorDesc": "Impossible de déterminer la ville à cet emplacement",
      "planner.accommodation.searchError": "Erreur de recherche",
      "planner.accommodation.newArea": "Nouvelle zone",
      "planner.accommodation.foundInCity": "{{count}} hébergements trouvés à {{city}}",
      "planner.accommodation.destinationAdded": "Destination ajoutée",
      "planner.accommodation.destinationAddedDesc": "{{city}} a été ajouté à vos hébergements",
      "planner.accommodation.booking": "Réservation",
      "planner.accommodation.bookingSoon": "La réservation sera bientôt disponible !",
      "planner.accommodation.defaultName": "Hébergement {{num}}",
      "planner.accommodation.shortName": "Hébgt {{num}}",
      "planner.accommodation.searchCity": "Rechercher une ville...",
      
      // Hotels (HotelSearchResults)
      "planner.hotels.perNight": "nuit",
      "planner.hotels.total": "Total",
      "planner.hotels.viewDetails": "Voir détails",
      "planner.hotels.inDestination": "Hébergements à {{destination}}",
      "planner.hotels.searching": "Recherche en cours...",
      "planner.hotels.resultsCount": "{{count}} résultats · {{nights}} nuit(s)",
      "planner.hotels.noResults": "Aucun hébergement trouvé pour ces critères",
      "planner.hotels.modifySearch": "Modifier la recherche",
      
      // HotelDetailView
      "planner.hotels.free": "Gratuit",
      "planner.hotels.paid": "Payant",
      "planner.hotels.freeCancellation": "Annulation gratuite",
      "planner.hotels.breakfastIncluded": "Petit-déj inclus",
      "planner.hotels.popular": "Populaire",
      "planner.hotels.excellentChoice": "Excellent choix",
      "planner.hotels.veryAppreciated": "Très apprécié",
      "planner.hotels.cityCenter": "Centre-ville",
      "planner.hotels.nearCenter": "Proche centre",
      "planner.hotels.pool": "Piscine",
      "planner.hotels.spa": "Spa",
      "planner.hotels.availableRooms": "Chambres disponibles ({{count}})",
      "planner.hotels.showLess": "Voir moins",
      "planner.hotels.showAllRooms": "Voir les {{count}} chambres",
      "planner.hotels.showOtherRooms": "Afficher les {{count}} autres chambres",
      "planner.hotels.whyBookHere": "Pourquoi réserver ici ?",
      "planner.hotels.bestPriceGuarantee": "Meilleur prix garanti - on vous rembourse la différence",
      "planner.hotels.instantConfirmation": "Confirmation immédiate par email",
      "planner.hotels.support24h": "Service client disponible 24h/24",
      "planner.hotels.persons": "pers.",
      "planner.hotels.night": "nuit",
      "planner.hotels.fromCenter": "du centre-ville",
      "planner.hotels.rating.exceptional": "Exceptionnel",
      "planner.hotels.rating.veryGood": "Très bien",
      "planner.hotels.rating.good": "Bien",
      "planner.hotels.rating.correct": "Correct",
      "planner.hotels.rating.fair": "Passable",
      "planner.hotels.amenities.connectivity": "Connectivité",
      "planner.hotels.amenities.food": "Restauration",
      "planner.hotels.amenities.wellness": "Bien-être",
      "planner.hotels.amenities.room": "Chambre",
      "planner.hotels.amenities.services": "Services",
      "planner.hotels.amenities.general": "Autres",
      "planner.hotels.amenities.wifi": "WiFi",
      "planner.hotels.amenities.parking": "Parking",
      "planner.hotels.amenities.breakfast": "Petit-déj",
      "planner.hotels.amenities.fitness": "Fitness",
      "planner.hotels.amenities.restaurant": "Restaurant",
      "planner.hotels.amenities.ac": "Climatisation",
      "planner.hotels.notYetRated": "Pas encore noté",
      "planner.hotels.checkIn": "Arrivée",
      "planner.hotels.checkOut": "Départ",
      "planner.hotels.nights": "{{count}} nuit",
      "planner.hotels.nightsPlural": "{{count}} nuits",
      "planner.hotels.location": "Localisation",
      "planner.hotels.detailedRatings": "Notes détaillées",
      "planner.hotels.whatThisOffers": "Ce que propose cet établissement",
      "planner.hotels.cancellationPolicy": "Politique d'annulation",
      "planner.hotels.goToPhoto": "Aller à la photo {{index}}",
      "planner.hotels.ratingBreakdown.cleanliness": "Propreté",
      "planner.hotels.ratingBreakdown.staff": "Personnel",
      "planner.hotels.ratingBreakdown.location": "Emplacement",
      "planner.hotels.ratingBreakdown.facilities": "Équipements",
      "planner.hotels.ratingBreakdown.comfort": "Confort",
      "planner.hotels.ratingBreakdown.valueForMoney": "Rapport qualité/prix",
      
      // AIConflictBadge
      "planner.ai.conflict.travelStyle": "Style de voyage",
      "planner.ai.conflict.comfortLevel": "Niveau de confort",
      "planner.ai.conflict.pace": "Rythme",
      "planner.ai.conflict.interests": "Centres d'intérêt",
      "planner.ai.conflict.occasion": "Occasion",
      "planner.ai.conflict.energy": "Énergie",
      "planner.ai.conflict.budget": "Budget",
      "planner.ai.conflict.environment": "Environnement",
      "planner.ai.conflict.authenticity": "Authenticité",
      
      // PreferenceSummary - Travel style labels for LLM prompt
      "planner.summary.travelStyle.solo": "solo",
      "planner.summary.travelStyle.couple": "en duo",
      "planner.summary.travelStyle.family": "en famille",
      "planner.summary.travelStyle.friends": "entre amis",
      "planner.summary.travelStyle.pet": "avec animal",
      "planner.summary.occasion.honeymoon": "lune de miel",
      "planner.summary.occasion.anniversary": "anniversaire de couple",
      "planner.summary.occasion.birthday": "célébration d'anniversaire",
      "planner.summary.occasion.vacation": "vacances",
      "planner.summary.occasion.workation": "télétravail + voyage",
      "planner.summary.occasion.other": "découverte",
      "planner.summary.polyvalent": "polyvalent",
      
      // MapPreviewWidget
      "planner.map.viewOnMap": "Voir sur la carte",
      "planner.map.viewMap": "Voir la carte",
      "planner.map.openInMaps": "Ouvrir dans Maps",
      "planner.map.enlarge": "Agrandir",
      "planner.map.map": "Carte",
      "planner.map.places": "lieu",
      "planner.map.placesPlural": "lieux",
      "planner.map.day": "Jour {{day}}",
      "planner.map.trips": "trajet",
      "planner.map.tripsPlural": "trajets",
      "planner.map.travelTime": "h de trajet",
      
      // FlightComparisonCard
      "planner.flights.comparison.bestPrice": "Meilleur prix",
      "planner.flights.comparison.fastest": "Plus rapide",
      "planner.flights.comparison.mostComfortable": "Plus confortable",
      "planner.flights.comparison.bestSchedule": "Meilleurs horaires",
      "planner.flights.comparison.included": "Inclus",
      "planner.flights.comparison.notIncluded": "Non inclus",
      "planner.flights.comparison.cabinOnly": "Cabine seul.",
      "planner.flights.comparison.outbound": "Aller",
      "planner.flights.comparison.return": "Retour",
      "planner.flights.comparison.direct": "Direct",
      "planner.flights.comparison.stop": "escale",
      "planner.flights.comparison.stops": "escales",
      "planner.flights.comparison.cheaper": "Moins cher",
      "planner.flights.comparison.faster": "Plus rapide",
      "planner.flights.comparison.select": "Sélectionner",
      "planner.flights.comparison.totalDuration": "Durée totale",
      "planner.flights.comparison.layovers": "Escales",
      "planner.flights.comparison.baggage": "Bagages",
      "planner.flights.comparison.flexibility": "Flexibilité",
      "planner.flights.comparison.refundable": "Remboursable",
      "planner.flights.comparison.changeable": "Modifiable",
      "planner.flights.comparison.notFlexible": "Non flex.",
      "planner.flights.comparison.perPerson": "pers.",
      
      // AirportConfirmationWidget
      "planner.airports.confirmed": "Aéroports confirmés",
      "planner.airports.selection": "Sélection des aéroports",
      "planner.airports.search": "Rechercher {{count}} vol",
      "planner.airports.searchPlural": "Rechercher {{count}} vols",
      "planner.airports.searching": "Recherche en cours...",
      "planner.airports.recommended": "recommandé",
      "planner.airports.bestChoice": "Meilleur choix",
      "planner.airports.accept": "Accepter",
      "planner.airports.seeOthers": "Voir les autres",
      "planner.airports.departureAirports": "Aéroports de départ disponibles",
      "planner.airports.arrivalAirports": "Aéroports d'arrivée disponibles",
      "planner.airports.closerToCenter": "Le plus proche",
      "planner.airports.furtherAway": "Plus éloigné",
      "planner.airports.majorInternational": "Aéroport international majeur",
      "planner.airports.moreFlights": "Plus de vols disponibles",
      "planner.airports.betterConnection": "Meilleure connexion",
      "planner.airports.quickAccess": "Accès rapide depuis le centre",
      "planner.airports.fewerFlights": "Moins de choix de vols",
      "planner.airports.kmFromCenter": "km du centre",
      "planner.airports.departure": "Départ",
      "planner.airports.arrival": "Arrivée",
      
      // CitySelectionWidget
      "planner.cities.recommended": "Recommandée",
      "planner.cities.bestChoice": "Meilleur choix",
      "planner.cities.chooseCity": "Choisir une ville en {{country}}",
      "planner.cities.loading": "Chargement des villes...",
      "planner.cities.mostPopular": "Destination la plus populaire et mieux desservie",
      "planner.cities.otherDestinations": "Autres destinations",
      
      // DirectFlightToggle
      "planner.flights.toggle.allFlights": "Tous les vols",
      "planner.flights.toggle.directOnly": "Directs uniquement",
      "planner.flights.toggle.all": "Tous",
      "planner.flights.toggle.direct": "Direct",
      "planner.flights.toggle.maxOneStop": "1 escale max",
      
      // BudgetProgressWidget
      "planner.budget.spent": "Dépensé",
      "planner.budget.overspent": "Dépassement",
      "planner.budget.remaining": "Restant",
      "planner.budget.budgetUsed": "Budget utilisé",
      "planner.budget.of": "sur",
      "planner.budget.budget": "Budget",
      
      // NavigationButtons
      "planner.nav.modifySearch": "Modifier la recherche",
      "planner.nav.viewMore": "Voir plus",
      "planner.nav.viewMoreResults": "Voir {{count}} résultat de plus",
      "planner.nav.viewMoreResultsPlural": "Voir {{count}} résultats de plus",
      "planner.nav.back": "Retour",
      "planner.nav.restart": "Recommencer",
      "planner.nav.restartConfirm": "Êtes-vous sûr de vouloir recommencer la planification ?",
      "planner.nav.refresh": "Actualiser",
      "planner.nav.home": "Accueil",
      
      // ResultBadges
      "planner.badges.bestDeal": "Meilleure offre",
      "planner.badges.popular": "Populaire",
      "planner.badges.recommended": "Recommandé",
      "planner.badges.topRated": "Mieux noté",
      "planner.badges.lastMinute": "Dernière minute",
      "planner.badges.fastSelling": "Se vend vite",
      "planner.badges.favorite": "Coup de cœur",
      "planner.badges.new": "Nouveau",
      "planner.badges.trending": "Tendance",
      "planner.badges.premium": "Premium",
      
      // TripTypeConfirmWidget
      "planner.tripType.roundtrip": "Aller-retour",
      "planner.tripType.oneway": "Aller simple",
      "planner.tripType.multi": "Multi-destinations",
      
      // ActivitiesPanel
      "planner.activities.searching": "Recherche...",
      "planner.activities.minChars": "Tapez au moins 3 caractères",
      "planner.activities.noResults": "Aucun résultat",
      "planner.activities.selectCity": "Veuillez sélectionner une ville",
      "planner.activities.added": "Activité ajoutée !",
      "planner.activities.removed": "Activité retirée",
      "planner.activities.selectDestination": "Veuillez sélectionner une destination",
      "planner.activities.addDestination": "Ajouter une destination",
      "planner.activities.newDestination": "Nouvelle destination",
      "planner.activities.searchCity": "Rechercher une ville...",
      "planner.activities.dates": "Dates",
      "planner.activities.add": "Ajouter",
      "planner.activities.noDestination": "Aucune destination",
      "planner.activities.noDestinationDesc": "Ajoutez une destination pour explorer les activités",
      "planner.activities.datesToDefine": "Dates à définir",
      "planner.activities.search": "Rechercher des activités",
      "planner.activities.searching.activities": "Recherche en cours...",
      "planner.activities.selected": "Activités sélectionnées",
      "planner.activities.others": "+{{count}} autres",
      "planner.activities.back": "Retour",
      "planner.activities.sortDefault": "Par défaut",
      "planner.activities.sortPriceAsc": "Prix ↑",
      "planner.activities.sortPriceDesc": "Prix ↓",
      "planner.activities.sortRating": "Meilleures notes",
      "planner.activities.sortDuration": "Plus longue durée",
      "planner.activities.found": "{{count}} activité trouvée",
      "planner.activities.foundPlural": "{{count}} activités trouvées",
      "planner.activities.attractionsOnMap": "+ {{count}} attraction sur la carte",
      "planner.activities.attractionsOnMapPlural": "+ {{count}} attractions sur la carte",
      "planner.activities.noFound": "Aucune activité trouvée",
      "planner.activities.noFoundDesc": "Essayez de modifier vos critères de recherche",
      "planner.activities.inheritedDestination": "Cette destination provient des hébergements. Modifiez-la dans l'onglet Hébergements.",
      "planner.activities.needOneDestination": "Vous devez avoir au moins une destination",
      "planner.activities.destinationRemoved": "Destination retirée",
      "planner.activities.cityAdded": "{{city}} ajoutée !",
      "planner.activities.cannotGetVisibleArea": "Impossible de récupérer la zone visible",
      "planner.activities.foundInZone": "{{attractions}} attractions et {{activities}} activités trouvées dans cette zone",
      "planner.activities.noActivityInZone": "Aucune activité trouvée dans cette zone",
      "planner.activities.searchZoneError": "Erreur lors de la recherche dans cette zone",
      "planner.activities.activityAdded": "Activité ajoutée !",
      "planner.activities.activityRemoved": "Activité retirée",
      "planner.activities.cityOrDestination": "Ville ou destination",
      "planner.activities.nights": "n",
      "planner.activities.addDestinationToExplore": "Ajoutez une destination pour explorer les activités",
      "planner.activities.thisCity": "cette ville",
      "planner.activities.addCity": "Ajouter {{city}}",
      "planner.activities.searchInProgress": "Recherche en cours...",
      "planner.activities.searchActivities": "Rechercher des activités",
      "planner.activities.selectedActivities": "Activités sélectionnées ({{count}})",
      "planner.activities.sort.default": "Par défaut",
      "planner.activities.sort.priceAsc": "Prix ↑",
      "planner.activities.sort.priceDesc": "Prix ↓",
      "planner.activities.sort.rating": "Meilleures notes",
      "planner.activities.sort.duration": "Plus longue durée",
      "planner.activities.activitiesFound": "{{count}} activité(s) trouvée(s)",
      "planner.activities.noActivityFound": "Aucune activité trouvée",
      "planner.activities.tryCriteria": "Essayez de modifier vos critères de recherche",
      "planner.activities.durationUnspecified": "Durée non spécifiée",
      "planner.activities.popular": "Populaire",
      "planner.activities.topRated": "Top noté",
      "planner.activities.activity": "Activité",
      "planner.activities.attraction": "Attraction",
      "planner.activities.reviews": "avis",
      "planner.activities.perPerson": "pers",
      "planner.activities.details": "Détails",
      "planner.activities.remove": "Supprimer",
      
      // PreferencesPanel
      "planner.preferences.detectedByAI": "Préférences détectées par l'IA",
      "planner.preferences.steps.base": "Base",
      "planner.preferences.steps.style": "Style",
      "planner.preferences.steps.criteria": "Critères",
      
      // ActivityFilters
      "planner.activityFilters.filters": "Filtres",
      "planner.activityFilters.clear": "Effacer",
      "planner.activityFilters.travelers": "voyageur(s)",
      "planner.activityFilters.adultsCount": "{{count}} adulte(s)",
      "planner.activityFilters.childrenCount": "{{count}} enfant(s)",
      "planner.activityFilters.autoSelect": "Sélection automatique selon mes préférences",
      "planner.activityFilters.categories": "Catégories",
      "planner.activityFilters.budgetPerActivity": "Budget / activité",
      "planner.activityFilters.minRating": "Note minimum",
      "planner.activityFilters.all": "Tous",
      "planner.activityFilters.advancedFilters": "Filtres avancés",
      "planner.activityFilters.timeOfDay": "Moment de la journée",
      "planner.activityFilters.morning": "Matin",
      "planner.activityFilters.afternoon": "Après-midi",
      "planner.activityFilters.evening": "Soirée",
      "planner.activityFilters.activityDuration": "Durée de l'activité",
      "planner.activityFilters.under1h": "< 1h",
      "planner.activityFilters.1to4h": "1-4h",
      "planner.activityFilters.over4h": "> 4h",
      "planner.activityFilters.fullDay": "1 journée",
      "planner.activityFilters.multiDay": "Plusieurs jours",
      "planner.activityFilters.preferencesUnavailable": "Vos préférences de voyage ne sont pas disponibles",
      "planner.activityFilters.filtersApplied": "Filtres appliqués : {{summary}}",
      
      // ActivityDetailModal
      "planner.activityDetail.close": "Fermer",
      "planner.activityDetail.durationNotSpecified": "Durée non spécifiée",
      "planner.activityDetail.reviews": "avis",
      "planner.activityDetail.topRated": "Top noté",
      "planner.activityDetail.duration": "Durée",
      "planner.activityDetail.location": "Lieu",
      "planner.activityDetail.pricePerPerson": "Prix par personne",
      "planner.activityDetail.options": "Options",
      "planner.activityDetail.description": "Description",
      "planner.activityDetail.priceFrom": "Prix à partir de",
      "planner.activityDetail.person": "personne",
      "planner.activityDetail.save": "Économisez",
      "planner.activityDetail.viewOnViator": "Voir sur Viator",
      "planner.activityDetail.removeFromPlanning": "Retirer du planning",
      "planner.activityDetail.addToPlanning": "Ajouter au planning",
      
      // PreferencesPanel - Travel Style Selector
      "planner.preferences.travelStyle.solo": "Solo",
      "planner.preferences.travelStyle.duo": "Duo",
      "planner.preferences.travelStyle.family": "Famille",
      "planner.preferences.travelStyle.friends": "Amis",
      
      // PreferencesPanel - Occasion Selector
      "planner.preferences.occasion.vacation": "Vacances",
      "planner.preferences.occasion.honeymoon": "Lune de miel",
      "planner.preferences.occasion.anniversary": "Anniversaire",
      "planner.preferences.occasion.birthday": "Fête",
      "planner.preferences.occasion.workation": "Télétravail",
      "planner.preferences.occasion.discovery": "Découverte",
      
      // PreferencesPanel - Must-Haves
      "planner.preferences.mustHaves.accessibility": "Accessibilité PMR",
      "planner.preferences.mustHaves.wifi": "WiFi Haut Débit",
      "planner.preferences.mustHaves.pets": "Accepte animaux",
      "planner.preferences.mustHaves.children": "Adapté enfants",
      
      // PreferencesPanel - Style Step
      "planner.preferences.style.yourStyle": "Votre style de voyage",
      "planner.preferences.style.interests": "Centres d'intérêt",
      "planner.preferences.style.defineCriteria": "Définir vos critères",
      
      // PreferencesPanel - Criteria Step
      "planner.preferences.criteria.mustHaves": "Critères obligatoires",
      "planner.preferences.criteria.dietary": "Restrictions alimentaires",
      "planner.preferences.criteria.viewSummary": "Voir le résumé",
      
      // PreferencesPanel - Profile Completion
      "planner.preferences.profile.complete": "Profil complet",
      "planner.preferences.profile.goodStart": "Bon début",
      "planner.preferences.profile.someInfo": "Quelques infos",
      "planner.preferences.profile.toComplete": "À compléter",
      "planner.preferences.profile.updated": "Mis à jour",
      "planner.preferences.profile.detectedByAI": "Détecté par IA",
      
      // PreferencesPanel - Smart Tags
      "planner.preferences.smartTags.title": "Ton profil voyageur",
      "planner.preferences.smartTags.emptyState": "Tes hashtags apparaîtront après quelques messages...",
      "planner.preferences.smartTags.analyzing": "Analyse...",
      "planner.preferences.smartTags.recalculate": "Recalculer",
      "planner.preferences.smartTags.add": "Ajouter",
      "planner.preferences.smartTags.placeholder": "#MonHashtag",
      
      // PreferencesPanel - Interests
      "planner.preferences.interests.selectUpTo": "Sélectionnez jusqu'à {{count}}",
      "planner.preferences.interests.culture": "Culture",
      "planner.preferences.interests.food": "Gastronomie",
      "planner.preferences.interests.nature": "Nature",
      "planner.preferences.interests.beach": "Plage",
      "planner.preferences.interests.wellness": "Bien-être",
      "planner.preferences.interests.sport": "Sport",
      "planner.preferences.interests.adventure": "Aventure",
      "planner.preferences.interests.nightlife": "Sorties",
      "planner.preferences.interests.shopping": "Shopping",
      "planner.preferences.interests.history": "Histoire",
      
      // PreferencesPanel - Dietary
      "planner.preferences.dietary.vegetarian": "Végétarien",
      "planner.preferences.dietary.vegan": "Végan",
      "planner.preferences.dietary.halal": "Halal",
      "planner.preferences.dietary.kosher": "Casher",
      "planner.preferences.dietary.glutenFree": "Sans gluten",
      "planner.preferences.dietary.pescatarian": "Pescétarien",
      "planner.preferences.dietary.lactoseFree": "Sans lactose",
      "planner.preferences.dietary.noEggs": "Sans œufs",
      "planner.preferences.dietary.noNuts": "Fruits à coque",
      
      // PreferencesPanel - Style Axes
      "planner.preferences.axes.chill": "Détente",
      "planner.preferences.axes.intense": "Intense",
      "planner.preferences.axes.urban": "Urbain",
      "planner.preferences.axes.nature": "Nature",
      "planner.preferences.axes.budget": "Économique",
      "planner.preferences.axes.luxury": "Luxe",
      "planner.preferences.axes.tourist": "Touristique",
      "planner.preferences.axes.authentic": "Authentique",
      
      // TimeOfDayChips
      "planner.timeOfDay.morning": "Matin",
      "planner.timeOfDay.morningShort": "Matin",
      "planner.timeOfDay.afternoon": "Après-midi",
      "planner.timeOfDay.afternoonShort": "A-M",
      "planner.timeOfDay.evening": "Soir",
      "planner.timeOfDay.eveningShort": "Soir",
      "planner.timeOfDay.night": "Nuit",
      "planner.timeOfDay.nightShort": "Nuit",
      
      // SeasonalTip
      "planner.seasonal.crowdLevel.low": "Peu fréquenté",
      "planner.seasonal.crowdLevel.medium": "Fréquentation moyenne",
      "planner.seasonal.crowdLevel.high": "Très fréquenté",
      "planner.seasonal.crowdLevel.peak": "Affluence maximale",
      "planner.seasonal.priceTrend.low": "Prix bas",
      "planner.seasonal.priceTrend.average": "Prix moyens",
      "planner.seasonal.priceTrend.high": "Prix élevés",
      "planner.seasonal.priceTrend.peak": "Prix au plus haut",
      "planner.seasonal.events": "Événements",
      
      // TipCard
      "planner.tips.type.savings": "Économisez",
      "planner.tips.type.timing": "Timing",
      "planner.tips.type.seasonal": "Conseil saisonnier",
      "planner.tips.type.location": "Localisation",
      "planner.tips.type.warning": "Attention",
      "planner.tips.type.insight": "Notre analyse",
      "planner.tips.type.pro": "Astuce",
      "planner.tips.type.info": "Info",
      "planner.tips.midweekFlights.title": "Économisez sur les vols",
      "planner.tips.midweekFlights.message": "Les vols en milieu de semaine (mardi-mercredi) sont souvent 20-30% moins chers.",
      "planner.tips.earlyBooking.title": "Réservez tôt",
      "planner.tips.earlyBooking.message": "Pour les meilleures offres, réservez 2-3 mois à l'avance pour les vols internationaux.",
      "planner.tips.flexibleDates.title": "Dates flexibles?",
      "planner.tips.flexibleDates.message": "Décaler votre voyage de quelques jours peut vous faire économiser significativement.",
      "planner.tips.highSeason.title": "Haute saison",
      "planner.tips.highSeason.message": "Cette période est très demandée. Réservez rapidement pour avoir les meilleurs choix.",
      "planner.tips.directFlight.title": "Vols directs",
      "planner.tips.directFlight.message": "Un vol direct peut coûter un peu plus mais vous fait gagner des heures précieuses.",

      // Landing - Video
      "landing.video.badge": "Découvre Travliaq en action",
      "landing.video.title": "Regarde comment ça marche",
      "landing.video.subtitle": "En 2 minutes, tu comprendras pourquoi des milliers de voyageurs nous font confiance",
      "landing.video.altPreview": "Aperçu du planner Travliaq",
      "landing.video.comingSoon": "Vidéo bientôt disponible",
      "landing.video.loading": "Vidéo en cours de chargement...",

      // Landing - Testimonials
      "landing.testimonials.title": "Ce qu'ils en disent",
      "landing.testimonials.subtitle": "Des milliers de voyageurs nous font déjà confiance",
      "landing.testimonials.marie.text": "J'ai organisé mon voyage à Rome en 10 minutes. L'IA m'a trouvé des activités que je n'aurais jamais découvertes seule !",
      "landing.testimonials.thomas.text": "Le comparateur de vols est incroyable. J'ai économisé 200€ sur mon aller-retour pour Tokyo.",
      "landing.testimonials.sophie.text": "Parfait pour les voyages en famille. L'IA a compris nos contraintes avec les enfants et a adapté tout l'itinéraire.",

      // Landing - Pricing
      "landing.pricing.title": "Des offres simples",
      "landing.pricing.subtitle": "Mensuel ou annuel (remise incluse). Tu gardes la main, tu peux changer quand tu veux.",
      "landing.pricing.or": "ou",
      "landing.pricing.choose": "Choisir",
      "landing.pricing.comingSoon": "Paiement Stripe bientôt. (Pour l'instant : vitrine.)",
      "landing.pricing.free.name": "Gratuit",
      "landing.pricing.free.badge": "Par défaut",
      "landing.pricing.free.feature1": "X crédits / mois",
      "landing.pricing.free.feature2": "Recommandations de base",
      "landing.pricing.free.feature3": "Accès au blog",
      "landing.pricing.pro.name": "Pro",
      "landing.pricing.pro.badge": "Le plus choisi",
      "landing.pricing.pro.feature1": "Tout du Gratuit",
      "landing.pricing.pro.feature2": "Téléchargement PDF",
      "landing.pricing.pro.feature3": "Plus de crédits / mois",
      "landing.pricing.premium.name": "Premium",
      "landing.pricing.premium.feature1": "Tout du Pro",
      "landing.pricing.premium.feature2": "Personnalisation avancée (plus de temps)",
      "landing.pricing.premium.feature3": "Priorité sur les meilleures options",

      // Share
      "share.button": "Partager",
      "share.shareItinerary": "Partager cet itinéraire",
      "share.shareText": "Découvrez mon itinéraire de {{days}} jours à {{destination}} ! 🌍✨",
      "share.sharing": "Partage en cours",
      "share.openingPlatform": "Ouverture de {{platform}}...",
      "share.shared": "Partagé !",
      "share.sharedSuccess": "Itinéraire partagé avec succès",
      "share.cancelled": "Partage annulé",
      "share.linkCopied": "Lien copié !",
      "share.pasteInstagram": "Collez-le dans votre story Instagram",
      "share.canShareNow": "Vous pouvez maintenant le partager",
      "share.copyLink": "Copier le lien",

      // Planner common
      "planner.common.add": "Ajouter",
      "planner.common.addActivity": "Ajouter une activité",
      "planner.common.noActivityPlanned": "Aucune activité prévue",
      "planner.common.viewPlanning": "Voir le planning",
      "planner.common.viewMap": "Voir la carte",
      "planner.common.viewOnMap": "Voir sur la carte",
      "planner.common.viewOnMapCount": "Voir sur la carte ({{count}} lieu)",
      "planner.common.viewOnMapCountPlural": "Voir sur la carte ({{count}} lieux)",
      "planner.common.openInMaps": "Ouvrir dans Maps",
      "planner.common.itinerary": "Itinéraire",
      "planner.common.day": "jour",
      "planner.common.days": "jours",
      "planner.common.activity": "activité",
      "planner.common.activities": "activités",
      "planner.common.loadingDetails": "Chargement des détails...",
      "planner.common.previousPhoto": "Photo précédente",
      "planner.common.nextPhoto": "Photo suivante",
      "planner.common.showLess": "Voir moins",
      "planner.common.showMore": "Lire la suite",
      "planner.common.showAllRooms": "Voir les {{count}} chambres",
      "planner.common.showOtherRooms": "Afficher les {{count}} autres chambres",
      "planner.common.aboutHotel": "À propos de cet établissement",
      "planner.common.availableRooms": "Chambres disponibles",
      "planner.common.book": "Réserver",
      "planner.common.viewOnBooking": "Voir sur Booking",
      "planner.common.searchInZone": "Rechercher dans cette zone",
      "planner.common.searchInProgress": "Recherche...",
      "planner.common.searchInProgressTitle": "Recherche en cours...",
      "planner.common.searchActivitiesInZone": "Rechercher des activités dans la zone visible",

      // Planner - Conflicts
      "planner.conflicts.collapse": "Réduire",
      "planner.conflicts.viewAll": "Voir tout",
      "planner.conflicts.problem": "problème",
      "planner.conflicts.problems": "problèmes",
      "planner.conflicts.warning": "avertissement",
      "planner.conflicts.warnings": "avertissements",
      "planner.conflicts.suggestion": "suggestion",
      "planner.conflicts.suggestions": "suggestions",

      // Planner - Travelers (additional keys)
      "planner.travelers.adult": "adulte",
      "planner.travelers.child": "enfant",
      "planner.travelers.infant": "bébé",
      "planner.travelers.traveler": "voyageur",
      "planner.travelers.travelersPlural": "voyageurs",

      // Planner - QuickEditChips
      "planner.quickEdit.dates": "Dates",
      "planner.quickEdit.travelers": "Voyageurs",
      "planner.quickEdit.departure": "Départ",
      "planner.quickEdit.destination": "Destination",
      "planner.quickEdit.budget": "Budget",
      "planner.quickEdit.moreOptions": "Plus d'options",

      // Planner - ActivitySearchBar
      "planner.activitySearch.placeholder": "Rechercher une destination...",
      "planner.activitySearch.clear": "Effacer",
      "planner.activitySearch.search": "Rechercher",
      "planner.activitySearch.searching": "Recherche...",
      "planner.activitySearch.quickFilters": "Filtres rapides",
      "planner.activitySearch.category.culture": "Culture",
      "planner.activitySearch.category.food": "Gastronomie",
      "planner.activitySearch.category.nature": "Nature",
      "planner.activitySearch.category.adventure": "Aventure",
      "planner.activitySearch.category.beach": "Plage",

      // Planner - Accommodation (additional keys)
      "planner.accommodation.missingDates": "Dates manquantes",
      "planner.accommodation.chooseDates": "Choisissez une date d'arrivée et une date de départ pour lancer la recherche d'hébergements.",
      "planner.accommodation.noHotelsFound": "Aucun hôtel trouvé pour ces critères",

      // Planner - YouTube
      "planner.youtube.loadError": "Impossible de charger les vidéos",
      "planner.youtube.refreshVideos": "Rafraîchir les vidéos",
      "planner.youtube.retry": "Réessayer",
      "planner.youtube.noVideosFound": "Aucune vidéo trouvée pour {{location}}.",
      "planner.youtube.closeVideo": "Fermer la vidéo",
      "planner.youtube.previousVideo": "Vidéo précédente",
      "planner.youtube.nextVideo": "Vidéo suivante",
      "planner.youtube.play": "Lecture",
      "planner.youtube.pause": "Pause",
      "planner.youtube.mute": "Couper le son",
      "planner.youtube.unmute": "Activer le son",
      "planner.youtube.scrollForNext": "Scroll pour la vidéo suivante",


      // Planner - Message Actions
      "planner.message.copy": "Copier",
      "planner.message.copyMessage": "Copier le message",
      "planner.message.copied": "Copié !",
      "planner.message.copyError": "Impossible de copier",
      "planner.message.like": "J'aime",
      "planner.message.likeResponse": "J'aime cette réponse",
      "planner.message.dislike": "Je n'aime pas",
      "planner.message.dislikeResponse": "Je n'aime pas cette réponse",

      // Planner - Booking Flow
      "planner.booking.summary": "Récapitulatif",
      "planner.booking.travelers": "Voyageurs",
      "planner.booking.contact": "Contact",
      "planner.booking.confirmation": "Confirmation",
      "planner.booking.adult": "adulte",
      "planner.booking.adults": "adultes",
      "planner.booking.child": "enfant",
      "planner.booking.children": "enfants",
      "planner.booking.confirmed": "Confirmé",
      "planner.booking.pending": "En attente",
      "planner.booking.reserve": "Réserver",
      "planner.booking.subtotal": "Sous-total",
      "planner.booking.serviceFees": "Frais de service",
      "planner.booking.discount": "Réduction",
      "planner.booking.total": "Total",
      "planner.booking.continueToTravelers": "Continuer vers les voyageurs",
      "planner.booking.travelerInfo": "Entrez les informations de chaque voyageur telles qu'elles apparaissent sur leurs documents d'identité.",
      "planner.booking.traveler": "Voyageur",
      "planner.booking.adultLabel": "(Adulte)",
      "planner.booking.childLabel": "(Enfant)",
      "planner.booking.infantLabel": "(Bébé)",
      "planner.booking.firstName": "Prénom",
      "planner.booking.lastName": "Nom",
      "planner.booking.back": "Retour",
      "planner.booking.continue": "Continuer",
      "planner.booking.finalize": "Finaliser",
      "planner.booking.finish": "Terminer",
      "planner.booking.contactInfo": "Ces informations seront utilisées pour vos confirmations de réservation.",
      "planner.booking.email": "Email",
      "planner.booking.phone": "Téléphone",
      "planner.booking.securityNote": "Vos données sont sécurisées et ne seront partagées qu'avec les prestataires de voyage.",
      "planner.booking.tripReady": "Votre voyage est prêt !",
      "planner.booking.reservationsConfirmed": "{{count}} réservation confirmée",
      "planner.booking.reservationsConfirmedPlural": "{{count}} réservations confirmées",
      "planner.booking.finalizeBelow": "Finalisez vos réservations ci-dessous",
      "planner.booking.confirmedReservations": "Réservations confirmées",
      "planner.booking.toBook": "À réserver",
      "planner.booking.ref": "Réf",
      "planner.booking.downloadPdf": "Télécharger PDF",
      "planner.booking.sendByEmail": "Envoyer par email",
      "planner.booking.itemSelected": "élément sélectionné",
      "planner.booking.itemsSelected": "éléments sélectionnés",
      "planner.booking.readyToBook": "Prêt à réserver",

      // Planner - Flight Comparison
      "planner.comparison.bestPrice": "Meilleur prix",
      "planner.comparison.fastest": "Plus rapide",
      "planner.comparison.mostComfortable": "Plus confortable",
      "planner.comparison.bestSchedule": "Meilleurs horaires",
      "planner.comparison.outbound": "Aller",
      "planner.comparison.return": "Retour",
      "planner.comparison.direct": "Direct",
      "planner.comparison.stop": "escale",
      "planner.comparison.stops": "escales",
      "planner.comparison.cheaper": "Moins cher",
      "planner.comparison.faster": "Plus rapide",
      "planner.comparison.select": "Sélectionner",
      "planner.comparison.totalDuration": "Durée totale",
      "planner.comparison.layovers": "Escales",
      "planner.comparison.baggage": "Bagages",
      "planner.comparison.included": "Inclus",
      "planner.comparison.cabinOnly": "Cabine seul.",
      "planner.comparison.notIncluded": "Non inclus",
      "planner.comparison.flexibility": "Flexibilité",
      "planner.comparison.refundable": "Remboursable",
      "planner.comparison.changeable": "Modifiable",
      "planner.comparison.notFlexible": "Non flex.",
      "planner.comparison.perPerson": "/pers.",

      // Planner - Hotel Comparison
      "planner.comparison.hotel.bestPrice": "Meilleur prix",
      "planner.comparison.hotel.bestRated": "Mieux noté",
      "planner.comparison.hotel.bestLocation": "Meilleur emplacement",
      "planner.comparison.hotel.bestValue": "Meilleur rapport Q/P",
      "planner.comparison.hotel.recommended": "Recommandé",
      "planner.comparison.hotel.reviews": "avis",
      "planner.comparison.hotel.breakfastIncluded": "Petit-déj inclus",
      "planner.comparison.hotel.freeCancellation": "Annulation gratuite",
      "planner.comparison.hotel.perNight": "/nuit",
      "planner.comparison.hotel.total": "Total",
      "planner.comparison.hotel.nights": "nuits",
      "planner.comparison.hotel.cheaper": "Moins cher",
      "planner.comparison.hotel.betterRated": "Mieux noté",
      "planner.comparison.hotel.book": "Réserver",
      "planner.comparison.hotel.amenities": "Équipements",
      "planner.comparison.hotel.cancellation": "Annulation",
      "planner.comparison.hotel.free": "Gratuite",
      "planner.comparison.hotel.nonRefundable": "Non remb.",
      "planner.comparison.hotel.payment": "Paiement",
      "planner.comparison.hotel.onSite": "Sur place",
      "planner.comparison.hotel.now": "Maintenant",

      // Planner - Weather
      "planner.weather.noForecast": "Aucune prévision météo disponible",
      "planner.weather.weatherAt": "Météo à {{location}}",
      "planner.weather.days": "jours",
      "planner.weather.avgTemp": "Moy.",
      "planner.weather.rainyDay": "jour de pluie",
      "planner.weather.rainyDays": "jours de pluie",
      "planner.weather.precipitation": "Précipitations",
      "planner.weather.wind": "Vent",
      "planner.weather.humidity": "Humidité",
      "planner.weather.today": "Aujourd'hui",
      "planner.weather.tomorrow": "Demain",
      "planner.weather.sunny": "Ensoleillé",
      "planner.weather.partlyCloudy": "Partiellement nuageux",
      "planner.weather.cloudy": "Nuageux",
      "planner.weather.rainy": "Pluvieux",
      "planner.weather.stormy": "Orageux",
      "planner.weather.snowy": "Neigeux",
      "planner.weather.foggy": "Brumeux",
      "planner.weather.windy": "Venteux",

      // Planner - Recommendation
      "planner.recommendation.recommendedForYou": "Recommandé pour vous",
      "planner.recommendation.select": "Sélectionner",
      "planner.recommendation.details": "Détails",
      "planner.recommendation.perPerson": "/pers.",

      // Planner - Calendar
      "planner.calendar.bestPrice": "Meilleur prix",
      "planner.calendar.confirmDates": "Confirmer les dates",
      "planner.calendar.prices": "Prix",
      "planner.calendar.weather": "Météo",
      "planner.calendar.selectAirports": "Sélectionnez un aéroport de départ et d'arrivée pour voir les prix",
      "planner.calendar.outbound": "Aller",
      "planner.calendar.return": "Retour",

      // Planner - AI Conflict Badge
      "planner.ai.suggests": "L'IA suggère",
      "planner.ai.detectedValueDifferent": "Valeur détectée différente de votre sélection",
      "planner.ai.applySuggestion": "Appliquer la suggestion",
      "planner.ai.ignore": "Ignorer",

      // Planner - Compact Cards
      "planner.flight.direct": "Direct",
      "planner.flight.stopover": "{{count}} escale",
      "planner.flight.stopovers": "{{count}} escales",
      "planner.flight.outbound": "Aller",
      "planner.flight.return": "Retour",
      "planner.common.perPerson": "/personne",
      "planner.common.reviews": "avis",
      "planner.hotel.perNight": "/nuit",
      "planner.hotel.night": "nuit",
      "planner.hotel.nights": "nuits",
      "planner.hotel.total": "total",
      "planner.activity.instantConfirmation": "Confirmation instantanée",
      "planner.activity.freeCancellation": "Annulation gratuite",
      "planner.activity.availableFrom": "Dispo",

      // Planner - Proactive Alerts
      "planner.alert.historicLow": "Prix historiquement bas !",
      "planner.alert.priceDrop": "Baisse de prix !",
      "planner.alert.priceDropMessage": "Le prix {{itemType}} \"{{itemName}}\" a baissé.",
      "planner.alert.itemFlight": "du vol",
      "planner.alert.itemHotel": "de l'hôtel",
      "planner.alert.itemActivity": "de l'activité",
      "planner.alert.viewOffer": "Voir l'offre",
      "planner.alert.bookNow": "Réserver maintenant",
      "planner.alert.priceIncrease": "Prix en hausse",
      "planner.alert.priceIncreaseMessage": "Le prix a augmenté de {{percent}}%. Réservez rapidement avant une nouvelle hausse.",
      "planner.alert.limitedAvailability": "Disponibilité limitée",
      "planner.alert.lastSpots": "Dernières places !",
      "planner.alert.spotsRemaining": "Plus que {{count}} places disponibles.",
      "planner.alert.lastSpotRemaining": "Il ne reste que {{count}} place !",
      "planner.alert.lastSpotsRemaining": "Il ne reste que {{count}} places !",
      "planner.alert.lastMinuteOffer": "Offre de dernière minute",
      "planner.alert.book": "Réserver",
      "planner.alert.departureClose": "Départ très proche !",
      "planner.alert.timeToBook": "Il est temps de réserver",
      "planner.alert.departureCloseMessage": "Votre départ est dans {{days}} jours et vous n'avez pas encore de vol. Les prix augmentent fortement à l'approche du départ.",
      "planner.alert.timeToBookMessage": "Votre départ est dans {{days}} jours. Réservez vos vols maintenant pour les meilleurs prix.",
      "planner.alert.searchFlights": "Rechercher des vols",
      "planner.alert.peakSeason": "Très haute saison",
      "planner.alert.highSeason": "Haute saison",
      "planner.alert.peakSeasonMessage": "C'est la très haute saison à {{city}}. Attendez-vous à des prix {{percent}}% plus élevés et des sites très fréquentés.",
      "planner.alert.highSeasonMessage": "C'est la haute saison à {{city}}. Les prix sont environ {{percent}}% plus élevés que d'habitude.",
      "planner.alert.viewOtherDates": "Voir d'autres dates",

      // Planner - Contextual Suggestions
      "planner.suggestion.lowSeason": "Bonne nouvelle ! Vous voyagez en basse saison à {{destination}}. Les prix sont environ {{percent}}% moins chers et les sites moins fréquentés.",
      "planner.suggestion.shoulderSeason": "Vous voyagez en intersaison à {{destination}}. C'est un bon compromis entre prix et affluence.",
      "planner.suggestion.highSeasonMessage": "Attention, vous voyagez en haute saison à {{destination}}. Attendez-vous à des prix {{percent}}% plus élevés.",
      "planner.suggestion.peakSeasonMessage": "C'est la très haute saison à {{destination}} ! Les prix sont {{percent}}% plus élevés et les sites très fréquentés. Réservez tôt !",
      "planner.suggestion.lowSeasonTitle": "Basse saison 👍",
      "planner.suggestion.shoulderSeasonTitle": "Intersaison",
      "planner.suggestion.highSeasonTitle": "Haute saison ⚠️",
      "planner.suggestion.peakSeasonTitle": "Très haute saison 🔥",
      "planner.suggestion.viewOtherDates": "Voir d'autres dates",
      "planner.suggestion.savingsFlights": "Économisez sur les vols",
      "planner.suggestion.savingsFlightsMessage": "Les vols sont généralement 20-30% moins chers en milieu de semaine (mardi-mercredi).",
      "planner.suggestion.modifyDates": "Modifier les dates",
      "planner.suggestion.alternativeAccommodation": "Alternatives d'hébergement",
      "planner.suggestion.alternativeAccommodationMessage": "Des options plus économiques existent. Appartements et auberges offrent souvent un meilleur rapport qualité-prix.",
      "planner.suggestion.earlyBooking": "Réservation anticipée",
      "planner.suggestion.earlyBookingMessage": "Vous partez dans plus de 2 mois. Les meilleurs prix sont souvent disponibles 6-8 semaines avant le départ.",
      "planner.suggestion.lateBooking": "Réservation tardive",
      "planner.suggestion.lateBookingMessage": "Votre départ approche ! Les prix peuvent augmenter rapidement. Réservez dès que possible.",

      // Planner - Step Tips
      "planner.tip.destination": "Astuce",
      "planner.tip.destinationMessage": "Vous pouvez indiquer un pays ou une région, et je vous proposerai les meilleures villes à visiter.",
      "planner.tip.datesFlexible": "Dates flexibles ?",
      "planner.tip.datesFlexibleMessage": "Si vos dates sont flexibles, indiquez-le moi. Je peux trouver les jours les moins chers.",
      "planner.tip.familyTravel": "Voyage en famille ?",
      "planner.tip.familyTravelMessage": "Si vous voyagez avec des enfants, je privilégierai les hébergements et activités adaptés.",
      "planner.tip.compareOptions": "Comparer les options",
      "planner.tip.compareOptionsMessage": "Les vols avec escale sont souvent moins chers. Je peux vous montrer les deux options.",
      "planner.tip.locationKey": "Emplacement clé",
      "planner.tip.locationKeyMessage": "Un hôtel bien situé peut vous faire économiser sur les transports. Je prends en compte la proximité des sites.",
      "planner.tip.localExperiences": "Expériences locales",
      "planner.tip.localExperiencesMessage": "Je peux vous suggérer des activités basées sur vos intérêts : culture, gastronomie, aventure...",
      "planner.tip.airportTransfers": "Transferts aéroport",
      "planner.tip.airportTransfersMessage": "Réserver un transfert privé peut être plus économique qu'un taxi, surtout à plusieurs.",

      // Planner - Quick Replies
      "planner.quickReply.planTrip": "Planifier un voyage",
      "planner.quickReply.getInspired": "M'inspirer",
      "planner.quickReply.resumeTrip": "Reprendre mon voyage",
      "planner.quickReply.beach": "Plage & soleil ☀️",
      "planner.quickReply.cityBreak": "City break 🏙️",
      "planner.quickReply.nature": "Nature & aventure 🏔️",
      "planner.quickReply.culture": "Culture & histoire 🏛️",
      "planner.quickReply.flexibleDates": "Dates flexibles",
      "planner.quickReply.nextWeekend": "Prochain week-end",
      "planner.quickReply.oneWeek": "Une semaine",
      "planner.quickReply.solo": "Solo",
      "planner.quickReply.couple": "En couple",
      "planner.quickReply.family": "En famille",
      "planner.quickReply.group": "En groupe",
      "planner.quickReply.cheapest": "Le moins cher",
      "planner.quickReply.directFlights": "Vols directs",
      "planner.quickReply.morningDeparture": "Départ le matin",
      "planner.quickReply.budget": "Petit budget",
      "planner.quickReply.center": "Centre-ville",
      "planner.quickReply.fourStar": "4 étoiles +",
      "planner.quickReply.popular": "Les plus populaires",
      "planner.quickReply.freeActivities": "Activités gratuites",
      "planner.quickReply.skipStep": "Passer cette étape",
      "planner.quickReply.privateTransfer": "Transfert privé",
      "planner.quickReply.sharedShuttle": "Navette partagée",
      "planner.quickReply.noNeed": "Pas besoin",
      "planner.quickReply.modifySomething": "Modifier quelque chose",
      "planner.quickReply.perfect": "C'est parfait ! ✓",
      "planner.quickReply.bookAll": "Tout réserver",
      "planner.quickReply.bookLater": "Réserver plus tard",

      // Planner - Missing Fields
      "planner.missing.departure": "ville de départ",
      "planner.missing.arrival": "destination",
      "planner.missing.departureDate": "date de départ",
      "planner.missing.returnDate": "date de retour",
      "planner.missing.passengers": "nombre de voyageurs",
      "planner.missing.legs": "étapes du voyage",
      "planner.missing.readyToSearch": "Aucun - prêt à chercher",

      // Planner - Action Buttons
      "planner.action.added": "Ajouté",
      "planner.action.selectFlight": "Sélectionner ce vol",
      "planner.action.bookHotel": "Réserver cet hôtel",
      "planner.action.addActivity": "Ajouter cette activité",
      "planner.action.addToTrip": "Ajouter au voyage",
      "planner.action.maxItems": "Maximum {{count}} éléments",
      "planner.action.removeFromCompare": "Retirer de la comparaison",
      "planner.action.compare": "Comparer",
      "planner.action.remove": "Retirer",
      "planner.action.removeFromFavorites": "Retirer des favoris",
      "planner.action.save": "Sauvegarder",
      "planner.action.saved": "Sauvegardé",
      "planner.action.viewDetails": "Voir détails",
      
      // Planner - Travelers Widget (additional keys)
      "planner.travelers.travelingAlone": "Vous partez <strong>seul(e)</strong> ?",
      "planner.travelers.adultSingular": "{{count}} adulte",
      "planner.travelers.adultPlural": "{{count}} adultes",
      "planner.travelers.childSingular": "{{count}} enfant",
      "planner.travelers.childPlural": "{{count}} enfants",
      "planner.travelers.infantSingular": "{{count}} bébé",
      "planner.travelers.infantPlural": "{{count}} bébés",
      
      // Planner - Missing Fields Card
      "planner.missingFields.infoMissing": "Informations manquantes",
      "planner.missingFields.readyToSearch": "Prêt à rechercher",
      "planner.missingFields.required": "requis",
      "planner.missingFields.optional": "Optionnel",
      "planner.missingFields.fieldRequired": "{{label}} requis",
      "planner.missingFields.destination": "Destination",
      "planner.missingFields.departureDate": "Date de départ",
      "planner.missingFields.returnDate": "Date de retour",
      "planner.missingFields.travelersLabel": "Voyageurs",
      
      // Planner - Trip Summary
      "planner.tripSummary.tripTo": "Voyage à {{city}}",
      "planner.tripSummary.yourTrip": "Votre voyage",
      "planner.tripSummary.nights": "nuits",
      "planner.tripSummary.flight": "Vol",
      "planner.tripSummary.hotel": "Hôtel",
      "planner.tripSummary.activitiesCount": "{{count}} activité",
      "planner.tripSummary.activitiesCountPlural": "{{count}} activités",
      "planner.tripSummary.total": "Total",
      
      // Planner - Map Preview (additional keys)
      "planner.map.itinerary": "Itinéraire",
      "planner.map.yourItinerary": "Votre itinéraire",
      "planner.map.searchInArea": "Rechercher dans cette zone",
      "planner.map.searchingInArea": "Recherche...",
      "planner.map.searchInAreaTitle": "Rechercher des activités dans la zone visible",
      "planner.map.searchingTitle": "Recherche en cours...",
      
      // Planner - Destination Suggestions
      "planner.suggestions.analyzingPreferences": "Analyse de vos préférences...",
      "planner.suggestions.searchingDestinations": "Recherche des meilleures destinations",
      "planner.suggestions.noSuggestions": "Aucune suggestion disponible",
      "planner.suggestions.basedOnProfile": "Recommandations basées sur votre profil",
      "planner.suggestions.profileComplete": "({{score}}% complété)",
      "planner.suggestions.previousDestination": "Destination précédente",
      "planner.suggestions.nextDestination": "Destination suivante",
      "planner.suggestions.goToDestination": "Aller à la destination {{index}}",
      "planner.suggestions.swipeHint": "← Glissez pour voir plus de destinations →",
      
      // Planner - Airport Widgets
      "planner.airport.departure": "Départ",
      "planner.airport.arrival": "Arrivée",
      "planner.airport.recommended": "recommandé",
      "planner.airport.bestChoice": "Meilleur choix",
      "planner.airport.kmFromCenter": "{{km}} km du centre",
      "planner.airport.accept": "Accepter",
      "planner.airport.seeOthers": "Voir les autres",
      "planner.airport.confirmedAirports": "Aéroports confirmés",
      "planner.airport.airportSelection": "Sélection des aéroports",
      "planner.airport.availableDeparture": "Aéroports de départ disponibles",
      "planner.airport.availableArrival": "Aéroports d'arrivée disponibles",
      "planner.airport.closest": "Le plus proche",
      "planner.airport.farthest": "Plus éloigné",
      "planner.airport.majorInternational": "Aéroport international majeur",
      "planner.airport.moreFlights": "Plus de vols disponibles",
      "planner.airport.betterConnection": "Meilleure connexion",
      "planner.airport.quickAccess": "Accès rapide depuis le centre",
      "planner.airport.lessFlightChoice": "Moins de choix de vols",
      "planner.airport.searchingFlights": "Recherche en cours...",
      "planner.airport.searchFlights": "Rechercher {{count}} vol",
      "planner.airport.searchFlightsPlural": "Rechercher {{count}} vols",
      
      // Planner - Cabin Class
      "planner.cabin.economy": "Économique",
      "planner.cabin.economyShort": "Éco",
      "planner.cabin.economyDesc": "Prix avantageux",
      "planner.cabin.premiumEconomy": "Premium Éco",
      "planner.cabin.premiumShort": "Premium",
      "planner.cabin.premiumDesc": "Plus d'espace",
      "planner.cabin.business": "Business",
      "planner.cabin.businessDesc": "Confort supérieur",
      "planner.cabin.first": "Première",
      "planner.cabin.firstShort": "1ère",
      "planner.cabin.firstDesc": "Luxe & exclusivité",
      
      // Planner - Budget
      "planner.budget.label": "Budget",
      
      // Planner - Hotel Search
      "planner.hotelSearch.accommodationsIn": "Hébergements à {{destination}}",
      "planner.hotelSearch.searchingInProgress": "Recherche en cours...",
      "planner.hotelSearch.resultsCount": "{{count}} résultats · {{nights}} nuit",
      "planner.hotelSearch.resultsCountPlural": "{{count}} résultats · {{nights}} nuits",
      
      // Planner - Search Buttons
      "planner.search.searchFlightsNow": "Rechercher les vols maintenant",
      "planner.search.search": "Rechercher",
      "planner.search.searching": "Recherche...",
      
      // Planner - Inspire Flow
      "planner.inspire.excellentChoice": "Excellent choix ! **{{country}}** est une destination parfaite pour vous.",
      "planner.inspire.searchingCities": "Je recherche les villes principales...",
      "planner.inspire.whichCity": "Quelle ville souhaitez-vous visiter ?",
      "planner.inspire.typeCity": "Quelle ville souhaitez-vous visiter ? Tapez le nom dans le chat.",
      "planner.inspire.importantCity": "Ville importante",
      
      // Planner - Navigation
      "planner.nav.tabNavigation": "Navigation des onglets",
      
      // Planner - Date Picker Labels
      "planner.datePicker.chooseDepartureDate": "Choisir la date de départ",
      "planner.datePicker.chooseReturnDate": "Choisir la date de retour",
      
      // Planner - Dual Airport Labels
      "planner.dualAirport.departure": "Départ",
      "planner.dualAirport.arrival": "Arrivée",

      // ============================================
      // LANDING PAGE "/" - Traductions complètes
      // ============================================

      // Landing - Hero Section
      "landing.hero.title": "Où veux-tu partir ?",
      "landing.hero.scrollIndicator": "Voir comment ça marche",
      "landing.hero.planButton": "Planifier",
      "landing.hero.ariaLabel": "Décris ton voyage idéal",

      // Landing - Quick Actions
      "landing.quickActions.inspireme": "Inspire-moi",
      "landing.quickActions.inspiremeMsg": "Inspire-moi pour mon prochain voyage",
      "landing.quickActions.weekend": "Weekend au soleil",
      "landing.quickActions.weekendMsg": "Je veux partir en weekend au soleil",
      "landing.quickActions.citybreak": "City break Europe",
      "landing.quickActions.citybreakMsg": "City break en Europe, quelle ville me recommandes-tu ?",
      "landing.quickActions.romantic": "Escapade romantique",
      "landing.quickActions.romanticMsg": "Je cherche une destination romantique pour 2",
      "landing.quickActions.cheapflight": "Vol pas cher",
      "landing.quickActions.cheapflightMsg": "Trouve-moi les vols les moins chers depuis Paris",

      // Landing - Destinations
      "landing.destinations.title": "Où partir ?",
      "landing.destinations.subtitle": "Clique sur une destination et laisse-moi t'aider à planifier ton voyage idéal",
      "landing.destinations.planAction": "Planifier",
      "landing.destinations.barcelona.title": "Barcelone",
      "landing.destinations.barcelona.subtitle": "City break culturel",
      "landing.destinations.barcelona.duration": "3-5 jours",
      "landing.destinations.barcelona.query": "City break à Barcelone, que me recommandes-tu ?",
      "landing.destinations.lisbon.title": "Lisbonne",
      "landing.destinations.lisbon.subtitle": "Charme portugais",
      "landing.destinations.lisbon.duration": "4-6 jours",
      "landing.destinations.lisbon.query": "Voyage à Lisbonne, aide-moi à planifier",
      "landing.destinations.rome.title": "Rome",
      "landing.destinations.rome.subtitle": "Histoire & Gastronomie",
      "landing.destinations.rome.duration": "4-7 jours",
      "landing.destinations.rome.query": "Escapade à Rome, suggestions d'itinéraire",
      "landing.destinations.marrakech.title": "Marrakech",
      "landing.destinations.marrakech.subtitle": "Évasion orientale",
      "landing.destinations.marrakech.duration": "5-7 jours",
      "landing.destinations.marrakech.query": "Voyage à Marrakech, je veux découvrir les souks et riads",
      "landing.destinations.santorini.title": "Santorin",
      "landing.destinations.santorini.subtitle": "Îles grecques",
      "landing.destinations.santorini.duration": "5-7 jours",
      "landing.destinations.santorini.query": "Santorin en amoureux, aide-moi à organiser",
      "landing.destinations.tokyo.title": "Tokyo",
      "landing.destinations.tokyo.subtitle": "Immersion japonaise",
      "landing.destinations.tokyo.duration": "10-14 jours",
      "landing.destinations.tokyo.query": "Voyage au Japon, Tokyo et environs",

      // Landing - How It Works
      "landing.howItWorks.title": "Comment ça marche (vraiment)",
      "landing.howItWorks.subtitle": "3 étapes. Une conversation. Un voyage prêt.",
      "landing.howItWorks.step1.title": "Tu me dis ce que tu veux",
      "landing.howItWorks.step1.desc": "Destination, dates, budget… en une phrase. Pas de formulaire interminable.",
      "landing.howItWorks.step1.example": "\"Barcelone, 4 jours, 700€, en couple\"",
      "landing.howItWorks.step2.title": "Je te propose un plan clair",
      "landing.howItWorks.step2.desc": "Vols, hôtels, activités — une première version cohérente, facile à lire.",
      "landing.howItWorks.step2.example": "3 options + recommandations",
      "landing.howItWorks.step3.title": "Tu ajustes, puis tu reçois tout",
      "landing.howItWorks.step3.desc": "Tu modifies ce que tu veux, puis tu récupères ton itinéraire prêt à réserver.",
      "landing.howItWorks.step3.example": "Liens + récapitulatif (PDF en Pro)",
      "landing.howItWorks.examplePrefix": "Ex :",

      // Landing - Features
      "landing.features.title": "Pourquoi Travliaq ?",
      "landing.features.subtitle": "Simple, rapide, gratuit.",
      "landing.features.free.title": "100% Gratuit",
      "landing.features.free.desc": "Pas de carte bancaire requise, pas d'inscription obligatoire.",
      "landing.features.fast.title": "Résultat en 2 min",
      "landing.features.fast.desc": "Dis-nous tes envies, on s'occupe du reste.",
      "landing.features.custom.title": "100% Sur-mesure",
      "landing.features.custom.desc": "Un itinéraire personnalisé selon tes goûts.",
      "landing.features.benefits.comparison": "Comparaison des prix",
      "landing.features.benefits.spots": "Spots cachés",
      "landing.features.benefits.rhythm": "Adapté à ton rythme",
      "landing.features.benefits.nosurprise": "Sans surprises",

      // Landing - Partners
      "landing.partners.title": "Nos partenaires",

      // Landing - Final CTA
      "landing.cta.title": "Dis-moi où tu veux aller",
      "landing.cta.subtitle": "Je m'occupe du reste. Vol, hôtel, activités – tout sera prêt en quelques minutes.",
      "landing.cta.free": "100% gratuit",
      "landing.cta.noSignup": "Sans inscription",
      "landing.cta.fastResults": "Résultats en 2 min",

      // Landing - Animated Placeholders
      "landing.placeholders.0": "Trouve-moi un vol pas cher pour Barcelone...",
      "landing.placeholders.1": "Week-end romantique à Rome en février...",
      "landing.placeholders.2": "Road trip en Espagne pour 2 semaines...",
      "landing.placeholders.3": "Aide-moi à planifier une semaine en Italie...",
      "landing.placeholders.4": "Voyage en famille au Portugal cet été...",
      "landing.placeholders.5": "City break à Lisbonne ce week-end...",

      // Landing - FAQ
      "landing.faq.title": "Questions fréquentes",
      "landing.faq.subtitle": "Tout ce que tu dois savoir avant de commencer",
      "landing.faq.q1": "C'est quoi Travliaq exactement ?",
      "landing.faq.a1": "Travliaq est ton assistant voyage IA personnel. Tu lui dis où tu veux aller, ton budget, tes dates, et il te crée un itinéraire sur-mesure avec vols, hôtels et activités. Tout ça en quelques minutes au lieu de plusieurs heures.",
      "landing.faq.q2": "C'est gratuit ?",
      "landing.faq.a2": "Oui, la planification de base est gratuite ! Tu peux créer des itinéraires et obtenir des recommandations sans frais. Des options premium sont disponibles pour plus de fonctionnalités comme le téléchargement PDF ou la personnalisation avancée.",
      "landing.faq.q3": "Comment ça marche concrètement ?",
      "landing.faq.a3": "Tu discutes avec moi comme avec un ami. Tu me dis tes envies (destination, dates, budget, style de voyage) et je te propose un itinéraire complet. Tu peux affiner, modifier, et quand tu es satisfait, tu reçois tout par email.",
      "landing.faq.q4": "Je peux modifier mon itinéraire après ?",
      "landing.faq.a4": "Absolument ! Tu peux revenir dessus à tout moment. Change les dates, ajoute des activités, modifie l'hôtel... Je m'adapte en temps réel à tes demandes.",
      "landing.faq.q5": "Les prix sont-ils fiables ?",
      "landing.faq.a5": "Je compare les prix en temps réel avec les principales plateformes de réservation. Les prix affichés sont ceux que tu retrouveras au moment de la réservation (aux variations normales près).",
      "landing.faq.q6": "Quelles destinations sont disponibles ?",
      "landing.faq.a6": "Travliaq couvre le monde entier ! Que tu rêves de Tokyo, New York, Marrakech, Bali ou d'un road trip en Patagonie, notre IA trouve les meilleures options pour n'importe quelle destination.",
      "landing.faq.q7": "Combien de temps faut-il pour recevoir mon itinéraire ?",
      "landing.faq.a7": "En général, tu reçois ta première proposition dans les 24 heures suivant ta demande. Pour les demandes urgentes, nous pouvons accélérer le processus.",
      "landing.faq.q8": "Puis-je voyager en groupe ou en famille ?",
      "landing.faq.a8": "Bien sûr ! Travliaq s'adapte à tous les types de voyageurs : solo, duo, groupe d'amis ou famille avec enfants. L'itinéraire sera personnalisé en fonction du nombre de participants et de leurs besoins spécifiques.",
      "landing.faq.q9": "Comment mes données sont-elles protégées ?",
      "landing.faq.a9": "Tes données sont sécurisées et ne sont jamais partagées avec des tiers sans ton consentement. Nous utilisons les meilleures pratiques de sécurité et respectons le RGPD.",
      "landing.faq.q10": "Comment contacter le support ?",
      "landing.faq.a10": "Tu peux nous contacter à tout moment via contact@travliaq.com. Notre équipe répond généralement sous 24h. Tu peux aussi utiliser le chat intégré pour des questions rapides.",

      // Landing - Footer
      "landing.footer.description": "Ton assistant voyage IA personnel. De l'inspiration au départ, je t'accompagne.",
      "landing.footer.navigation": "Navigation",
      "landing.footer.home": "Accueil",
      "landing.footer.planner": "Planifier",
      "landing.footer.blog": "Blog",
      "landing.footer.discover": "Découvrir",
      "landing.footer.legal": "Légal",
      "landing.footer.cgv": "Conditions Générales de Vente",
      "landing.footer.privacy": "Politique de confidentialité",
      "landing.footer.mentions": "Mentions légales",
      "landing.footer.contact": "Contact",
      "landing.footer.followUs": "Suivez-nous",
      "landing.footer.copyright": "© {{year}} Travliaq. Tous droits réservés.",

      // ============================================
      // PLANNER PAGE "/planner" - Traductions supplémentaires
      // ============================================

      // Planner - Meta & Page
      "planner.meta.title": "Planificateur | Travliaq",
      "planner.meta.description": "Planifiez votre voyage avec notre assistant intelligent. Comparez vols, activités et hébergements sur une carte interactive.",
      "planner.leaveConfirmation": "Vous avez une conversation en cours. Quitter le planner ?",

      // Planner - Accommodation Toasts
      "planner.accommodation.toast.synced": "Hébergements synchronisés",
      "planner.accommodation.toast.syncedDesc": "{{count}} destination mise à jour depuis vos vols",
      "planner.accommodation.toast.syncedDescPlural": "{{count}} destinations mises à jour depuis vos vols",
      "planner.accommodation.toast.incompleteDestination": "Destination incomplète",
      "planner.accommodation.toast.incompleteDestinationDesc": "Sélectionnez une ville dans la liste (pas seulement du texte) pour récupérer le pays et les coordonnées.",
      "planner.accommodation.toast.missingDates": "Dates manquantes",
      "planner.accommodation.toast.missingDatesDesc": "Choisissez une date d'arrivée et une date de départ pour lancer la recherche d'hébergements.",
      "planner.accommodation.toast.noResults": "Aucun résultat",
      "planner.accommodation.toast.noResultsDesc": "Aucun hôtel trouvé pour ces critères",
      "planner.accommodation.toast.searchError": "Impossible de rechercher les hôtels",
      "planner.accommodation.toast.searchErrorTitle": "Erreur de recherche",
      "planner.accommodation.toast.locationError": "Localisation impossible",
      "planner.accommodation.toast.locationErrorDesc": "Impossible de déterminer la ville à cet emplacement",
      "planner.accommodation.toast.newArea": "Nouvelle zone",
      "planner.accommodation.toast.newAreaFound": "{{count}} hébergements trouvés à {{city}}",
      "planner.accommodation.toast.noHotelInCity": "Aucun hôtel trouvé à {{city}}",
      "planner.accommodation.toast.error": "Erreur",
      "planner.accommodation.toast.areaSearchError": "Impossible de rechercher dans cette zone",
      "planner.accommodation.toast.selectDatesFirst": "Veuillez d'abord sélectionner des dates",
      "planner.accommodation.toast.destinationAdded": "Destination ajoutée",
      "planner.accommodation.toast.destinationAddedDesc": "{{name}} a été ajouté à vos hébergements",
      "planner.accommodation.toast.booking": "Réservation",
      "planner.accommodation.toast.bookingSoon": "La réservation sera bientôt disponible !",

      // Planner - PlannerCard
      "planner.card.perNight": "/nuit",
      "planner.card.fromCity": "Depuis {{city}}",
      "planner.card.duration": "Durée",
      "planner.card.addToTrip": "Ajouter à mon voyage",

      // Planner - FlightPriceMarkers
      "planner.flights.departureMarker": "Départ",

      // Planner - Chat Messages
      "planner.chat.activitiesContext": "[ACTIVITÉS] {{count}} activité(s) planifiée(s)",
      "planner.chat.preferencesContext": "[PRÉFÉRENCES] Rythme: {{pace}}, Style: {{style}}, Intérêts: {{interests}}, Confort: {{comfort}}",
      "planner.chat.activityTitle": "Titre",
      "planner.chat.activityDescription": "Description",
      "planner.chat.activityHighlights": "Points forts",
      "planner.chat.activityBudget": "Budget",
      "planner.chat.errorMessage": "Désolé, une erreur s'est produite. Veuillez réessayer.",
      "planner.chat.errorOccurred": "Désolé, une erreur s'est produite. Veuillez réessayer.",
      "planner.chat.excellentChoice": "Excellent choix ! **{{country}}** est une destination parfaite pour vous.",
      "planner.chat.searchingCities": "Je recherche les villes principales...",
      "planner.chat.importantCity": "Ville importante",
      "planner.chat.whichCityToVisit": "Quelle ville souhaitez-vous visiter ?",
      "planner.chat.searchFlightsNow": "Rechercher les vols maintenant",
      "planner.chat.selectInterests": "Sélectionnez vos centres d'intérêt :",
      "planner.chat.adjustTravelStyle": "Ajustez votre style de voyage :",
      "planner.chat.nothingElseToAdd": "Rien d'autre à ajouter. Fais-moi 3 recommandations de destinations selon mon profil.",
      "planner.chat.specifyInterests": "J'aimerais préciser mes centres d'intérêt.",
      "planner.chat.adjustMyStyle": "J'aimerais ajuster mon style de voyage.",
      "planner.chat.mandatoryCriteria": "J'ai des critères obligatoires à préciser.",
      "planner.chat.dietaryRestrictions": "J'ai des restrictions alimentaires à préciser.",
      "planner.chat.chooseBestDestination": "Choisis la meilleure destination pour moi parmi celles affichées et explique pourquoi.",

      // Planner - YouTubeShortsPanel
      "planner.youtube.thingsToDo": "À faire à {{city}}",
      "planner.youtube.videoPreview": "Aperçu vidéo {{city}}",

      // Planner - Preferences
      "planner.preferences.wellness": "Bien-être",
      "planner.preferences.party": "Fête",
      "planner.preferences.remote": "Télétravail",
      "planner.preferences.discovery": "Découverte",
      "planner.preferences.accessibility": "Accessibilité PMR",
      "planner.preferences.wifi": "WiFi Haut Débit",
      "planner.preferences.childFriendly": "Adapté enfants",
      "planner.preferences.relaxed": "Détente",
      "planner.preferences.intense": "Intense",
      "planner.preferences.vegetarian": "Végétarien",
      "planner.preferences.vegan": "Végan",
      "planner.preferences.pescatarian": "Pescétarien",
      "planner.preferences.noEggs": "Sans œufs",
      "planner.preferences.nuts": "Fruits à coque",
      "planner.preferences.criteria": "Critères",

      // Planner - SmartTags
      "planner.smartTags.adventurer": "#Aventurier",
      "planner.smartTags.explorer": "#Explorateur",
      "planner.smartTags.relaxation": "#Détente",
      "planner.smartTags.cultural": "#Culturel",
      "planner.smartTags.foodie": "#Foodie",
      "planner.smartTags.nature": "#Nature",
      "planner.smartTags.romantic": "#Romantique",
      "planner.smartTags.family": "#Famille",
      "planner.smartTags.budget": "#Économique",
      "planner.smartTags.luxury": "#Luxe",
      "planner.smartTags.generatePrompt": "Génère les 3 hashtags qui me décrivent le mieux.",

    },
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.blog": "Blog",
      "nav.discover": "Discover",
      "nav.admin": "Admin",
      "nav.login": "Login",
      "nav.logout": "Logout",
      "nav.comparison": "Comparison",
      "nav.howItWorks": "How it works",
      "nav.examples": "Examples",
      "nav.whyUs": "Why us",
      "nav.faq": "FAQ",
      "nav.questionnaire": "Questionnaire",

      // User Preferences
      "preferences.currency": "Currency",
      "preferences.chooseCurrency": "Choose a currency",
      "preferences.language": "Language",
      "preferences.chooseLanguage": "Choose a language",
      "preferences.temperature": "Temperature",
      
      // Currencies
      "currency.EUR": "Euro",
      "currency.USD": "US Dollar",
      "currency.GBP": "British Pound",
      
      // Languages
      "language.fr": "Français",
      "language.en": "English",
      "language.es": "Español",
      
      // User Menu
      "userMenu.blog": "Blog",
      "userMenu.newTrip": "New trip",
      "userMenu.myTrips": "My trips",
      "userMenu.planner": "Planner",
      "userMenu.settings": "Settings",
      "userMenu.about": "About",
      "userMenu.contact": "Contact",
      "userMenu.terms": "Terms of Service",
      "userMenu.login": "Login",
      "userMenu.logout": "Logout",

      // Hero Section
      "hero.title": "Your trip,",
      "hero.title.ai": "AI-optimized",
      "hero.subtitle":
        "Discover your next personalized itinerary — flights, hotels, weather, activities, all in one click.",
      "hero.subtitle.user":
        "{{name}}, discover your next personalized itinerary — flights, hotels, weather, activities, all in one click.",
      "hero.cta": "Create your itinerary",

      // How it works
      "howItWorks.title": "How does it work?",
      "howItWorks.description": " simplifies your trip in 4 steps:",
      "howItWorks.step1": "You tell us your wishes (destination, budget, style).",
      "howItWorks.step2":
        "We compare flights, accommodations and activities in real time (prices, weather, distances).",
      "howItWorks.step3": "We create a clear, optimized day-by-day itinerary that respects your budget.",
      "howItWorks.step4":
        "You receive a personalized proposal with detailed pricing and a single link to book everything in a few clicks.",
      "howItWorks.tagline": "Fewer tabs, more adventure.",

      // Steps details
      "step1.title": "Your wishes",
      "step1.description": "Share your travel wishes for a 100% personalized itinerary.",
      "step1.dest": "Tell us your destination:",
      "step1.dest.desc":
        "whether it's Lisbon, Tokyo or just your departure airport, so Travliaq can find the best options.",
      "step1.dates": "Specify your dates:",
      "step1.dates.desc": "fixed or flexible, to optimize prices and weather, and guarantee you perfect timing.",
      "step1.budget": "Share your budget and travel style:",
      "step1.budget.desc": "solo, backpacking, comfort or premium, we adapt each step to your pace and wishes.",

      "step2.title": "Smart search",
      "step2.description": "Our AI analyzes thousands of options to find the best combinations.",
      "step2.scan": "We scan the best options:",
      "step2.scan.desc": "flights, accommodations and activities, from reliable sources updated in real time.",
      "step2.cross": "We cross-reference prices, weather and logistics:",
      "step2.cross.desc": "so each step flows naturally, without wasting time or budget.",
      "step2.filter": "We filter according to your profile:",
      "step2.filter.desc": "solo, backpacker, comfort or premium, each result is adjusted to your priorities.",

      "step3.title": "Optimized itinerary",
      "step3.description": "Receive a detailed day-by-day program, perfectly tailored to your preferences.",
      "step3.program": "Day-by-day program:",
      "step3.program.desc":
        "activities, visits, breaks and meals organized in a logical order, to enjoy without rushing.",
      "step3.budget": "Controlled budget:",
      "step3.budget.desc": "each step is priced to avoid bad surprises, from the flight to the corner café.",
      "step3.tips": "Integrated local tips:",
      "step3.tips.desc": "photo spots, hidden restaurants, smart transport... as if a friend on site was guiding you.",

      "step4.title": "Trip ready to book",
      "step4.description": "Everything is ready! You just need to book in a few clicks.",
      "step4.email": "Complete itinerary sent by email:",
      "step4.email.desc": "ready to be consulted online or offline.",
      "step4.links": "Direct booking links:",
      "step4.links.desc": "flights, accommodations, activities, everything is one click away.",
      "step4.modular": "100% customizable:",
      "step4.modular.desc": "you can adjust dates, change an activity or restart a search in an instant.",

      // Why Travliaq
      "whyTravliaq.title": "Why Travliaq?",
      "whyTravliaq.subtitle": "The smart travel revolution has arrived",
      "whyTravliaq.noPlan.title": "No more planning hassle",
      "whyTravliaq.noPlan.desc":
        "No more 20 open tabs, no more endless comparisons. AI analyzes everything for you: prices, weather, distances, availability.",
      "whyTravliaq.local.title": "Travel like a local",
      "whyTravliaq.local.desc":
        "Our recommendations lead you to real hidden gems, away from tourist traps. Authentic, not artificial.",
      "whyTravliaq.stat": "savings in search time",
      "whyTravliaq.guarantees": "Our guarantees",
      "whyTravliaq.guarantee1": "Best prices guaranteed",
      "whyTravliaq.guarantee2": "Itinerary in less than 24h",
      "whyTravliaq.guarantee3": "100% customizable",
      "whyTravliaq.guarantee4": "24/7 support",
      "whyTravliaq.testimonial":
        "« I saved 15 hours of research and €300 on my trip to Tokyo. Travliaq found spots that even my Japanese friends didn't know! »",
      "whyTravliaq.testimonial.author": "Sarah, 26 years old — Tokyo & Kyoto, 10 days",

      // CTA
      "cta.start": "Start my journey",
      "cta.create": "Create your itinerary",

      // Comparison Section
      "comparison.title": "Before / After Travliaq",
      "comparison.subtitle": "Discover how Travliaq transforms the way you plan your trips",
      "comparison.before.badge": "Without Travliaq",
      "comparison.before.title": "Traditional planning",
      "comparison.before.point1": "Hours spent comparing hundreds of tabs",
      "comparison.before.point2": "Risk of overpaying for flights and accommodations",
      "comparison.before.point3": "Improvised and stressful itinerary",
      "comparison.before.point4": "No guarantee of consistency or optimization",
      "comparison.after.badge": "With Travliaq",
      "comparison.after.title": "Smart planning",
      "comparison.after.point1": "A few clicks for a complete itinerary",
      "comparison.after.point2": "Best prices guaranteed by AI",
      "comparison.after.point3": "Day-by-day optimized program",
      "comparison.after.point4": "24/7 support and unlimited modifications",

      // Examples Section
      "examples.title": "Discover our trips",
      "examples.subtitle": "Concrete examples of itineraries created by Travliaq",
      "examples.tokyo.title": "Tokyo & Kyoto",
      "examples.tokyo.description": "Culture, gastronomy and traditional temples in the heart of Japan.",
      "examples.tokyo.duration": "10 days",
      "examples.tokyo.travelers": "2 travelers",
      "examples.algeria.title": "Sidi Bel Abbès",
      "examples.algeria.description": "Authentic discovery of Algeria and its heritage.",
      "examples.algeria.duration": "7 days",
      "examples.algeria.travelers": "1 traveler",
      "examples.custom.title": "Your custom trip",
      "examples.custom.description": "Create the perfect itinerary according to your wishes and budget.",
      "examples.custom.anywhere": "Anywhere in the world",
      "examples.viewTrip": "View trip",
      "examples.createYours": "Create my trip",

      // Video Section
      "video.title": "Discover Travliaq in video",
      "video.subtitle": "See how we simplify your travel planning",
      "video.coming": "Demo video",
      "video.demo": "Coming soon",

      // FAQ Section
      "faq.title": "Frequently asked questions",
      "faq.subtitle": "Everything you need to know about Travliaq",
      "faq.q1": "How does Travliaq work?",
      "faq.a1": "Travliaq uses artificial intelligence to analyze your travel preferences (destination, budget, dates, style) and compares thousands of flight, accommodation and activity options in real time. In less than 24 hours, you receive an optimized day-by-day itinerary with all booking links.",
      "faq.q2": "How much does the service cost?",
      "faq.a2": "Using Travliaq is currently free. You only pay for your bookings (flights, hotels, activities) directly with the providers.",
      "faq.q3": "Can I modify my itinerary after receiving it?",
      "faq.a3": "Absolutely! Your itinerary is 100% customizable. You can adjust dates, change an activity, modify accommodation or even restart a complete search at any time.",
      "faq.q4": "Which destinations are available?",
      "faq.a4": "Travliaq covers the whole world! Whether you dream of Tokyo, New York, Marrakech or a road trip in Patagonia, our AI finds the best options for any destination.",
      "faq.q5": "Are the prices really the best?",
      "faq.a5": "Yes! Our AI compares hundreds of sources in real time (airlines, booking platforms, hotels) to guarantee you the best rates. And if you find cheaper elsewhere, we adjust your itinerary.",
      "faq.q6": "How long does it take to receive my itinerary?",
      "faq.a6": "Generally, you receive your first proposal within 24 hours of submitting your questionnaire. For urgent requests, we can speed up the process.",
      "faq.more": "Have more questions?",
      "faq.contact": "Contact us",

      // Toast
      "toast.login": "Sign in with Google to save your preferences",
      "toast.loginButton": "Sign in",
      "toast.loginError": "Login error: {{error}}",

      // Auth page
      "auth.welcome": "Welcome to Travliaq",
      "auth.subtitle": "Create your personalized itinerary in a few clicks",
      "auth.continueWithGoogle": "Continue with Google",
      "auth.continueWithLinkedIn": "Continue with LinkedIn",
      "auth.continueWithFacebook": "Continue with Facebook",
      "auth.useMagicLink": "Passwordless login",
      "auth.hideMagicLink": "Hide magic link",
      "auth.magicLinkTitle": "Magic link login",
      "auth.sendMagicLink": "Send link",
      "auth.magicLinkSent": "Magic link sent!",
      "auth.magicLinkSentMessage": "Check your mailbox and click the link to sign in.",
      "auth.sendAnotherLink": "Send another link",
      "auth.magicLinkError": "Error sending magic link",
      "auth.useEmail": "Or use email",
      "auth.hideEmailOption": "Hide email option",
      "auth.oauthError": "Authentication error",
      "auth.loginWithEmail": "Login with email",
      "auth.signupWithEmail": "Sign up with email",
      "auth.email": "Email",
      "auth.emailPlaceholder": "your@email.com",
      "auth.password": "Password",
      "auth.passwordSecure": "Secure password",
      "auth.passwordMinLength": "Password must be at least 8 characters long",
      "auth.passwordLowercase": "Password must contain at least one lowercase letter",
      "auth.passwordUppercase": "Password must contain at least one uppercase letter",
      "auth.passwordNumber": "Password must contain at least one number",
      "auth.login": "Sign in",
      "auth.signup": "Sign up",
      "auth.forgotPassword": "Forgot password?",
      "auth.noAccount": "Don't have an account?",
      "auth.signupLink": "Sign up",
      "auth.hasAccount": "Already have an account?",
      "auth.loginLink": "Sign in",
      "auth.footerNote": "By continuing, you accept our terms of service",
      "auth.googleError": "Error signing in with Google",
      "auth.fillAllFields": "Please fill in all fields",
      "auth.invalidEmail": "Invalid email address",
      "auth.passwordCriteria": "Password does not meet security criteria",
      "auth.invalidCredentials": "Invalid email or password. Make sure you confirmed your email if you just signed up.",
      "auth.emailNotConfirmed": "Please confirm your email before signing in. Check your mailbox.",
      "auth.sessionError": "Session error. Please try again.",
      "auth.loginSuccess": "Successfully signed in",
      "auth.emailAlreadyUsed": "This email address is already in use. If you signed up with Google, please sign in with Google.",
      "auth.signupSuccess": "Successfully signed up! Check your email to confirm your account before signing in.",
      "auth.signupAutoLogin": "Successfully signed up! Signing in automatically...",
      "auth.loginError": "Error signing in",
      "auth.signupError": "Error signing up",

      // Hero name suffix
      "hero.subtitle.afterName":
        ", discover your next personalized itinerary — flights, hotels, weather, activities, all in one click.",

      // Footer
      "footer.ribbon": "Free • No commitment • Result in 24h",
      "footer.tagline": "Artificial intelligence at the service of your exceptional travels",
      "footer.nav": "Navigation",
      "footer.contact": "Contact",
      "footer.legal": "Legal information",
      "footer.follow": "Follow us",
      "footer.create": "Create an itinerary",
      "footer.terms": "Terms and Conditions",
      "footer.imprint": "Legal Notice",
      "footer.privacy": "Privacy Policy",
      "footer.copyright": "© 2025 Travliaq. All rights reserved. Made with ❤️ for authentic travelers",

      // Common
      "common.back": "Back",
      "common.backToTop": "Back to top",

      // Blog
      "blog.backToBlog": "Back to blog",
      "blog.readingTime": "{{time}} min read",
      "blog.views": "{{count}} views",

      // Discover page
      "discover.title": "DISCOVER TRIPS",
      "discover.subtitle": "Explore our collection of unique trips, custom-designed for unforgettable experiences",
      "discover.searchPlaceholder": "Search for a destination, travel style...",
      "discover.filters.budget": "< €800",
      "discover.filters.group": "Group",
      "discover.filters.adventure": "Adventure",
      "discover.filters.nature": "Nature",
      "discover.filters.culture": "Culture",
      "discover.filters.exploration": "Exploration",
      "discover.noTrips": "No trips found",
      "discover.newBadge": "NEW",
      "discover.shareLink": "Copy link",
      "discover.days": "days",
      "discover.from": "From",
      "discover.discover": "Discover",
      "discover.shareText": "Discover this incredible trip: {{destination}}",
      "discover.error": "Error",
      "discover.errorLoading": "Unable to load trips",
      "discover.linkCopied": "Link copied! 🎉",
      "discover.linkCopiedDescription": "The trip link has been copied to your clipboard",

      // Questionnaire
      "q.title": "YOUR CUSTOM TRIP",
      "q.back": "Back",
      "q.continue": "Continue",
      "q.send": "Send 🚀",
      "q.sending": "Sending...",

      // Q1: Who's traveling
      "q.step1.title": "Who's traveling? 👥",
      "q.step1.solo": "Solo",
      "q.step1.duo": "Duo",
      "q.step1.group": "Group 3-5",
      "q.step1.family": "Family (children <12)",
      "q.step1b.group.title": "Number of travelers",
      "q.step1b.family.title": "Number of people (children included) 👨‍👩‍👧‍👦",

      // Q2: Help needed
      "q.step2.title": "How can Travliaq help you? 🎯",
      "q.step2.desc": "Select all services needed",
      "q.step2.flights": "Flights",
      "q.step2.accommodation": "Accommodation",
      "q.step2.activities": "Activities & Suggestions",

      // Q3: Destination
      "q.step3.title": "Where do you want to go? 🌍",
      "q.step3.desc": "Final destination of your trip",
      "q.step3.yes": "Yes, I have a destination in mind",
      "q.step3.no": "No, I don't know yet",
      "q.step3.search": "Search for a destination...",
      "q.step3.popular": "Popular destinations",

      // Q4: Departure location
      "q.step4.title": "Where are you departing from? ✈️",
      "q.step4.search": "Search your departure city...",
      "q.step4.detect": "Auto-detect",
      "q.step4.detecting": "Detecting...",

      // Q5: Climate
      "q.step5.title": "What climate do you prefer? 🌡️",
      "q.step5.desc": "Select all climates you like",
      "q.step5.hot": "Hot (beach, sun)",
      "q.step5.mild": "Mild (gentle, pleasant)",
      "q.step5.cold": "Cold (mountains, snow)",
      "q.step5.mix": "Mixed (variety)",

      // Q6: Travel affinities
      "q.step6.title": "What are your travel interests? 💫",
      "q.step6.desc": "Choose maximum 3",
      "q.step6.culture": "Culture (museums, monuments)",
      "q.step6.nature": "Nature (hiking, parks)",
      "q.step6.gastro": "Gastronomy",
      "q.step6.beach": "Beach & Relaxation",
      "q.step6.nightlife": "Nightlife",
      "q.step6.shopping": "Shopping",
      "q.step6.adventure": "Adventure",
      "q.step6.wellbeing": "Wellness (spa, yoga)",

      // Q7: Travel ambiance
      "q.step7.title": "Desired travel atmosphere 🎨",
      "q.step7.romantic": "Romantic (couple)",
      "q.step7.family": "Family (with children)",
      "q.step7.friends": "With friends (party)",
      "q.step7.relax": "Total relaxation",
      "q.step7.cultural": "Cultural (learning)",
      "q.step7.adventure": "Adventure (sports)",

      // Q8: Dates
      "q.step8.title": "When do you want to travel? 📅",
      "q.step8.exact": "I have specific dates",
      "q.step8.approx": "I have an approximate period",
      "q.step8.flexible": "I'm flexible",
      "q.step8.departure": "Departure date",
      "q.step8.return": "Return date",
      "q.step8.approx.title": "Do you have an approximate departure period?",
      "q.step8.approx.yes": "Yes, I have an idea",
      "q.step8.approx.no": "No, I'm totally flexible",
      "q.step8.approx.when": "When would you like to leave?",
      "q.step8.flex.title": "What is your flexibility level? ⏰",
      "q.step8.flex.days": "±3 days",
      "q.step8.flex.week": "±1 week",
      "q.step8.flex.2weeks": "±2 weeks",
      "q.step8.flex.month": "±1 month",

      // Q9: Duration
      "q.step9.title": "Trip duration 📆",
      "q.step9.1week": "1 week (5-7 days)",
      "q.step9.2weeks": "2 weeks (10-14 days)",
      "q.step9.3weeks": "3 weeks (18-21 days)",
      "q.step9.custom": "Custom duration",
      "q.step9.nights": "Exact number of nights",

      // Q10: Budget
      "q.step10.title": "Budget per person 💰",
      "q.step10.desc": "Rough estimate",
      "q.step10.low": "Low budget (< €1000)",
      "q.step10.mid": "Medium (€1000-3000)",
      "q.step10.high": "Comfortable (€3000-5000)",
      "q.step10.premium": "Premium (> €5000)",
      "q.step10.exact": "Precise budget",
      "q.step10.custom.title": "Exact budget per person",
      "q.step10.total": "Total budget",
      "q.step10.perperson": "Budget per person",
      "q.step10.amount": "Amount",
      "q.step10.currency": "Currency",

      // Q11: Travel styles
      "q.step11.title": "Travel styles 🎒",
      "q.step11.desc": "Select all that apply",
      "q.step11.backpacker": "Backpacker (hostels, budget)",
      "q.step11.comfort": "Comfort (3-4⭐ hotels)",
      "q.step11.premium": "Premium (5⭐ hotels, luxury)",
      "q.step11.authentic": "Authentic (local, immersion)",
      "q.step11.classic": "Classic (must-sees)",
      "q.step11.offbeat": "Off the beaten path",

      // Q12: Rhythm
      "q.step12.title": "Trip pace 🕐",
      "q.step12.slow": "Slow travel (take your time)",
      "q.step12.balanced": "Balanced (mix relaxation/visits)",
      "q.step12.intense": "Intense (packed schedule)",

      // Q13: Flight preference
      "q.step13.title": "Flight preference ✈️",
      "q.step13.direct": "Direct only",
      "q.step13.1stop": "Max 1 layover",
      "q.step13.any": "Doesn't matter (best price)",

      // Q14: Luggage
      "q.step14.title": "Luggage per traveler 🧳",
      "q.step14.cabin": "Cabin luggage",
      "q.step14.hold": "Checked luggage",
      "q.step14.both": "Cabin + Checked",

      // Q15: Mobility
      "q.step15.title": "Mobility & Accessibility ♿",
      "q.step15.desc": "Select all that apply",
      "q.step15.none": "No constraints",
      "q.step15.wheelchair": "Wheelchair",
      "q.step15.walking": "Difficulty walking long distances",
      "q.step15.elevator": "Need elevator",
      "q.step15.stairs": "Avoid stairs",

      // Q16: Accommodation type
      "q.step16.title": "Accommodation type 🏨",
      "q.step16.desc": "Choose all that suit you",
      "q.step16.hotel": "Hotel",
      "q.step16.airbnb": "Airbnb/Rental",
      "q.step16.hostel": "Hostel",
      "q.step16.resort": "Resort/All-inclusive",
      "q.step16.boutique": "Boutique hotel",
      "q.step16b.title": "Hotel preferences 🏨",
      "q.step16b.desc": "Select what interests you",
      "q.step16b.breakfast": "Breakfast included",
      "q.step16b.halfboard": "Half-board",
      "q.step16b.fullboard": "Full-board",
      "q.step16b.allinc": "All-inclusive",
      "q.step16b.room": "Room service",

      // Q17: Comfort
      "q.step17.title": "Expected comfort level 🛏️",
      "q.step17.simple": "Simple (basic cleanliness)",
      "q.step17.standard": "Standard (comfortable)",
      "q.step17.superior": "Superior (very comfortable)",
      "q.step17.luxury": "Luxury (5 stars)",

      // Q18: Neighborhood
      "q.step18.title": "Accommodation location 📍",
      "q.step18.center": "City center (easy access)",
      "q.step18.quiet": "Quiet area (remote)",
      "q.step18.transport": "Near transport",
      "q.step18.attractions": "Near attractions",

      // Q19: Amenities
      "q.step19.title": "Desired amenities 🏊",
      "q.step19.desc": "Select all important to you",
      "q.step19.wifi": "Wi-Fi",
      "q.step19.pool": "Pool",
      "q.step19.gym": "Gym",
      "q.step19.spa": "Spa",
      "q.step19.restaurant": "On-site restaurant",
      "q.step19.parking": "Parking",
      "q.step19.ac": "Air conditioning",
      "q.step19.kitchen": "Equipped kitchen",

      // Children details (for family)
      "questionnaire.children.title": "Children Details 👶",
      "questionnaire.children.description": "To better adapt the itinerary",
      "questionnaire.children.howMany": "How many children among the travelers?",
      "questionnaire.children.child": "Child",
      "questionnaire.children.age": "Age",
      "questionnaire.children.years": "year(s)",
      "questionnaire.children.addChild": "+ Add a child",
      "questionnaire.children.removeChild": "Remove",

      // Security & Safety
      "questionnaire.security.title": "Security & Phobias 🛡️",
      "questionnaire.security.description": "To avoid uncomfortable situations",
      "questionnaire.security.selectAll": "Select what applies",
      "questionnaire.security.none": "No particular constraints",
      "questionnaire.security.crowds": "Avoid crowds",
      "questionnaire.security.heights": "Fear of heights",
      "questionnaire.security.tunnels": "Tunnel phobia",
      "questionnaire.security.water": "Fear of water/swimming",
      "questionnaire.security.animals": "Fear of certain animals",
      "questionnaire.security.darkness": "Fear of darkness/confined spaces",
      "questionnaire.security.unsafeAreas": "Avoid unsafe areas",
      "questionnaire.security.extremeActivities": "No extreme activities",

      // Biological clock & Habits
      "questionnaire.biorhythm.title": "Biological Clock & Habits 🕐",
      "questionnaire.biorhythm.description": "For a rhythm that suits you",
      "questionnaire.biorhythm.selectAll": "Select what fits you",
      "questionnaire.biorhythm.earlyBird": "Early bird (active morning)",
      "questionnaire.biorhythm.nightOwl": "Night owl (late nights)",
      "questionnaire.biorhythm.naps": "Need naps",
      "questionnaire.biorhythm.dailyFreeTime": "Daily free time essential",
      "questionnaire.biorhythm.earlyTolerant": "Tolerant to early wake-ups",
      "questionnaire.biorhythm.regularMeals": "Regular meal times",
      "questionnaire.biorhythm.flexible": "Flexible, I adapt",

      // Q20: Constraints
      "q.step20.title": "Constraints & preferences 🎯",
      "q.step20.desc": "Select all important options",
      "q.step20.halal": "Halal",
      "q.step20.kosher": "Kosher",
      "q.step20.vege": "Vegetarian",
      "q.step20.vegan": "Vegan",
      "q.step20.gluten": "Gluten-free",
      "q.step20.allergies": "Food allergies",
      "q.step20.none": "No constraints",

      // Q21: Additional info
      "q.step21.title": "Additional information 📝",
      "q.step21.desc": "Specify your expectations, constraints or special preferences (optional)",
      "q.step21.placeholder": "E.g.: birthday, food allergies, specific accessibility...",

      // Q22: Open comments
      "q.step22.title": "Free text 💭",
      "q.step22.desc": "Add any comments, questions or useful information (optional)",
      "q.step22.placeholder": "Share your desires, inspirations, special constraints...",

      // Q23: Email
      "q.step23.title": "Last step! 📧",
      "q.step23.desc": "Where should we send your personalized itinerary?",
      "q.step23.email": "Your email",
      "q.step23.name": "Your name (optional)",

      // Errors & Success
      "q.error.quota": "Quota reached 🚫",
      "q.error.quota.desc":
        "You have reached your quota of 2 questionnaires per day. Come back tomorrow to plan another trip!",
      "q.error.auth": "Login required 🔒",
      "q.error.auth.desc": "You must be logged in to submit a questionnaire.",
      "q.error.validation": "Validation error",
      "q.error.validation.desc": "Some fields contain invalid data.",
      "q.error.generic": "Error",
      "q.error.generic.desc": "An error occurred while submitting the questionnaire. Please try again.",
      "q.success": "Questionnaire submitted! 🎉",
      "q.success.desc": "We'll send you your personalized itinerary within 48 hours.",

      "questionnaire.pleaseAnswer": "Answer required",
      "questionnaire.answerRequired": "Please answer this question before continuing",

      // Progress milestones
      "questionnaire.progress.profile": "Profile",
      "questionnaire.progress.destination": "Destination",
      "questionnaire.progress.dates": "Dates",
      "questionnaire.progress.budget": "Budget",
      "questionnaire.progress.flights": "Flights",
      "questionnaire.progress.activities": "Activities",
      "questionnaire.progress.preferences": "Preferences",
      "questionnaire.progress.accommodation": "Accommodation",
      "questionnaire.progress.finalization": "Finalization",

      // Help with descriptions
      "questionnaire.flights.desc": "Flight tickets",
      "questionnaire.accommodation.desc": "Hotels & lodging",
      "questionnaire.activities.desc": "Visits & experiences",

      // Luggage details
      "questionnaire.luggage.personalItem.desc": "Under the seat",
      "questionnaire.luggage.cabin.desc": "Overhead bin",
      "questionnaire.luggage.hold.desc": "Checked luggage",
      "questionnaire.luggage.cabinHold.desc": "Cabin + Checked",

      // Mobility options
      "questionnaire.mobility.dontMind": "Don't mind",
      "questionnaire.mobility.walking": "Walking",
      "questionnaire.mobility.publicTransport.full": "Walking/public transport mainly",
      "questionnaire.mobility.rentalCar.full": "Rental car",
      "questionnaire.mobility.taxi.full": "Taxi/Uber",
      "questionnaire.mobility.bike.full": "Bike",
      "questionnaire.mobility.walking.full": "Walking",
      "questionnaire.mobility.atypical.full": "Atypical transport",
      "questionnaire.mobility.ferry.full": "Boat/ferry",
      "questionnaire.mobility.incompleteSelection": "Incomplete selection",
      "questionnaire.mobility.selectOtherTransport":
        "Select at least one other mode of transport in addition to atypical transport or boat/ferry.",
      "questionnaire.mobility.electricScooter": "Electric scooter",
      "questionnaire.mobility.motorbikeScooter": "Motorbike/scooter",
      "questionnaire.mobility.touristBus": "Tourist bus",
      "questionnaire.mobility.trainMetro": "Train/metro",

      // Questionnaire - Additional keys
      "questionnaire.connectionRequired": "Connection required 🔒",
      "questionnaire.mustBeConnected": "You must be logged in to submit a questionnaire.",
      "questionnaire.submittedTitle": "Questionnaire submitted! 🎉",
      "questionnaire.submittedDescription": "We will send you your personalized itinerary within 48h.",
      "questionnaire.quotaReached": "Quota reached 🚫",
      "questionnaire.quotaExceeded":
        "You have reached your quota of 2 questionnaires per day. Come back tomorrow to plan another trip!",
      "questionnaire.validationError": "Validation error",
      "questionnaire.invalidData": "Some fields contain invalid data.",
      "questionnaire.error": "Error",
      "questionnaire.submissionError": "An error occurred while submitting the questionnaire. Please try again.",
      "questionnaire.saveAndReturn": "💾 Save and return later",
      "questionnaire.draftSaved": "Draft saved! 💾",
      "questionnaire.draftSavedDesc": "You can resume the questionnaire later",
      "questionnaire.draftRestored": "Draft restored! 📋",
      "questionnaire.draftRestoredDesc": "You've resumed where you left off",
      "questionnaire.resumeDraft": "Resume draft?",
      "questionnaire.whoTraveling": "Who's traveling? 👥",

      // Review step
      "questionnaire.review.title": "Trip summary 📋",
      "questionnaire.review.description": "Review your answers before submitting",
      "questionnaire.review.group": "Travel group",
      "questionnaire.review.destination": "Destination",
      "questionnaire.review.dates": "Dates",
      "questionnaire.review.budget": "Budget",
      "questionnaire.review.preferences": "Preferences",
      "questionnaire.review.accommodation": "Accommodation",
      "questionnaire.review.constraints": "Constraints",
      "questionnaire.review.contact": "Contact",
      "questionnaire.review.edit": "Edit",
      "questionnaire.review.emailDesc": "We'll send your itinerary to this address",
      "questionnaire.submit": "Send my questionnaire",
      "questionnaire.submitting": "Sending...",
      "questionnaire.email": "Email",
      "questionnaire.emailPlaceholder": "your@email.com",
      "questionnaire.travelGroup": "Travel group",
      "questionnaire.numberOfTravelers": "Number of travelers",
      "questionnaire.hasDestination": "Destination in mind",
      "questionnaire.destination": "Destination",
      "questionnaire.departureLocation": "Departure location",
      "questionnaire.datesType": "Dates type",
      "questionnaire.departureDate": "Departure date",
      "questionnaire.returnDate": "Return date",
      "questionnaire.duration": "Duration",
      "questionnaire.budget": "Budget",
      "questionnaire.budgetAmount": "Budget amount",
      "questionnaire.budgetCurrency": "Currency",
      "questionnaire.travelAmbiance": "Travel vibe",
      "questionnaire.styles": "Styles",
      "questionnaire.rhythm": "Rhythm",
      "questionnaire.schedulePrefs": "Schedule preferences",
      "questionnaire.accommodationType": "Accommodation type",
      "questionnaire.hotelPreferences": "Hotel preferences",
      "questionnaire.comfort": "Comfort",
      "questionnaire.security": "Security",
      "questionnaire.mobility": "Mobility",
      "questionnaire.constraints": "Constraints",
      "questionnaire.numberOfPeople": "Number of people 👥",
      "questionnaire.continue": "Continue",
      "questionnaire.howManyPeople": "How many people exactly? 👥",
      "questionnaire.destinationInMind": "Destination in mind? 🌍",
      "questionnaire.destinationInMind.description": "City or country you want to visit",
      "questionnaire.howCanHelp": "How can we help? 🎯",
      "questionnaire.howCanHelp.description": "Select the services you need",
      "questionnaire.multipleSelectionPossible": "Multiple selection possible",
      "questionnaire.solo": "Solo",
      "questionnaire.duo": "Duo",
      "questionnaire.group35": "Group 3-5",
      "questionnaire.family": "Family (children <12)",
      "questionnaire.3people": "3 people",
      "questionnaire.4people": "4 people",
      "questionnaire.5people": "5 people",
      "questionnaire.yes": "Yes",
      "questionnaire.no": "No",
      "questionnaire.flights": "Flights",
      "questionnaire.accommodation": "Accommodation",
      "questionnaire.activities": "Activities",
      "questionnaire.destinationDetails": "Enter your destination details 🌍",
      "questionnaire.whereFrom": "Departure city? 📍",
      "questionnaire.cityTooltip":
        "You can enter any city, even if it doesn't appear in the list. The AI will understand your starting point if you spell it correctly.",
      "questionnaire.detecting": "Detecting...",
      "questionnaire.myPosition": "My position",
      "questionnaire.departureCity": "Departure city",
      "questionnaire.whereGoing": "Where are you going? 🌍",
      "questionnaire.destinationTooltip":
        "You can enter any city, even if it doesn't appear in the list. The AI will understand your destination if you spell it correctly.",
      "questionnaire.destinationCity": "Destination city...",
      "questionnaire.citiesMustBeDifferent": "Departure and destination cities must be different",
      "questionnaire.climatePreference": "Preferred climate? 🌡️",
      "questionnaire.climatePreference.description": "Multiple choices possible",
      "questionnaire.customTrip": "YOUR CUSTOM TRIP",
      "questionnaire.back": "Back",
      "questionnaire.backToReview": "Back to summary",
      "questionnaire.noCityFound": "No city found for",

      // Travelers step
      "questionnaire.travelers.addTravelers": "Add travelers one by one",
      "questionnaire.travelers.adult": "adult",
      "questionnaire.travelers.adults": "adults",
      "questionnaire.travelers.child": "child",
      "questionnaire.travelers.children": "children",
      "questionnaire.travelers.addAdult": "+ Adult",
      "questionnaire.travelers.addChild": "+ Child (<18 years)",
      "questionnaire.travelers.adultLabel": "Adult",
      "questionnaire.travelers.childLabel": "Child",
      "questionnaire.travelers.childAge": "Child's age",
      "questionnaire.travelers.agePlaceholder": "Age",
      "questionnaire.travelers.childNeedsAdult": "A child must be accompanied by at least one adult",
      "questionnaire.travelers.childMinAge": "The minimum age for a child is 1 year",

      // Climate options
      "questionnaire.climate.hotSunny": "Hot & sunny",
      "questionnaire.climate.hotSunny.desc": "25-35°C",
      "questionnaire.climate.mildSweet": "Mild & sweet",
      "questionnaire.climate.mildSweet.desc": "15-25°C",
      "questionnaire.climate.coldSnowy": "Cold & snowy",
      "questionnaire.climate.coldSnowy.desc": "<10°C",
      "questionnaire.climate.tropicalHumid": "Tropical & humid",
      "questionnaire.climate.tropicalHumid.desc": "Beaches & jungle",
      "questionnaire.climate.mountainAltitude": "Mountain & altitude",
      "questionnaire.climate.mountainAltitude.desc": "Fresh air",
      "questionnaire.climate.dontMind": "Don't mind",
      "questionnaire.climate.dontMind.desc": "I'm flexible",

      // Travel affinities
      "questionnaire.affinities.title": "Travel interests? 🎯",
      "questionnaire.affinities.description": "Select up to 5 options",
      "questionnaire.affinities.selectUpTo5": "Select up to 5 affinities",
      "questionnaire.affinities.dontMind": "Don't mind",
      "questionnaire.affinities.paradiseBeaches": "Paradise beaches",
      "questionnaire.affinities.historicCities": "Historic cities",
      "questionnaire.affinities.natureHiking": "Nature & hiking",
      "questionnaire.affinities.skiWinterSports": "Skiing & winter sports",
      "questionnaire.affinities.safariAnimals": "Safari & animals",
      "questionnaire.affinities.localGastronomy": "Local gastronomy",
      "questionnaire.affinities.shoppingFashion": "Shopping & fashion",
      "questionnaire.affinities.festivalsEvents": "Festivals & events",
      "questionnaire.affinities.modernArchitecture": "Modern architecture",
      "questionnaire.affinities.templesSpirituality": "Temples & spirituality",
      "questionnaire.affinities.amusementParks": "Amusement parks",
      "questionnaire.affinities.divingSnorkeling": "Diving & snorkeling",
      "questionnaire.affinities.roadTripFreedom": "Road trip & freedom",
      "questionnaire.affinities.vineyardsWine": "Vineyards & wine tourism",
      "questionnaire.affinities.desertsLunar": "Deserts & lunar landscapes",
      "questionnaire.affinities.islandsArchipelagos": "Islands & archipelagos",
      "questionnaire.affinities.photography": "Photography",
      "questionnaire.affinities.artMuseums": "Art & museums",
      "questionnaire.affinities.waterSports": "Water sports",
      "questionnaire.affinities.fishing": "Fishing",
      "questionnaire.affinities.spasThermal": "Spas & thermal baths",
      "questionnaire.affinities.cruises": "Cruises",
      "questionnaire.affinities.localMarkets": "Local markets",

      // Travel ambiance
      "questionnaire.ambiance.title": "Desired ambiance? 🎨",
      "questionnaire.ambiance.description": "Trip atmosphere",
      "questionnaire.ambiance.adventureExotic": "Adventure & exotic",
      "questionnaire.ambiance.adventureExotic.desc": "Get out of my comfort zone",
      "questionnaire.ambiance.relaxation": "Relaxation",
      "questionnaire.ambiance.relaxation.desc": "Completely recharge",
      "questionnaire.ambiance.romanceIntimacy": "Romance & intimacy",
      "questionnaire.ambiance.romanceIntimacy.desc": "Moments for two",
      "questionnaire.ambiance.culturalDiscovery": "Cultural discovery",
      "questionnaire.ambiance.culturalDiscovery.desc": "Learn and grow",
      "questionnaire.ambiance.partyNightlife": "Party & nightlife",
      "questionnaire.ambiance.partyNightlife.desc": "Party time",
      "questionnaire.ambiance.familyConviviality": "Family & conviviality",
      "questionnaire.ambiance.familyConviviality.desc": "Family moments",

      // Dates
      "questionnaire.dates.title": "Travel dates? 📅",
      "questionnaire.dates.description": "Fixed or flexible dates",
      "questionnaire.dates.fixed": "Fixed dates",
      "questionnaire.dates.flexible": "I'm flexible",
      "questionnaire.dates.selectDates": "Select dates 🗓️",
      "questionnaire.dates.selectDates.description": "Departure then return date",
      "questionnaire.dates.selectRange": "Click and drag to select a date range",
      "questionnaire.dates.selected": "Selected dates:",
      "questionnaire.dates.departure": "Departure:",
      "questionnaire.dates.return": "Return:",
      "questionnaire.dates.nights": "nights",
      "questionnaire.dates.reset": "Reset dates",
      "questionnaire.dates.pickDeparture": "Select your departure date",
      "questionnaire.dates.pickReturn": "Now select your return date",
      "questionnaire.dates.selectedMsg": "Dates selected!",

      // Flexibility
      "questionnaire.flexibility.title": "Date flexibility? ⏰",
      "questionnaire.flexibility.description": "Possible date shift for better prices",
      "questionnaire.flexibility.souplesse": "What flexibility? 🔄",
      "questionnaire.flexibility.0days": "±1d",
      "questionnaire.flexibility.3days": "±3d",
      "questionnaire.flexibility.7days": "±7d",
      "questionnaire.flexibility.14days": "±14d",
      "questionnaire.flexibility.30days": "±30d",
      "questionnaire.flexibility.week": "±1 week",
      "questionnaire.flexibility.2weeks": "±2 weeks",
      "questionnaire.flexibility.month": "±1 month",
      "questionnaire.flexibility.hasApproxDate": "Approximate departure? 📅",
      "questionnaire.flexibility.hasApproxDate.description": "Do you have a rough idea of when?",
      "questionnaire.flexibility.hasApproxDate.yes": "Yes, I have an idea",
      "questionnaire.flexibility.hasApproxDate.no": "Not yet",
      "questionnaire.flexibility.approxDate": "What is your approximate departure date? 📆",
      "questionnaire.flexibility.clickDate":
        "Click on a date (this date will serve as a reference for your flexibility)",
      "questionnaire.flexibility.dateSelected": "Date selected:",
      "questionnaire.dates.clickInstruction": "Click on your departure date then on your return date ✈️",
      "questionnaire.dates.duration": "Trip duration:",
      "questionnaire.dates.days": "days",

      // Duration
      "questionnaire.duration.title": "Trip duration? 🌙",
      "questionnaire.duration.description": "Number of nights",
      "questionnaire.duration.2nights": "2 nights",
      "questionnaire.duration.3nights": "3 nights",
      "questionnaire.duration.4nights": "4 nights",
      "questionnaire.duration.5nights": "5 nights",
      "questionnaire.duration.6nights": "6 nights",
      "questionnaire.duration.7nights": "7 nights",
      "questionnaire.duration.8to10": "8-10 nights",
      "questionnaire.duration.11to14": "11-14 nights",
      "questionnaire.duration.more14": ">14 nights",
      "questionnaire.duration.exactNights": "Exact number of nights? 🌉",
      "questionnaire.duration.exactNights.description": "Minimum 15 nights",
      "questionnaire.duration.specify8to10": "Specify number of nights 🛏️",
      "questionnaire.duration.specify8to10.description": "Choose between 8, 9 or 10 nights",
      "questionnaire.duration.specify11to14": "Specify number of nights 🛏️",
      "questionnaire.duration.specify11to14.description": "Choose between 11, 12, 13 or 14 nights",
      "questionnaire.duration.8nights": "8 nights",
      "questionnaire.duration.9nights": "9 nights",
      "questionnaire.duration.10nights": "10 nights",
      "questionnaire.duration.11nights": "11 nights",
      "questionnaire.duration.12nights": "12 nights",
      "questionnaire.duration.13nights": "13 nights",
      "questionnaire.duration.14nights": "14 nights",

      // Budget
      "questionnaire.budget.title": "Budget per person? 💰",
      "questionnaire.budget.description": "Total budget excluding personal purchases",
      "questionnaire.budget.sliderDescription": "Move the slider to set your budget per person",
      "questionnaire.budget.perPerson": "per person",
      "questionnaire.budget.excluding": "Excluding personal purchases",
      "questionnaire.budget.less300": "<€300",
      "questionnaire.budget.300to600": "€300-600",
      "questionnaire.budget.600to900": "€600-900",
      "questionnaire.budget.900to1200": "€900-1,200",
      "questionnaire.budget.1200to1800": "€1,200-1,800",
      "questionnaire.budget.more1800": ">€1,800",
      "questionnaire.budget.dontKnow": "I don't know",
      "questionnaire.budget.precise": "Precise budget",
      "questionnaire.budget.totalBudget": "Exact budget? 💵",
      "questionnaire.budget.totalBudget.description": "Per person for the entire trip",
      "questionnaire.budget.entireTrip": "For the entire trip",
      "questionnaire.budget.amount": "Amount",
      "questionnaire.budget.currency": "Currency",
      "questionnaire.budget.enterPrecise": "Enter a precise budget",
      "questionnaire.budget.backToSlider": "Back to slider",

      // Travel styles
      "questionnaire.styles.title": "Activity interests? 🎨",
      "questionnaire.styles.description": "Select up to 5 options",
      "questionnaire.styles.selectUpTo5": "Select up to 5 styles",
      "questionnaire.styles.nature": "Nature",
      "questionnaire.styles.cultureMuseums": "Culture & museums",
      "questionnaire.styles.food": "Food",
      "questionnaire.styles.beach": "Beach",
      "questionnaire.styles.mountainHiking": "Mountain & hiking",
      "questionnaire.styles.photoSpots": "Photo spots",
      "questionnaire.styles.localMarkets": "Local life & markets",
      "questionnaire.styles.sportOutdoor": "Sport & outdoor",
      "questionnaire.styles.wellnessSpa": "Wellness & spa",
      "questionnaire.styles.nightlife": "Nightlife",

      // Rhythm
      "questionnaire.rhythm.title": "Trip pace? ⏱️",
      "questionnaire.rhythm.description": "Activities per day",
      "questionnaire.rhythm.selectRhythm": "Select your pace",
      "questionnaire.rhythm.cool": "Cool",
      "questionnaire.rhythm.cool.desc": "1-2 activities/day",
      "questionnaire.rhythm.relaxed": "Relaxed",
      "questionnaire.rhythm.relaxed.desc": "1-2 activities/day",
      "questionnaire.rhythm.balanced": "Balanced",
      "questionnaire.rhythm.balanced.desc": "2-3 activities/day",
      "questionnaire.rhythm.intense": "Intense",
      "questionnaire.rhythm.intense.desc": "3+ activities/day",

      // Schedule preferences
      "questionnaire.optional": "Optional",
      "questionnaire.schedule.title": "Schedule preferences",
      "questionnaire.schedule.description": "Select up to 3 options",
      "questionnaire.schedule.maxReached": "Maximum 3 preferences",
      "questionnaire.schedule.earlyBird": "Early bird",
      "questionnaire.schedule.nightOwl": "Night owl",
      "questionnaire.schedule.needsSiesta": "Needs siesta",
      "questionnaire.schedule.needsBreaks": "Needs breaks",
      "questionnaire.schedule.needsFreeTime": "Needs free time",
      "questionnaire.schedule.flexibleSchedule": "Flexible schedule",

      // Flights
      "questionnaire.flights.title": "Flight preference? ✈️",
      "questionnaire.flights.description": "Direct or with layovers",
      "questionnaire.flights.directOnly": "Direct only",
      "questionnaire.flights.max1Stop": "Max 1 stop",
      "questionnaire.flights.dontMind": "Don't mind",

      // Luggage
      "questionnaire.luggage.title": "Luggage per traveler? 🧳",
      "questionnaire.luggage.description": "Impacts flight price",
      "questionnaire.luggage.travelers": "traveler",
      "questionnaire.luggage.travelers_plural": "travelers",
      "questionnaire.luggage.traveler": "Traveler",
      "questionnaire.luggage.personalItem": "Personal item only",
      "questionnaire.luggage.cabin": "Cabin baggage only",
      "questionnaire.luggage.hold": "Checked baggage only",
      "questionnaire.luggage.cabinHold": "Cabin + Checked",

      // Accommodation type
      "questionnaire.accommodationType.title": "Accommodation type? 🏨",
      "questionnaire.accommodationType.description": "Select 1 or 2 types",
      "questionnaire.accommodationType.select1or2": "Select 1 or 2 types",
      "questionnaire.accommodationType.hotel": "Hotel",
      "questionnaire.accommodationType.apartment": "Apartment",
      "questionnaire.accommodationType.villa": "Villa",
      "questionnaire.accommodationType.chalet": "Chalet",
      "questionnaire.accommodationType.condominium": "Condominium",
      "questionnaire.accommodationType.hostel": "Hostel",
      "questionnaire.accommodationType.guesthouse": "Guesthouse/riad",
      "questionnaire.accommodationType.lodge": "Lodge/eco-stay",
      "questionnaire.accommodationType.camping": "Camping/glamping",
      "questionnaire.accommodationType.bedBreakfast": "Bed & breakfast",
      "questionnaire.accommodationType.resort": "Resort",
      "questionnaire.accommodationType.dontMind": "Don't mind",

      // Hotel preferences
      "questionnaire.hotelPreferences.title": "Hotel preferences? 🏨",
      "questionnaire.hotelPreferences.description": "Services and amenities",
      "questionnaire.hotelPreferences.selectInterested": "Select what interests you",
      "questionnaire.hotelPreferences.breakfast": "Breakfast included",
      "questionnaire.hotelPreferences.halfBoard": "Half board",
      "questionnaire.hotelPreferences.fullBoard": "Full board",
      "questionnaire.hotelPreferences.allInclusive": "All-inclusive",
      "questionnaire.hotelPreferences.roomService": "Room service",
      "questionnaire.hotelPreferences.minibar": "Minibar",
      "questionnaire.hotelPreferences.view": "Sea/mountain view",
      "questionnaire.hotelPreferences.balcony": "Balcony/terrace",
      "questionnaire.hotelPreferences.dontMind": "Don't mind",
      "questionnaire.hotelPreferences.concierge": "Concierge service",

      // Comfort
      "questionnaire.comfort.title": "Minimum comfort? ⭐",
      "questionnaire.comfort.description": "Minimum rating required",
      "questionnaire.comfort.rating75": "Rating ≥7.5",
      "questionnaire.comfort.rating80": "Rating ≥8.0",
      "questionnaire.comfort.rating85": "Rating ≥8.5",
      "questionnaire.comfort.dontMind": "Don't mind",

      // Neighborhood
      "questionnaire.neighborhood.title": "Preferred neighborhood? 🗺️",
      "questionnaire.neighborhood.description": "Location type",
      "questionnaire.neighborhood.quiet": "Quiet",
      "questionnaire.neighborhood.centralLively": "Central & lively",
      "questionnaire.neighborhood.nearNatureBeach": "Near nature/beach",
      "questionnaire.neighborhood.atypicalCharm": "Atypical/local charm",

      // Amenities
      "questionnaire.amenities.title": "Desired amenities? 🛠️",
      "questionnaire.amenities.description": "Multiple choices possible",
      "questionnaire.amenities.selectAll": "Select all that matter to you",
      "questionnaire.amenities.reliableWifi": "Reliable Wi-Fi",
      "questionnaire.amenities.airConditioning": "Air conditioning",
      "questionnaire.amenities.kitchen": "Kitchen",
      "questionnaire.amenities.washingMachine": "Washing machine",
      "questionnaire.amenities.parking": "Parking",
      "questionnaire.amenities.elevator": "Elevator",
      "questionnaire.amenities.reception24": "24/7 reception",
      "questionnaire.amenities.nearWorship": "Near place of worship",
      "questionnaire.amenities.babyCrib": "Baby crib",
      "questionnaire.amenities.familyRoom": "Family room",
      "questionnaire.amenities.pool": "Pool",
      "questionnaire.amenities.gym": "Gym",
      "questionnaire.amenities.spa": "Spa/jacuzzi",
      "questionnaire.amenities.gardenTerrace": "Garden/terrace",
      "questionnaire.amenities.dontMind": "Don't mind",

      // Constraints
      "questionnaire.constraints.title": "Any constraints? 🎯",
      "questionnaire.constraints.description": "Dietary, religious, accessibility",
      "questionnaire.constraints.selectAllImportant": "Select all important options",
      "questionnaire.constraints.halal": "Halal",
      "questionnaire.constraints.kosher": "Kosher",
      "questionnaire.constraints.vegetarian": "Vegetarian",
      "questionnaire.constraints.vegan": "Vegan",
      "questionnaire.constraints.glutenFree": "Gluten-free",
      "questionnaire.constraints.noPork": "No pork",
      "questionnaire.constraints.noAlcohol": "No alcohol",
      "questionnaire.constraints.prayerPlaces": "Prayer places",
      "questionnaire.constraints.buddhistTraditions": "Respect Buddhist traditions",
      "questionnaire.constraints.accessibility": "Wheelchair accessibility",
      "questionnaire.constraints.safezones": "Safe zones",
      "questionnaire.constraints.avoidCar": "Avoid car",
      "questionnaire.constraints.localTraditions": "Respect local traditions",
      "questionnaire.constraints.foodAllergies": "Food allergies",
      "questionnaire.constraints.dontMind": "Don't mind",

      // Additional info
      "questionnaire.additionalInfo.title": "Additional info? 💬",
      "questionnaire.additionalInfo.description": "Important details we should know (optional)",
      "questionnaire.additionalInfo.descriptionExtended": "Ex: avoid stopovers, allergies, special event",
      "questionnaire.additionalInfo.optional": "Free text (optional)",
      "questionnaire.additionalInfo.placeholder": "Share your specific needs...",
      "questionnaire.additionalInfo.skip": "Skip",
      "questionnaire.additionalInfo.characters": "characters",

      // Email step
      "questionnaire.email.title": "Receive my itinerary 📧",
      "questionnaire.email.description": "We will send you your personalized itinerary within 48h",
      "questionnaire.email.placeholder": "your@email.com",
      "questionnaire.email.send": "Send 🚀",
      "questionnaire.email.sending": "Sending...",

      // Trip Details page
      "tripDetails.notFound": "Trip not found",
      "tripDetails.backToTrip": "Back to trip",
      "tripDetails.preBookingInfo": "Pre-booking information",
      "tripDetails.tripSummary": "Trip summary",
      "tripDetails.days": "days",
      "tripDetails.travelers": "travelers",
      "tripDetails.duration": "Duration",
      "tripDetails.travelersLabel": "Travelers",
      "tripDetails.activities": "Activities",
      "tripDetails.totalPrice": "Total price",
      "tripDetails.included": "Included in the trip",
      "tripDetails.excluded": "Not included",
      "tripDetails.responsibilities": "Responsibilities & Organization",
      "tripDetails.organizer": "Trip organizer",
      "tripDetails.organizerDesc": "Travliaq SAS acts as a travel organizer within the meaning of the European Directive 2015/2302. As such, we are responsible for the proper execution of all services included in your package.",
      "tripDetails.globalResponsibility": "Overall trip responsibility",
      "tripDetails.globalResponsibilityDesc": "In case of a problem with a provider (hotel, airline, etc.), you contact Travliaq directly. We handle claims and ensure coordination with all partners.",
      "tripDetails.cancellation": "Cancellation policy",
      "tripDetails.noRefundPolicy": "No refunds for cancellations",
      "tripDetails.noRefundDesc": "All bookings are final. No refunds will be issued for cancellations, regardless of the reason or timing before departure.",
      "tripDetails.insuranceRecommendation": "We strongly recommend purchasing travel cancellation insurance from your insurer to protect yourself against unforeseen circumstances.",
      "tripDetails.guarantees": "Guarantees & Protections",
      "tripDetails.insolvencyGuarantee": "Insolvency guarantee",
      "tripDetails.insolvencyGuaranteeDesc": "In accordance with European regulations, Travliaq has a financial guarantee that ensures reimbursement of amounts paid and repatriation of travelers in the event of company failure.",
      "tripDetails.rcProInsurance": "Professional Liability Insurance",
      "tripDetails.rcProInsuranceDesc": "Travliaq is covered by travel-specific professional liability insurance, covering damages that may occur during the organization of your trip.",
      "tripDetails.acceptTerms": "I have read and accept the",
      "tripDetails.termsLink": "Terms and Conditions",
      "tripDetails.acceptTerms2": "as well as the information regarding responsibilities and guarantees detailed above.",
      "tripDetails.proceedToBooking": "Proceed to booking",
      "tripDetails.footerNote": "In accordance with European Directive 2015/2302 on package travel, you benefit from all the rights provided for consumers.",

      // Travel Co-Pilot
      "copilot.pageTitle": "Travel Co-Pilot",
      "copilot.pageDescription": "Plan your trip with our smart AI assistant",
      "copilot.title": "Travel Co-Pilot",
      "copilot.subtitle": "Your AI travel assistant",
      "copilot.welcome": "Hello! 👋 I'm your travel co-pilot. Tell me where you'd like to go and I'll help you plan your perfect trip.",
      "copilot.thinking": "Thinking...",
      "copilot.inputPlaceholder": "Tell me your travel wishes...",
      "copilot.quickDestination": "I want to go to...",
      "copilot.quickDates": "My travel dates",
      "copilot.tabs.flights": "Flights",
      "copilot.tabs.hotels": "Hotels",
      "copilot.tabs.activities": "Activities",
      "copilot.tabs.trip": "My Trip",
      "copilot.panel.flights": "Available flights",
      "copilot.panel.hotels": "Accommodations",
      "copilot.panel.activities": "Activities & Experiences",
      "copilot.panel.trip": "Trip summary",
      "copilot.noFlights": "Tell me your destination to see flights",
      "copilot.noHotels": "Select a destination to see hotels",
      "copilot.noActivities": "Explore activities after choosing your destination",
      "copilot.noTrip": "Your itinerary will appear here",
      "copilot.direct": "Direct flight",
      "copilot.stops": "stop(s)",
      "copilot.selectedAirport": "Selected airport",
      "copilot.selectedDates": "Selected dates",
      "copilot.response.destination": "Great choice! 🗽 The map now shows New York. Where would you like to depart from?",
      "copilot.response.hotels": "Here are available hotels in Manhattan. Click on a marker on the map or in the list to see details.",
      "copilot.response.activities": "Here are popular activities! Broadway shows, Statue of Liberty and Central Park are must-sees.",
      "copilot.response.dates": "Perfect! Select your travel dates:",
      "copilot.response.generic": "I'm listening! Tell me your destination, dates, or what kind of accommodation or activities you're looking for.",
      "copilot.response.airportSelected": "Perfect, departing from {{airport}}! I'm searching for the best flights for you.",
      "copilot.response.datesSelected": "Dates saved! I'm updating availability for those dates.",

      // Planner Chat translations
      "planner.welcome": "Hello! 👋 I'm your travel assistant. Where would you like to go?",
      "planner.askDestination": "Where would you like to go?",
      "planner.askDates": "When would you like to travel?",
      "planner.askTravelers": "How many travelers?",
      "planner.askDeparture": "Where are you departing from?",
      "planner.confirmTrip": "Perfect! Here's your trip summary:",
      "planner.countryDetected": "{{country}} is a fascinating destination! Here are the main cities:",
      "planner.datesConfirmed": "Perfect! Dates saved.",
      "planner.travelersConfirmed": "Great! Travelers configured.",
      "planner.searchReady": "All set! Click to search. 🚀",
      "planner.chooseForMe": "Choose for me",
      "planner.travelers": "{{count}} traveler",
      "planner.travelers_plural": "{{count}} travelers",
      "planner.departure": "Departure",
      "planner.return": "Return",
      "planner.roundtrip": "Round trip",
      "planner.oneway": "One way",
      "planner.adults": "adult",
      "planner.adults_plural": "adults",
      "planner.children": "child",
      "planner.children_plural": "children",
      "planner.infants": "infant",
      "planner.infants_plural": "infants",
      "planner.selectCity": "Select a city",
      "planner.selectDates": "Select your dates",
      "planner.selectTravelers": "Specify travelers",
      "planner.launchSearch": "Search",
      "planner.searchFlights": "Search flights now",
      "planner.modifySearch": "Modify search",
      "planner.inspireMe": "Inspire me!",
      "planner.newConversation": "New conversation",
      "planner.history": "History",
      "planner.inputPlaceholder": "Describe your ideal trip...",
      "planner.closeChat": "Close chat",
      // Error messages
      "planner.error.generic": "Sorry, an error occurred. Please try again.",
      "planner.error.noResponse": "Sorry, I couldn't respond.",
      "planner.error.noDestinations": "Sorry, I couldn't find destinations matching your criteria. Try giving me your travel preferences with 'Inspire me!' 🌍",
      "planner.error.destinationSearch": "An error occurred while searching for destinations. Please try again.",
      "planner.error.citySearch": "An error occurred while searching for cities.",
      // Inspire flow messages
      "planner.inspire.title1": "✨ **Perfect, let me inspire you!**\n\nTo create a trip that suits you, let's start by discovering your travel style. Choose what suits you best:",
      "planner.inspire.title2": "🌍 **The adventure starts here!**\n\nTo offer you unique destinations, I need to know you better. What type of traveler are you?",
      "planner.inspire.title3": "🎯 **Let's find your ideal trip!**\n\nYour next trip will reflect who you are. Tell me your style for personalized suggestions:",
      "planner.inspire.title4": "💫 **Let's create your next getaway together!**\n\nEvery traveler is unique. Share your preferences so I can offer you tailored experiences:",
      "planner.inspire.title5": "🗺️ **Ready for inspiration?**\n\nTo guide you to the perfect destination, first tell me what kind of experience you're looking for:",
      // Destination selection
      "planner.destination.found": "Here is {{count}} perfect destination for you, based on your profile ({{score}}% completion):",
      "planner.destination.found_plural": "Here are {{count}} perfect destinations for you, based on your profile ({{score}}% completion):",
      "planner.destination.excellent": "Excellent choice! **{{country}}** is a perfect destination for you.",
      "planner.destination.searchingCities": "Searching for main cities...",
      "planner.destination.whichCity": "Which city would you like to visit?",
      "planner.destination.typeCity": "Which city would you like to visit? Type the name in the chat.",
      // Trip summary
      "planner.trip.configured": "Great! Your trip **{{from}} → {{to}}** is configured:",
      "planner.trip.ready": "Perfect! Your itinerary **{{from}} → {{to}}** is ready!",
      "planner.trip.selectAirports": "Select your airports below:",
      "planner.trip.selectAirportsPanel": "Please select your airports in the right panel.",
      // Widgets
      "planner.widget.selectDepartureDate": "Choose departure date",
      "planner.widget.selectReturnDate": "Choose return date",
      "planner.widget.selectInterests": "Select your interests:",
      "planner.widget.adjustStyle": "Adjust your travel style:",
      // Quick suggestions
      "planner.suggestion.noMore": "Nothing else to add. Give me 3 destination recommendations based on my profile.",
      "planner.suggestion.specifyInterests": "I'd like to specify my interests.",
      "planner.suggestion.adjustStyle": "I'd like to adjust my travel style.",
      "planner.suggestion.mustHaves": "I have mandatory criteria to specify.",
      "planner.suggestion.dietary": "I have dietary restrictions to specify.",
      "planner.suggestion.chooseForMe": "Choose the best destination for me from those shown and explain why.",
      "planner.suggestion.nothingElse": "Nothing else, suggest!",
      // Preference flow messages
      "planner.preference.styleTitle": "Your travel style",
      "planner.preference.continue": "Continue",
      "planner.preference.selectInterests": "Now, select your interests:",
      "planner.preference.anythingElse": "Anything else to mention? (mandatory criteria, dietary restrictions...)",
      "planner.preference.afterMustHaves": "Perfect! Anything else to mention?",
      "planner.preference.searchingDestinations": "Searching for the best destinations for you...",
      "planner.preference.mustHavesConfigured": "Mandatory criteria configured",
      "planner.preference.dietaryConfigured": "Dietary restrictions: {{restrictions}}",
      "planner.preference.selectUpTo": "Select up to {{max}}",
      // Style axes labels
      "planner.style.chill": "Relaxation",
      "planner.style.intense": "Intense",
      "planner.style.urban": "Urban",
      "planner.style.nature": "Nature",
      "planner.style.budget": "Budget",
      "planner.style.luxury": "Luxury",
      "planner.style.tourist": "Touristic",
      "planner.style.authentic": "Authentic",
      // Interests labels
      "planner.interest.culture": "Culture",
      "planner.interest.food": "Gastronomy",
      "planner.interest.nature": "Nature",
      "planner.interest.beach": "Beach",
      "planner.interest.wellness": "Wellness",
      "planner.interest.sport": "Sport",
      "planner.interest.adventure": "Adventure",
      "planner.interest.nightlife": "Nightlife",
      "planner.interest.shopping": "Shopping",
      "planner.interest.history": "History",
      // Must-haves labels
      "planner.mustHaves.title": "Mandatory criteria",
      "planner.mustHaves.selected": "{{count}} selected",
      "planner.mustHaves.selected_plural": "{{count}} selected",
      "planner.mustHaves.accessibility": "Wheelchair access",
      "planner.mustHaves.petFriendly": "Pet friendly",
      "planner.mustHaves.familyFriendly": "Family friendly",
      "planner.mustHaves.highSpeedWifi": "High-speed WiFi",
      // Dietary labels
      "planner.dietary.title": "Dietary restrictions",
      "planner.dietary.selected": "{{count}} selected",
      "planner.dietary.selected_plural": "{{count}} selected",
      // Date picker
      "planner.datePicker.departure": "Departure",
      "planner.datePicker.return": "Return",
      "planner.datePicker.confirm": "Confirm",
      "planner.datePicker.selectedDate": "Selected date",
      // Travelers widget
      "planner.travelers.title": "Travelers",
      "planner.travelers.adults": "Adults",
      "planner.travelers.children": "Children",
      "planner.travelers.infants": "Infants",
      "planner.travelers.confirm": "Confirm",
      "planner.travelers.solo": "I'm traveling alone",
      "planner.travelers.edit": "Edit number of travelers",
      // City selection
      "planner.city.recommended": "Best choice",
      "planner.city.otherDestinations": "Other destinations",
      "planner.city.selected": "City selected",
      // Destination suggestions
      "planner.destinations.loading": "Searching for the best destinations based on your profile...",
      "planner.destinations.swipeHint": "Swipe for more",
      "planner.destinations.noResults": "No destinations found. Try adjusting your preferences.",
      "planner.destinations.profileBased": "Based on {{score}}% of your profile",
      "planner.destinations.select": "Select",
      "planner.destinations.limitExceeded": "I can only show 5 destinations maximum, but here are my {{count}} best recommendations for you...",
      "planner.destinations.searching": "Searching for {{count}} perfect destinations for you...",
      // Additional travelers widget keys
      "planner.travelers.countTitle": "Number of travelers",
      "planner.travelers.editTitle": "Edit number of travelers",
      "planner.travelers.adultsDesc": "12 years and up",
      "planner.travelers.childrenDesc": "2-11 years",
      "planner.travelers.infantsDesc": "Under 2 years",
      "planner.travelers.confirmCount": "Confirm ({{count}} traveler)",
      "planner.travelers.confirmCount_plural": "Confirm ({{count}} travelers)",
      "planner.travelers.soloQuestion": "Traveling alone?",
      "planner.travelers.yesSolo": "Yes, traveling alone",
      "planner.travelers.noEdit": "No, edit",
      // City selection additional keys
      "planner.city.loadingCities": "Loading cities...",
      "planner.city.chooseIn": "Choose a city in {{country}}",
      "planner.city.recommendedLabel": "Recommended",
      "planner.city.bestChoice": "Best choice",
      "planner.city.popularDestination": "Most popular and best-served destination",
      // Date picker additional keys
      "planner.datePicker.weekdays": "Mo,Tu,We,Th,Fr,Sa,Su",
      "planner.datePicker.selectDeparture": "Select departure",
      "planner.datePicker.selectReturn": "Select return",
      "planner.datePicker.selectDate": "Select a date",
      "planner.datePicker.confirmDate": "Confirm: {{date}}",
      "planner.datePicker.confirmRange": "Confirm: {{start}} → {{end}}",
      "planner.datePicker.selectReturnDate": "Select return date",
      "planner.datePicker.selectDepartureDate": "Select departure date",
      // Top bar tabs
      "planner.tabs.flights": "Flights",
      "planner.tabs.stays": "Stays",
      "planner.tabs.activities": "Activities",
      "planner.tabs.preferences": "Preferences",
      "planner.tabs.backToHome": "Back to home",
      "planner.tabs.openChat": "Open chat",
      "planner.tabs.leaveConfirm": "Leave planner?",
      "planner.myTrip": "My Trip",
      // Step suggestions
      "planner.step.selectDestination": "Let's start by choosing your destination",
      "planner.step.selectDates": "Perfect! Now let's select your travel dates",
      "planner.step.selectTravelers": "How many travelers will you be?",
      "planner.step.searchFlights": "All set! Let's search for the best flights",
      "planner.step.selectHotel": "Flight selected! Now let's find accommodation",
      "planner.step.selectActivities": "Excellent choice! Let's add activities to your stay",
      "planner.step.tripComplete": "Your trip is ready! Here's the summary",
      "planner.step.buttonDestination": "Choose a destination",
      "planner.step.buttonDates": "Choose dates",
      "planner.step.buttonTravelers": "Specify travelers",
      "planner.step.buttonSearch": "Search flights",
      "planner.step.buttonHotel": "See hotels",
      "planner.step.buttonActivities": "Discover activities",
      "planner.step.buttonSummary": "See summary",
      // Chat UI labels
      "planner.chat.newConversation": "New conversation",
      "planner.chat.history": "History",
      "planner.chat.closeChat": "Close chat",
      "planner.chat.inputPlaceholder": "Send a message...",
      "planner.chat.inputLoading": "Responding...",
      "planner.chat.inputHelper": "Type a destination or ask about flights, activities, accommodations",
      "planner.chat.send": "Send",
      "planner.chat.noConversation": "No conversations",
      "planner.chat.creating": "Creating...",
      "planner.chat.deleting": "Deleting...",
      "planner.chat.deleteAll": "Delete all",
      "planner.chat.createdToast": "New conversation created",
      "planner.chat.creatingToast": "Creating conversation...",
      "planner.chat.deletedToast": "History deleted",
      "planner.chat.deletingToast": "Deleting history...",
      // Dialog labels
      "planner.dialog.deleteTitle": "Delete this conversation?",
      "planner.dialog.deleteDesc": "This action is irreversible. The conversation will be permanently deleted.",
      "planner.dialog.newTitle": "New conversation?",
      "planner.dialog.newDesc": "Reset flights, accommodations, activities and preferences?",
      "planner.dialog.deleteAllTitle": "Delete all history?",
      "planner.dialog.deleteAllDesc": "This action is irreversible. All conversations, flights, accommodations and preferences will be permanently deleted.",
      "planner.dialog.cancel": "Cancel",
      "planner.dialog.confirm": "Confirm",
      "planner.dialog.delete": "Delete",
      // Quick replies
      "planner.quick.whenToGo": "When to go?",
      "planner.quick.howMuch": "How much?",
      
      // ScrollToBottomButton
      "planner.chat.scrollToBottom": "Back to bottom",
      "planner.chat.newMessage": "{{count}} new message",
      "planner.chat.newMessages": "{{count}} new messages",
      
      // Chat system messages
      "planner.messages.tripConfigured": "Great! Your trip **{{from}} → {{to}}** is configured:",
      "planner.messages.departureDate": "📅 Departure: {{date}}",
      "planner.messages.returnDate": "📅 Return: {{date}}",
      "planner.messages.travelers": "👥 {{count}} traveler",
      "planner.messages.travelersPlural": "👥 {{count}} travelers",
      "planner.messages.selectAirports": "Select your airports below:",
      "planner.messages.selectAirportsPanel": "Please select your airports in the right panel.",
      "planner.messages.searchReady": "Perfect! Your itinerary **{{from}} → {{to}}** is ready!",
      "planner.messages.clickToSearch": "Click below to start searching. 🚀",
      "planner.messages.destinationsFound": "Here is {{count}} perfect destination for you, based on your profile ({{score}}% completion):",
      "planner.messages.destinationsFoundPlural": "Here are {{count}} perfect destinations for you, based on your profile ({{score}}% completion):",
      "planner.messages.noDestinations": "Sorry, I couldn't find destinations matching your criteria. Try adjusting your preferences.",
      "planner.messages.noDestinationsHint": "Sorry, I couldn't find destinations matching your criteria. Try telling me your travel preferences first with 'Inspire me!' 🌍",
      "planner.messages.errorDestinations": "An error occurred while searching for destinations. Please try again.",
      "planner.messages.searchingDestinations": "Searching for {{count}} perfect destinations for you...",
      "planner.messages.defaultError": "Sorry, I couldn't respond.",
      "planner.messages.exceededLimit": "I can only show 5 destinations maximum, but here are my {{count}} best recommendations for you...",
      
      // FlightRouteBuilder & FlightsPanel
      "planner.flights.searching": "Searching...",
      "planner.flights.minChars": "Type at least 3 characters",
      "planner.flights.noResults": "No results found",
      "planner.flights.airport": "Airport",
      "planner.flights.country": "Country",
      "planner.flights.city": "City",
      "planner.flights.departure": "Departure",
      "planner.flights.destination": "Destination",
      "planner.flights.swapCities": "Swap departure and destination",
      "planner.flights.outbound": "Outbound",
      "planner.flights.inbound": "Return",
      "planner.flights.date": "Date",
      "planner.flights.closeCalendar": "Close calendar",
      "planner.flights.addDestination": "Add destination",
      "planner.flights.roundtrip": "Round trip",
      "planner.flights.oneway": "One way",
      "planner.flights.multiCity": "Multi-city",
      "planner.flights.passengers": "Passengers & Baggage",
      "planner.flights.addPassenger": "+ Add",
      "planner.flights.adult": "Adult",
      "planner.flights.child": "Child",
      "planner.flights.cabin": "Cabin",
      "planner.flights.hold": "Hold",
        "planner.flights.cabinBag": "Cabin",
        "planner.flights.checkedBag": "Checked",
      "planner.flights.cabinClass": "Class",
      "planner.flights.economy": "Economy",
      "planner.flights.business": "Business",
      "planner.flights.first": "First",
      "planner.flights.options": "Options",
      "planner.flights.directOnly": "Direct flights only",
      "planner.flights.flexibleDates": "Flexible dates (±3 days)",
      "planner.flights.search": "Search",
      "planner.flights.searchingAirports": "Searching airports...",
      "planner.flights.modify": "Modify",
      "planner.flights.selected": "flights selected",
      "planner.flights.bookItinerary": "Book full itinerary",
      "planner.flights.closePanel": "Close panel",
      
      // FlightResults component
      "planner.flightResults.bestPrice": "Best price",
      "planner.flightResults.fastest": "Fastest",
      "planner.flightResults.lowestCO2": "Lowest CO₂",
      "planner.flightResults.nightLayover": "Night layover",
      "planner.flightResults.direct": "Direct",
      "planner.flightResults.stop": "{{count}} stop",
      "planner.flightResults.stops": "{{count}} stops",
      "planner.flightResults.select": "Select",
      "planner.flightResults.perPerson": "/person",
      "planner.flightResults.hideDetails": "Hide details",
      "planner.flightResults.showDetails": "Show details",
      "planner.flightResults.outboundFlight": "Outbound flight",
      "planner.flightResults.returnFlight": "Return flight",
      "planner.flightResults.aircraft": "Aircraft",
      "planner.flightResults.legroom": "Legroom",
      "planner.flightResults.comfort": "Comfort",
      "planner.flightResults.layoverAt": "Layover at {{city}}",
      "planner.flightResults.baggage": "Baggage",
      "planner.flightResults.carryOn": "Carry-on",
      "planner.flightResults.checked": "Checked",
      "planner.flightResults.emissions": "Emissions",
      "planner.flightResults.lessThanAvg": "less than average",
      "planner.flightResults.moreThanAvg": "more than average",
      "planner.flightResults.selfTransfer": "Self-transfer",
      "planner.flightResults.selfTransferNote": "Collect baggage between flights",
      "planner.flightResults.noResults": "No flights found",
      "planner.flightResults.noResultsDesc": "Try modifying your search criteria",
      "planner.flightResults.loading": "Searching flights...",
      
      // DestinationPopup
      "planner.destination.close": "Close",
      "planner.destination.discover": "Discover",
      "planner.flightResults.flightFound": "flight found",
      "planner.flightResults.flightsFound": "flights found",
      "planner.flightResults.scrollMore": "Scroll for more",
      "planner.flightResults.notIncluded": "Not included",
      "planner.flightResults.carryOnIncluded": "Carry-on bag included",
      
      // BaseStep (preferences)
      "planner.presets.quickStart": "Quick start",
      "planner.presets.close": "Close",
      "planner.presets.oneClick": "Fill in 1 click",
      "planner.presets.romantic": "Romantic getaway",
      "planner.presets.adventure": "Adventure with friends",
      "planner.presets.family": "Family vacation",
      "planner.presets.workation": "Workation",
      "planner.presets.travelers": "Travelers",
      "planner.presets.occasion": "Trip occasion",
      "planner.presets.optional": "optional",
      "planner.presets.defineStyle": "Define your style",
      
      // PreferenceSummary
      "planner.summary.generating": "Generating profile...",
      "planner.summary.analyzing": "Analyzing your style...",
      "planner.summary.yourProfile": "Your traveler profile",
      "planner.summary.regenerate": "Regenerate profile",
      "planner.summary.placeholder": "Refine your preferences to discover your unique traveler profile...",
      "planner.summary.energy.zen": "zen and relaxation",
      "planner.summary.energy.balanced": "balanced",
      "planner.summary.energy.dynamic": "dynamic",
      "planner.summary.energy.intense": "intense and sporty",
      "planner.summary.terrain.urban": "urban and cultural",
      "planner.summary.terrain.mixed": "mixed city/nature",
      "planner.summary.terrain.open": "wide open spaces",
      "planner.summary.terrain.wild": "wild nature",
      "planner.summary.budget.budget": "budget-friendly",
      "planner.summary.budget.smart": "smart spending",
      "planner.summary.budget.comfortable": "comfortable",
      "planner.summary.budget.luxury": "luxurious",
      "planner.summary.auth.classic": "must-sees",
      "planner.summary.auth.balanced": "balanced",
      "planner.summary.auth.local": "local experiences",
      "planner.summary.auth.authentic": "authentic adventure",
      "planner.quick.seeActivities": "See activities",
      "planner.quick.cheapestFlight": "Cheapest flight",
      "planner.quick.fastestFlight": "Fastest flight",
      "planner.quick.findHotel": "Find a hotel",
      "planner.quick.travelers": "Number of travelers",
      "planner.quick.flexible": "Flexible dates?",
      "planner.quick.discoverActivities": "Discover activities",
      "planner.quick.otherHotels": "Other hotels",
      "planner.quick.summary": "Summary",
      "planner.quick.help": "Help",
      "planner.quick.inspireMe": "Inspire me",
      
      // Onboarding Tour
      "planner.onboarding.stepLabels": "Intro,Chat,Tools,Map,Flights,Stays,Activities,Prefs,End",
      "planner.onboarding.skipGuide": "Skip guide",
      "planner.onboarding.next": "Next →",
      "planner.onboarding.prev": "← Previous",
      "planner.onboarding.done": "Let's go! ✨",
      "planner.onboarding.step0.title": "✨ Welcome to Travliaq!",
      "planner.onboarding.step0.desc": "Plan your ideal trip in minutes with our intelligent assistant.",
      "planner.onboarding.step0.info": "This quick guide presents the main features in 30 seconds.",
      "planner.onboarding.step0.skip": "You can skip this guide anytime with the × button",
      "planner.onboarding.step1.title": "💬 AI Assistant",
      "planner.onboarding.step1.badge": "Smart chat",
      "planner.onboarding.step1.desc": "Speak naturally to plan your trip.",
      "planner.onboarding.step1.item1": "Ask for personalized recommendations",
      "planner.onboarding.step1.item2": "Configure your flights, accommodations, activities",
      "planner.onboarding.step1.item3": "AI syncs everything automatically in the widgets",
      "planner.onboarding.step1.tip": "Example: \"I want to go to Bali in April for 2 weeks\"",
      "planner.onboarding.step2.title": "🛠️ Toolbar",
      "planner.onboarding.step2.badge": "Instant access",
      "planner.onboarding.step2.desc": "Use these buttons to switch between widgets without losing track of your conversation.",
      "planner.onboarding.step2.flights": "✈️ Flights — configure itinerary, dates, passengers",
      "planner.onboarding.step2.stays": "🏨 Stays — choose an area + filter by your criteria",
      "planner.onboarding.step2.activities": "🎭 Activities — explore, filter and add to itinerary",
      "planner.onboarding.step2.preferences": "⚙️ Preferences — refine travel style to guide AI",
      "planner.onboarding.step2.tip": "Tip: click a tab, then tell the AI what you want — everything fills in automatically.",
      "planner.onboarding.step3.title": "🗺️ Interactive Map",
      "planner.onboarding.step3.badge": "Real-time visualization",
      "planner.onboarding.step3.desc": "Explore your trip on the map:",
      "planner.onboarding.step3.item1": "Live prices — click a destination to see rates",
      "planner.onboarding.step3.item2": "Itineraries — your routes display automatically",
      "planner.onboarding.step3.item3": "Zoom — discover more destinations by zooming",
      "planner.onboarding.step4.title": "✈️ Flights Widget",
      "planner.onboarding.step4.badge": "Search and compare",
      "planner.onboarding.step4.desc": "This complete panel lets you configure all flight details.",
      "planner.onboarding.step4.item1": "Trip type — round trip, one way, multi-city",
      "planner.onboarding.step4.item2": "Origin & destination — airports or cities",
      "planner.onboarding.step4.item3": "Dates & travelers — flexible or fixed",
      "planner.onboarding.step4.item4": "Advanced options — direct flights, baggage, class…",
      "planner.onboarding.step4.tip": "Results appear here after the search",
      "planner.onboarding.step5.title": "🏨 Stays Widget",
      "planner.onboarding.step5.badge": "Find your ideal stay",
      "planner.onboarding.step5.desc": "Search among thousands of accommodation options.",
      "planner.onboarding.step5.item1": "Destination — synced with your flights automatically",
      "planner.onboarding.step5.item2": "Budget & comfort — set your price range",
      "planner.onboarding.step5.item3": "Type — hotel, apartment, villa, hostel…",
      "planner.onboarding.step5.item4": "Amenities — pool, WiFi, parking, breakfast…",
      "planner.onboarding.step5.tip": "Prices also display on the map",
      "planner.onboarding.step6.title": "🎭 Activities Widget",
      "planner.onboarding.step6.badge": "Discover what to do",
      "planner.onboarding.step6.desc": "Explore the best activities at your destination.",
      "planner.onboarding.step6.item1": "Categories — culture, nature, food, adventure…",
      "planner.onboarding.step6.item2": "Filters — price, duration, popularity, accessibility",
      "planner.onboarding.step6.item3": "Location — view activities on the map",
      "planner.onboarding.step6.item4": "Details — photos, reviews, schedules, booking",
      "planner.onboarding.step6.tip": "Add activities to your itinerary with one click",
      "planner.onboarding.step7.title": "⚙️ Preferences Widget",
      "planner.onboarding.step7.badge": "Customize the experience",
      "planner.onboarding.step7.desc": "Your preferences guide AI for tailored recommendations.",
      "planner.onboarding.step7.item1": "Pace — relaxed, moderate or intensive",
      "planner.onboarding.step7.item2": "Budget — budget, comfort or premium",
      "planner.onboarding.step7.item3": "Interests — culture, beach, mountain, nightlife…",
      "planner.onboarding.step7.item4": "Style — solo, couple, family, group of friends",
      "planner.onboarding.step7.tip": "The more precise your preferences, the better the suggestions",
      "planner.onboarding.step8.title": "🚀 You're ready!",
      "planner.onboarding.step8.desc": "Your travel assistant awaits.",
      "planner.onboarding.step8.tip": "To start: say hello to the assistant or configure your flights directly!",
      "planner.onboarding.step8.info": "You can restart this guide from settings anytime.",
      
      // PlannerPanel flights additional
      "planner.flights.segmentsToSearch": "Segments to search",
      "planner.flights.searchNFlights": "Search {{count}} flights",
      "planner.flights.searchFlights": "Search flights",
      "planner.flights.missingInfo": "Missing: {{info}}",
      "planner.flights.incompleteSegments": "{{count}} incomplete segment(s)",
      "planner.flights.nearbyAirports": "Nearby airports",
      "planner.flights.noEveningFlights": "No evening flights",
      
      // AccommodationPanel
      "planner.accommodation.searching": "Searching...",
      "planner.accommodation.minChars": "Type at least 3 characters",
      "planner.accommodation.noResults": "No results",
      "planner.accommodation.whereTo": "City or destination",
      "planner.accommodation.adults": "Adults",
      "planner.accommodation.adultsDesc": "18 years and up",
      "planner.accommodation.childrenLabel": "Children",
      "planner.accommodation.childrenDesc": "0 - 17 years",
      "planner.accommodation.childrenAges": "Children's ages",
      "planner.accommodation.year": "year",
      "planner.accommodation.years": "years",
      "planner.accommodation.adult": "adult",
      "planner.accommodation.child": "child",
      "planner.accommodation.rooms.single": "1 single room",
      "planner.accommodation.rooms.double": "1 double room",
      "planner.accommodation.rooms.family": "1 family room",
      "planner.accommodation.rooms.count": "{{count}} rooms",
      "planner.accommodation.rooms.room": "Room {{num}}",
      "planner.accommodation.rooms.remove": "Remove",
      "planner.accommodation.rooms.add": "Add a room",
      "planner.accommodation.rooms.autoConfig": "Auto configuration",
      "planner.accommodation.rooms.enabled": "Enabled",
      "planner.accommodation.rooms.disabled": "Disabled",
      "planner.accommodation.rooms.mismatch": "{{inRooms}} people in rooms / {{travelers}} travelers",
      "planner.accommodation.dates.selectDates": "Select your dates",
      "planner.accommodation.dates.selectReturn": "Choose departure date",
      "planner.accommodation.dates.nightsSelected": "{{count}} night selected",
      "planner.accommodation.dates.nightsSelectedPlural": "{{count}} nights selected",
      "planner.accommodation.dates.syncedWithFlight": "Dates synced with your flights",
      "planner.accommodation.dates.arrivalSynced": "Arrival date synced with flight",
      "planner.accommodation.dates.stayDates": "Stay dates",
      "planner.accommodation.dates.return": "Return?",
      "planner.accommodation.dates.canModify": "Feel free to modify them if needed",
      "planner.accommodation.type.hotel": "Hotel",
      "planner.accommodation.type.apartment": "Apartment",
      "planner.accommodation.type.villa": "Villa",
      "planner.accommodation.type.hostel": "Hostel",
      "planner.accommodation.type.guesthouse": "Guesthouse",
      "planner.accommodation.type.any": "All",
      "planner.accommodation.type.label": "Type",
      "planner.accommodation.budget.perNight": "Budget per night",
      "planner.accommodation.budget.eco": "Budget",
      "planner.accommodation.budget.comfort": "Comfort",
      "planner.accommodation.budget.premium": "Premium",
      "planner.accommodation.rating.min": "Minimum rating",
      "planner.accommodation.rating.all": "All",
      "planner.accommodation.amenities.label": "Amenities",
      "planner.accommodation.amenities.wifi": "WiFi",
      "planner.accommodation.amenities.parking": "Parking",
      "planner.accommodation.amenities.breakfast": "Breakfast",
      "planner.accommodation.amenities.ac": "A/C",
      "planner.accommodation.amenities.pool": "Pool",
      "planner.accommodation.amenities.kitchen": "Kitchen",
      "planner.accommodation.filters.advanced": "Advanced filters",
      "planner.accommodation.filters.mealPlan": "Meal plan",
      "planner.accommodation.filters.halfBoard": "Half board",
      "planner.accommodation.filters.fullBoard": "Full board",
      "planner.accommodation.filters.allInclusive": "All-inclusive",
      "planner.accommodation.filters.views": "View",
      "planner.accommodation.filters.sea": "Sea",
      "planner.accommodation.filters.mountain": "Mountain",
      "planner.accommodation.filters.city": "City",
      "planner.accommodation.filters.garden": "Garden",
      "planner.accommodation.filters.poolView": "Pool",
      "planner.accommodation.filters.services": "Services",
      "planner.accommodation.filters.roomService": "Room service",
      "planner.accommodation.filters.spa": "Spa",
      "planner.accommodation.filters.gym": "Gym",
      "planner.accommodation.filters.shuttle": "Shuttle",
      "planner.accommodation.filters.accessibility": "Accessibility",
      "planner.accommodation.filters.pmr": "Wheelchair",
      "planner.accommodation.filters.baby": "Baby",
      "planner.accommodation.filters.pets": "Pets",
      "planner.accommodation.search": "Search accommodations",
      "planner.accommodation.searching.hotels": "Searching hotels...",
      "planner.accommodation.addDestination": "Add a destination",
      "planner.accommodation.syncedFlights": "Synced with your flights",
      "planner.accommodation.destinationIncomplete": "Incomplete destination",
      "planner.accommodation.destinationIncompleteDesc": "Select a city from the list (not just text) to get country and coordinates.",
      "planner.accommodation.datesMissing": "Missing dates",
      "planner.accommodation.datesMissingDesc": "Choose an arrival and departure date to search for accommodations.",
      "planner.accommodation.noResults.title": "No results",
      "planner.accommodation.noResults.desc": "No hotels found for these criteria",
      "planner.accommodation.synced": "Accommodations synced",
      "planner.accommodation.syncedDesc": "{{count}} destination updated from your flights",
      "planner.accommodation.syncedDescPlural": "{{count}} destinations updated from your flights",
      "planner.accommodation.locationError": "Location unavailable",
      "planner.accommodation.locationErrorDesc": "Unable to determine the city at this location",
      "planner.accommodation.searchError": "Search error",
      "planner.accommodation.newArea": "New area",
      "planner.accommodation.foundInCity": "{{count}} accommodations found in {{city}}",
      "planner.accommodation.destinationAdded": "Destination added",
      "planner.accommodation.destinationAddedDesc": "{{city}} has been added to your accommodations",
      "planner.accommodation.booking": "Booking",
      "planner.accommodation.bookingSoon": "Booking will be available soon!",
      "planner.accommodation.defaultName": "Accommodation {{num}}",
      "planner.accommodation.shortName": "Stay {{num}}",
      "planner.accommodation.searchCity": "Search for a city...",
      
      // Hotels (HotelSearchResults)
      "planner.hotels.perNight": "night",
      "planner.hotels.total": "Total",
      "planner.hotels.viewDetails": "View details",
      "planner.hotels.inDestination": "Stays in {{destination}}",
      "planner.hotels.searching": "Searching...",
      "planner.hotels.resultsCount": "{{count}} results · {{nights}} night(s)",
      "planner.hotels.noResults": "No accommodations found for these criteria",
      "planner.hotels.modifySearch": "Modify search",
      
      // HotelDetailView
      "planner.hotels.free": "Free",
      "planner.hotels.paid": "Paid",
      "planner.hotels.freeCancellation": "Free cancellation",
      "planner.hotels.breakfastIncluded": "Breakfast incl.",
      "planner.hotels.popular": "Popular",
      "planner.hotels.excellentChoice": "Excellent choice",
      "planner.hotels.veryAppreciated": "Highly rated",
      "planner.hotels.cityCenter": "City center",
      "planner.hotels.nearCenter": "Near center",
      "planner.hotels.pool": "Pool",
      "planner.hotels.spa": "Spa",
      "planner.hotels.availableRooms": "Available rooms ({{count}})",
      "planner.hotels.showLess": "Show less",
      "planner.hotels.showAllRooms": "Show all {{count}} rooms",
      "planner.hotels.showOtherRooms": "Show {{count}} other rooms",
      "planner.hotels.whyBookHere": "Why book here?",
      "planner.hotels.bestPriceGuarantee": "Best price guarantee - we'll refund the difference",
      "planner.hotels.instantConfirmation": "Instant confirmation by email",
      "planner.hotels.support24h": "24/7 customer support",
      "planner.hotels.persons": "pers.",
      "planner.hotels.night": "night",
      "planner.hotels.fromCenter": "from city center",
      "planner.hotels.rating.exceptional": "Exceptional",
      "planner.hotels.rating.veryGood": "Very good",
      "planner.hotels.rating.good": "Good",
      "planner.hotels.rating.correct": "Okay",
      "planner.hotels.rating.fair": "Fair",
      "planner.hotels.amenities.connectivity": "Connectivity",
      "planner.hotels.amenities.food": "Food & Drinks",
      "planner.hotels.amenities.wellness": "Wellness",
      "planner.hotels.amenities.room": "Room",
      "planner.hotels.amenities.services": "Services",
      "planner.hotels.amenities.general": "Other",
      "planner.hotels.amenities.wifi": "WiFi",
      "planner.hotels.amenities.parking": "Parking",
      "planner.hotels.amenities.breakfast": "Breakfast",
      "planner.hotels.amenities.fitness": "Fitness",
      "planner.hotels.amenities.restaurant": "Restaurant",
      "planner.hotels.amenities.ac": "Air conditioning",
      "planner.hotels.notYetRated": "Not rated yet",
      "planner.hotels.checkIn": "Check-in",
      "planner.hotels.checkOut": "Check-out",
      "planner.hotels.nights": "{{count}} night",
      "planner.hotels.nightsPlural": "{{count}} nights",
      "planner.hotels.location": "Location",
      "planner.hotels.detailedRatings": "Detailed ratings",
      "planner.hotels.whatThisOffers": "What this property offers",
      "planner.hotels.cancellationPolicy": "Cancellation policy",
      "planner.hotels.goToPhoto": "Go to photo {{index}}",
      "planner.hotels.ratingBreakdown.cleanliness": "Cleanliness",
      "planner.hotels.ratingBreakdown.staff": "Staff",
      "planner.hotels.ratingBreakdown.location": "Location",
      "planner.hotels.ratingBreakdown.facilities": "Facilities",
      "planner.hotels.ratingBreakdown.comfort": "Comfort",
      "planner.hotels.ratingBreakdown.valueForMoney": "Value for money",
      
      // AIConflictBadge
      "planner.ai.conflict.travelStyle": "Travel style",
      "planner.ai.conflict.comfortLevel": "Comfort level",
      "planner.ai.conflict.pace": "Pace",
      "planner.ai.conflict.interests": "Interests",
      "planner.ai.conflict.occasion": "Occasion",
      "planner.ai.conflict.energy": "Energy",
      "planner.ai.conflict.budget": "Budget",
      "planner.ai.conflict.environment": "Environment",
      "planner.ai.conflict.authenticity": "Authenticity",
      
      // PreferenceSummary - Travel style labels for LLM prompt
      "planner.summary.travelStyle.solo": "solo",
      "planner.summary.travelStyle.couple": "as a couple",
      "planner.summary.travelStyle.family": "as a family",
      "planner.summary.travelStyle.friends": "with friends",
      "planner.summary.travelStyle.pet": "with pet",
      "planner.summary.occasion.honeymoon": "honeymoon",
      "planner.summary.occasion.anniversary": "couple anniversary",
      "planner.summary.occasion.birthday": "birthday celebration",
      "planner.summary.occasion.vacation": "vacation",
      "planner.summary.occasion.workation": "workation",
      "planner.summary.occasion.other": "discovery",
      "planner.summary.polyvalent": "versatile",
      
      // MapPreviewWidget
      "planner.map.viewOnMap": "View on map",
      "planner.map.viewMap": "View map",
      "planner.map.openInMaps": "Open in Maps",
      "planner.map.enlarge": "Enlarge",
      "planner.map.map": "Map",
      "planner.map.places": "place",
      "planner.map.placesPlural": "places",
      "planner.map.day": "Day {{day}}",
      "planner.map.trips": "trip",
      "planner.map.tripsPlural": "trips",
      "planner.map.travelTime": "h travel time",
      
      // FlightComparisonCard
      "planner.flights.comparison.bestPrice": "Best price",
      "planner.flights.comparison.fastest": "Fastest",
      "planner.flights.comparison.mostComfortable": "Most comfortable",
      "planner.flights.comparison.bestSchedule": "Best schedule",
      "planner.flights.comparison.included": "Included",
      "planner.flights.comparison.notIncluded": "Not included",
      "planner.flights.comparison.cabinOnly": "Cabin only",
      "planner.flights.comparison.outbound": "Outbound",
      "planner.flights.comparison.return": "Return",
      "planner.flights.comparison.direct": "Direct",
      "planner.flights.comparison.stop": "stop",
      "planner.flights.comparison.stops": "stops",
      "planner.flights.comparison.cheaper": "Cheaper",
      "planner.flights.comparison.faster": "Faster",
      "planner.flights.comparison.select": "Select",
      "planner.flights.comparison.totalDuration": "Total duration",
      "planner.flights.comparison.layovers": "Layovers",
      "planner.flights.comparison.baggage": "Baggage",
      "planner.flights.comparison.flexibility": "Flexibility",
      "planner.flights.comparison.refundable": "Refundable",
      "planner.flights.comparison.changeable": "Changeable",
      "planner.flights.comparison.notFlexible": "Not flex.",
      "planner.flights.comparison.perPerson": "pers.",
      
      // AirportConfirmationWidget
      "planner.airports.confirmed": "Airports confirmed",
      "planner.airports.selection": "Airport selection",
      "planner.airports.search": "Search {{count}} flight",
      "planner.airports.searchPlural": "Search {{count}} flights",
      "planner.airports.searching": "Searching...",
      "planner.airports.recommended": "recommended",
      "planner.airports.bestChoice": "Best choice",
      "planner.airports.accept": "Accept",
      "planner.airports.seeOthers": "See others",
      "planner.airports.departureAirports": "Available departure airports",
      "planner.airports.arrivalAirports": "Available arrival airports",
      "planner.airports.closerToCenter": "Closest",
      "planner.airports.furtherAway": "Further away",
      "planner.airports.majorInternational": "Major international airport",
      "planner.airports.moreFlights": "More flights available",
      "planner.airports.betterConnection": "Better connection",
      "planner.airports.quickAccess": "Quick access from center",
      "planner.airports.fewerFlights": "Fewer flight options",
      "planner.airports.kmFromCenter": "km from center",
      "planner.airports.departure": "Departure",
      "planner.airports.arrival": "Arrival",
      
      // CitySelectionWidget
      "planner.cities.recommended": "Recommended",
      "planner.cities.bestChoice": "Best choice",
      "planner.cities.chooseCity": "Choose a city in {{country}}",
      "planner.cities.loading": "Loading cities...",
      "planner.cities.mostPopular": "Most popular and best-served destination",
      "planner.cities.otherDestinations": "Other destinations",
      
      // DirectFlightToggle
      "planner.flights.toggle.allFlights": "All flights",
      "planner.flights.toggle.directOnly": "Direct only",
      "planner.flights.toggle.all": "All",
      "planner.flights.toggle.direct": "Direct",
      "planner.flights.toggle.maxOneStop": "1 stop max",
      
      // BudgetProgressWidget
      "planner.budget.spent": "Spent",
      "planner.budget.overspent": "Overspent",
      "planner.budget.remaining": "Remaining",
      "planner.budget.budgetUsed": "Budget used",
      "planner.budget.of": "of",
      "planner.budget.budget": "Budget",
      
      // NavigationButtons
      "planner.nav.modifySearch": "Modify search",
      "planner.nav.viewMore": "View more",
      "planner.nav.viewMoreResults": "View {{count}} more result",
      "planner.nav.viewMoreResultsPlural": "View {{count}} more results",
      "planner.nav.back": "Back",
      "planner.nav.restart": "Start over",
      "planner.nav.restartConfirm": "Are you sure you want to restart planning?",
      "planner.nav.refresh": "Refresh",
      "planner.nav.home": "Home",
      
      // ResultBadges
      "planner.badges.bestDeal": "Best deal",
      "planner.badges.popular": "Popular",
      "planner.badges.recommended": "Recommended",
      "planner.badges.topRated": "Top rated",
      "planner.badges.lastMinute": "Last minute",
      "planner.badges.fastSelling": "Selling fast",
      "planner.badges.favorite": "Favorite",
      "planner.badges.new": "New",
      "planner.badges.trending": "Trending",
      "planner.badges.premium": "Premium",
      
      // TripTypeConfirmWidget
      "planner.tripType.roundtrip": "Round trip",
      "planner.tripType.oneway": "One way",
      "planner.tripType.multi": "Multi-city",
      
      // ActivitiesPanel
      "planner.activities.searching": "Searching...",
      "planner.activities.minChars": "Type at least 3 characters",
      "planner.activities.noResults": "No results",
      "planner.activities.selectCity": "Please select a city",
      "planner.activities.added": "Activity added!",
      "planner.activities.removed": "Activity removed",
      "planner.activities.selectDestination": "Please select a destination",
      "planner.activities.addDestination": "Add a destination",
      "planner.activities.newDestination": "New destination",
      "planner.activities.searchCity": "Search for a city...",
      "planner.activities.dates": "Dates",
      "planner.activities.add": "Add",
      "planner.activities.noDestination": "No destination",
      "planner.activities.noDestinationDesc": "Add a destination to explore activities",
      "planner.activities.datesToDefine": "Dates to be set",
      "planner.activities.search": "Search activities",
      "planner.activities.searching.activities": "Searching...",
      "planner.activities.selected": "Selected activities",
      "planner.activities.others": "+{{count}} more",
      "planner.activities.back": "Back",
      "planner.activities.sortDefault": "Default",
      "planner.activities.sortPriceAsc": "Price ↑",
      "planner.activities.sortPriceDesc": "Price ↓",
      "planner.activities.sortRating": "Best rated",
      "planner.activities.sortDuration": "Longest duration",
      "planner.activities.found": "{{count}} activity found",
      "planner.activities.foundPlural": "{{count}} activities found",
      "planner.activities.attractionsOnMap": "+ {{count}} attraction on map",
      "planner.activities.attractionsOnMapPlural": "+ {{count}} attractions on map",
      "planner.activities.noFound": "No activities found",
      "planner.activities.noFoundDesc": "Try modifying your search criteria",
      "planner.activities.inheritedDestination": "This destination comes from accommodations. Modify it in the Stays tab.",
      "planner.activities.needOneDestination": "You must have at least one destination",
      "planner.activities.destinationRemoved": "Destination removed",
      "planner.activities.cityAdded": "{{city}} added!",
      "planner.activities.cannotGetVisibleArea": "Unable to get the visible area",
      "planner.activities.foundInZone": "{{attractions}} attractions and {{activities}} activities found in this area",
      "planner.activities.noActivityInZone": "No activities found in this area",
      "planner.activities.searchZoneError": "Error searching in this area",
      "planner.activities.activityAdded": "Activity added!",
      "planner.activities.activityRemoved": "Activity removed",
      "planner.activities.cityOrDestination": "City or destination",
      "planner.activities.nights": "n",
      "planner.activities.addDestinationToExplore": "Add a destination to explore activities",
      "planner.activities.thisCity": "this city",
      "planner.activities.addCity": "Add {{city}}",
      "planner.activities.searchInProgress": "Searching...",
      "planner.activities.searchActivities": "Search activities",
      "planner.activities.selectedActivities": "Selected activities ({{count}})",
      "planner.activities.sort.default": "Default",
      "planner.activities.sort.priceAsc": "Price ↑",
      "planner.activities.sort.priceDesc": "Price ↓",
      "planner.activities.sort.rating": "Best rated",
      "planner.activities.sort.duration": "Longest duration",
      "planner.activities.activitiesFound": "{{count}} activity(ies) found",
      "planner.activities.noActivityFound": "No activities found",
      "planner.activities.tryCriteria": "Try modifying your search criteria",
      "planner.activities.durationUnspecified": "Duration not specified",
      "planner.activities.popular": "Popular",
      "planner.activities.topRated": "Top rated",
      "planner.activities.activity": "Activity",
      "planner.activities.attraction": "Attraction",
      "planner.activities.reviews": "reviews",
      "planner.activities.perPerson": "person",
      "planner.activities.details": "Details",
      "planner.activities.remove": "Remove",
      
      // PreferencesPanel
      "planner.preferences.detectedByAI": "Preferences detected by AI",
      "planner.preferences.steps.base": "Base",
      "planner.preferences.steps.style": "Style",
      "planner.preferences.steps.criteria": "Criteria",
      
      // ActivityFilters
      "planner.activityFilters.filters": "Filters",
      "planner.activityFilters.clear": "Clear",
      "planner.activityFilters.travelers": "traveler(s)",
      "planner.activityFilters.adultsCount": "{{count}} adult(s)",
      "planner.activityFilters.childrenCount": "{{count}} child(ren)",
      "planner.activityFilters.autoSelect": "Auto-select based on my preferences",
      "planner.activityFilters.categories": "Categories",
      "planner.activityFilters.budgetPerActivity": "Budget / activity",
      "planner.activityFilters.minRating": "Minimum rating",
      "planner.activityFilters.all": "All",
      "planner.activityFilters.advancedFilters": "Advanced filters",
      "planner.activityFilters.timeOfDay": "Time of day",
      "planner.activityFilters.morning": "Morning",
      "planner.activityFilters.afternoon": "Afternoon",
      "planner.activityFilters.evening": "Evening",
      "planner.activityFilters.activityDuration": "Activity duration",
      "planner.activityFilters.under1h": "< 1h",
      "planner.activityFilters.1to4h": "1-4h",
      "planner.activityFilters.over4h": "> 4h",
      "planner.activityFilters.fullDay": "Full day",
      "planner.activityFilters.multiDay": "Multiple days",
      "planner.activityFilters.preferencesUnavailable": "Your travel preferences are not available",
      "planner.activityFilters.filtersApplied": "Filters applied: {{summary}}",
      
      // ActivityDetailModal
      "planner.activityDetail.close": "Close",
      "planner.activityDetail.durationNotSpecified": "Duration not specified",
      "planner.activityDetail.reviews": "reviews",
      "planner.activityDetail.topRated": "Top rated",
      "planner.activityDetail.duration": "Duration",
      "planner.activityDetail.location": "Location",
      "planner.activityDetail.pricePerPerson": "Price per person",
      "planner.activityDetail.options": "Options",
      "planner.activityDetail.description": "Description",
      "planner.activityDetail.priceFrom": "Price from",
      "planner.activityDetail.person": "person",
      "planner.activityDetail.save": "Save",
      "planner.activityDetail.viewOnViator": "View on Viator",
      "planner.activityDetail.removeFromPlanning": "Remove from planning",
      "planner.activityDetail.addToPlanning": "Add to planning",
      
      // PreferencesPanel - Travel Style Selector
      "planner.preferences.travelStyle.solo": "Solo",
      "planner.preferences.travelStyle.duo": "Duo",
      "planner.preferences.travelStyle.family": "Family",
      "planner.preferences.travelStyle.friends": "Friends",
      
      // PreferencesPanel - Occasion Selector
      "planner.preferences.occasion.vacation": "Vacation",
      "planner.preferences.occasion.honeymoon": "Honeymoon",
      "planner.preferences.occasion.anniversary": "Anniversary",
      "planner.preferences.occasion.birthday": "Party",
      "planner.preferences.occasion.workation": "Remote work",
      "planner.preferences.occasion.discovery": "Discovery",
      
      // PreferencesPanel - Must-Haves
      "planner.preferences.mustHaves.accessibility": "Accessibility",
      "planner.preferences.mustHaves.wifi": "High-speed WiFi",
      "planner.preferences.mustHaves.pets": "Pet-friendly",
      "planner.preferences.mustHaves.children": "Child-friendly",
      
      // PreferencesPanel - Style Step
      "planner.preferences.style.yourStyle": "Your travel style",
      "planner.preferences.style.interests": "Interests",
      "planner.preferences.style.defineCriteria": "Define your criteria",
      
      // PreferencesPanel - Criteria Step
      "planner.preferences.criteria.mustHaves": "Required criteria",
      "planner.preferences.criteria.dietary": "Dietary restrictions",
      "planner.preferences.criteria.viewSummary": "View summary",
      
      // PreferencesPanel - Profile Completion
      "planner.preferences.profile.complete": "Profile complete",
      "planner.preferences.profile.goodStart": "Good start",
      "planner.preferences.profile.someInfo": "Some info",
      "planner.preferences.profile.toComplete": "To complete",
      "planner.preferences.profile.updated": "Updated",
      "planner.preferences.profile.detectedByAI": "Detected by AI",
      
      // PreferencesPanel - Smart Tags
      "planner.preferences.smartTags.title": "Your traveler profile",
      "planner.preferences.smartTags.emptyState": "Your hashtags will appear after a few messages...",
      "planner.preferences.smartTags.analyzing": "Analyzing...",
      "planner.preferences.smartTags.recalculate": "Recalculate",
      "planner.preferences.smartTags.add": "Add",
      "planner.preferences.smartTags.placeholder": "#MyHashtag",
      
      // PreferencesPanel - Interests
      "planner.preferences.interests.selectUpTo": "Select up to {{count}}",
      "planner.preferences.interests.culture": "Culture",
      "planner.preferences.interests.food": "Gastronomy",
      "planner.preferences.interests.nature": "Nature",
      "planner.preferences.interests.beach": "Beach",
      "planner.preferences.interests.wellness": "Wellness",
      "planner.preferences.interests.sport": "Sport",
      "planner.preferences.interests.adventure": "Adventure",
      "planner.preferences.interests.nightlife": "Nightlife",
      "planner.preferences.interests.shopping": "Shopping",
      "planner.preferences.interests.history": "History",
      
      // PreferencesPanel - Dietary
      "planner.preferences.dietary.vegetarian": "Vegetarian",
      "planner.preferences.dietary.vegan": "Vegan",
      "planner.preferences.dietary.halal": "Halal",
      "planner.preferences.dietary.kosher": "Kosher",
      "planner.preferences.dietary.glutenFree": "Gluten-free",
      "planner.preferences.dietary.pescatarian": "Pescatarian",
      "planner.preferences.dietary.lactoseFree": "Lactose-free",
      "planner.preferences.dietary.noEggs": "No eggs",
      "planner.preferences.dietary.noNuts": "No nuts",
      
      // PreferencesPanel - Style Axes
      "planner.preferences.axes.chill": "Relaxed",
      "planner.preferences.axes.intense": "Intense",
      "planner.preferences.axes.urban": "Urban",
      "planner.preferences.axes.nature": "Nature",
      "planner.preferences.axes.budget": "Budget",
      "planner.preferences.axes.luxury": "Luxury",
      "planner.preferences.axes.tourist": "Touristy",
      "planner.preferences.axes.authentic": "Authentic",
      
      // TimeOfDayChips
      "planner.timeOfDay.morning": "Morning",
      "planner.timeOfDay.morningShort": "Morning",
      "planner.timeOfDay.afternoon": "Afternoon",
      "planner.timeOfDay.afternoonShort": "PM",
      "planner.timeOfDay.evening": "Evening",
      "planner.timeOfDay.eveningShort": "Evening",
      "planner.timeOfDay.night": "Night",
      "planner.timeOfDay.nightShort": "Night",
      
      // SeasonalTip
      "planner.seasonal.crowdLevel.low": "Not crowded",
      "planner.seasonal.crowdLevel.medium": "Moderate crowds",
      "planner.seasonal.crowdLevel.high": "Very crowded",
      "planner.seasonal.crowdLevel.peak": "Peak crowds",
      "planner.seasonal.priceTrend.low": "Low prices",
      "planner.seasonal.priceTrend.average": "Average prices",
      "planner.seasonal.priceTrend.high": "High prices",
      "planner.seasonal.priceTrend.peak": "Peak prices",
      "planner.seasonal.events": "Events",
      
      // TipCard
      "planner.tips.type.savings": "Save money",
      "planner.tips.type.timing": "Timing",
      "planner.tips.type.seasonal": "Seasonal tip",
      "planner.tips.type.location": "Location",
      "planner.tips.type.warning": "Warning",
      "planner.tips.type.insight": "Our insight",
      "planner.tips.type.pro": "Pro tip",
      "planner.tips.type.info": "Info",
      "planner.tips.midweekFlights.title": "Save on flights",
      "planner.tips.midweekFlights.message": "Midweek flights (Tuesday-Wednesday) are often 20-30% cheaper.",
      "planner.tips.earlyBooking.title": "Book early",
      "planner.tips.earlyBooking.message": "For best deals, book international flights 2-3 months in advance.",
      "planner.tips.flexibleDates.title": "Flexible dates?",
      "planner.tips.flexibleDates.message": "Shifting your trip by a few days can save you significantly.",
      "planner.tips.highSeason.title": "High season",
      "planner.tips.highSeason.message": "This period is in high demand. Book quickly for the best options.",
      "planner.tips.directFlight.title": "Direct flights",
      "planner.tips.directFlight.message": "A direct flight may cost a bit more but saves you precious hours.",

      // Landing - Video
      "landing.video.badge": "See Travliaq in action",
      "landing.video.title": "See how it works",
      "landing.video.subtitle": "In 2 minutes, you'll understand why thousands of travelers trust us",
      "landing.video.altPreview": "Travliaq planner preview",
      "landing.video.comingSoon": "Video coming soon",
      "landing.video.loading": "Video loading...",

      // Landing - Testimonials
      "landing.testimonials.title": "What they say",
      "landing.testimonials.subtitle": "Thousands of travelers already trust us",
      "landing.testimonials.marie.text": "I organized my trip to Rome in 10 minutes. The AI found activities I would never have discovered on my own!",
      "landing.testimonials.thomas.text": "The flight comparison tool is amazing. I saved €200 on my round trip to Tokyo.",
      "landing.testimonials.sophie.text": "Perfect for family trips. The AI understood our constraints with children and adapted the entire itinerary.",

      // Landing - Pricing
      "landing.pricing.title": "Simple pricing",
      "landing.pricing.subtitle": "Monthly or yearly (discount included). You stay in control, change anytime.",
      "landing.pricing.or": "or",
      "landing.pricing.choose": "Choose",
      "landing.pricing.comingSoon": "Stripe payment coming soon. (For now: showcase.)",
      "landing.pricing.free.name": "Free",
      "landing.pricing.free.badge": "Default",
      "landing.pricing.free.feature1": "X credits / month",
      "landing.pricing.free.feature2": "Basic recommendations",
      "landing.pricing.free.feature3": "Blog access",
      "landing.pricing.pro.name": "Pro",
      "landing.pricing.pro.badge": "Most popular",
      "landing.pricing.pro.feature1": "Everything in Free",
      "landing.pricing.pro.feature2": "PDF download",
      "landing.pricing.pro.feature3": "More credits / month",
      "landing.pricing.premium.name": "Premium",
      "landing.pricing.premium.feature1": "Everything in Pro",
      "landing.pricing.premium.feature2": "Advanced customization (more time)",
      "landing.pricing.premium.feature3": "Priority on best options",

      // Share
      "share.button": "Share",
      "share.shareItinerary": "Share this itinerary",
      "share.shareText": "Check out my {{days}}-day itinerary to {{destination}}! 🌍✨",
      "share.sharing": "Sharing",
      "share.openingPlatform": "Opening {{platform}}...",
      "share.shared": "Shared!",
      "share.sharedSuccess": "Itinerary shared successfully",
      "share.cancelled": "Share cancelled",
      "share.linkCopied": "Link copied!",
      "share.pasteInstagram": "Paste it in your Instagram story",
      "share.canShareNow": "You can now share it",
      "share.copyLink": "Copy link",

      // Planner common
      "planner.common.add": "Add",
      "planner.common.addActivity": "Add an activity",
      "planner.common.noActivityPlanned": "No activity planned",
      "planner.common.viewPlanning": "View planning",
      "planner.common.viewMap": "View map",
      "planner.common.viewOnMap": "View on map",
      "planner.common.viewOnMapCount": "View on map ({{count}} place)",
      "planner.common.viewOnMapCountPlural": "View on map ({{count}} places)",
      "planner.common.openInMaps": "Open in Maps",
      "planner.common.itinerary": "Itinerary",
      "planner.common.day": "day",
      "planner.common.days": "days",
      "planner.common.activity": "activity",
      "planner.common.activities": "activities",
      "planner.common.loadingDetails": "Loading details...",
      "planner.common.previousPhoto": "Previous photo",
      "planner.common.nextPhoto": "Next photo",
      "planner.common.showLess": "Show less",
      "planner.common.showMore": "Read more",
      "planner.common.showAllRooms": "View all {{count}} rooms",
      "planner.common.showOtherRooms": "Show {{count}} other rooms",
      "planner.common.aboutHotel": "About this hotel",
      "planner.common.availableRooms": "Available rooms",
      "planner.common.book": "Book",
      "planner.common.viewOnBooking": "View on Booking",
      "planner.common.searchInZone": "Search in this area",
      "planner.common.searchInProgress": "Searching...",
      "planner.common.searchInProgressTitle": "Search in progress...",
      "planner.common.searchActivitiesInZone": "Search for activities in visible area",

      // Planner - Conflicts
      "planner.conflicts.noIssue": "No issues detected",
      "planner.conflicts.collapse": "Collapse",
      "planner.conflicts.viewAll": "View all",
      "planner.conflicts.problem": "issue",
      "planner.conflicts.problems": "issues",
      "planner.conflicts.warning": "warning",
      "planner.conflicts.warnings": "warnings",
      "planner.conflicts.suggestion": "suggestion",
      "planner.conflicts.suggestions": "suggestions",

      // Planner - Travelers (additional keys)
      "planner.travelers.adult": "adult",
      "planner.travelers.child": "child",
      "planner.travelers.infant": "infant",
      "planner.travelers.traveler": "traveler",
      "planner.travelers.travelersPlural": "travelers",

      // Planner - QuickEditChips
      "planner.quickEdit.dates": "Dates",
      "planner.quickEdit.travelers": "Travelers",
      "planner.quickEdit.departure": "Departure",
      "planner.quickEdit.destination": "Destination",
      "planner.quickEdit.budget": "Budget",
      "planner.quickEdit.moreOptions": "More options",

      // Planner - ActivitySearchBar
      "planner.activitySearch.placeholder": "Search a destination...",
      "planner.activitySearch.clear": "Clear",
      "planner.activitySearch.search": "Search",
      "planner.activitySearch.searching": "Searching...",
      "planner.activitySearch.quickFilters": "Quick filters",
      "planner.activitySearch.category.culture": "Culture",
      "planner.activitySearch.category.food": "Food",
      "planner.activitySearch.category.nature": "Nature",
      "planner.activitySearch.category.adventure": "Adventure",
      "planner.activitySearch.category.beach": "Beach",

      // Planner - Accommodation (additional keys)
      "planner.accommodation.missingDates": "Missing dates",
      "planner.accommodation.chooseDates": "Choose check-in and check-out dates to search for accommodations.",
      "planner.accommodation.noHotelsFound": "No hotels found for these criteria",

      // Planner - YouTube
      "planner.youtube.loadError": "Unable to load videos",
      "planner.youtube.refreshVideos": "Refresh videos",
      "planner.youtube.retry": "Retry",
      "planner.youtube.noVideosFound": "No videos found for {{location}}.",
      "planner.youtube.closeVideo": "Close video",
      "planner.youtube.previousVideo": "Previous video",
      "planner.youtube.nextVideo": "Next video",
      "planner.youtube.play": "Play",
      "planner.youtube.pause": "Pause",
      "planner.youtube.mute": "Mute",
      "planner.youtube.unmute": "Unmute",
      "planner.youtube.scrollForNext": "Scroll for next video",

      // Planner - Message Actions
      "planner.message.copy": "Copy",
      "planner.message.copyMessage": "Copy message",
      "planner.message.copied": "Copied!",
      "planner.message.copyError": "Unable to copy",
      "planner.message.like": "Like",
      "planner.message.likeResponse": "Like this response",
      "planner.message.dislike": "Dislike",
      "planner.message.dislikeResponse": "Dislike this response",

      // Planner - Booking Flow
      "planner.booking.summary": "Summary",
      "planner.booking.travelers": "Travelers",
      "planner.booking.contact": "Contact",
      "planner.booking.confirmation": "Confirmation",
      "planner.booking.adult": "adult",
      "planner.booking.adults": "adults",
      "planner.booking.child": "child",
      "planner.booking.children": "children",
      "planner.booking.confirmed": "Confirmed",
      "planner.booking.pending": "Pending",
      "planner.booking.reserve": "Book",
      "planner.booking.subtotal": "Subtotal",
      "planner.booking.serviceFees": "Service fees",
      "planner.booking.discount": "Discount",
      "planner.booking.total": "Total",
      "planner.booking.continueToTravelers": "Continue to travelers",
      "planner.booking.travelerInfo": "Enter each traveler's information as it appears on their identity documents.",
      "planner.booking.traveler": "Traveler",
      "planner.booking.adultLabel": "(Adult)",
      "planner.booking.childLabel": "(Child)",
      "planner.booking.infantLabel": "(Infant)",
      "planner.booking.firstName": "First name",
      "planner.booking.lastName": "Last name",
      "planner.booking.back": "Back",
      "planner.booking.continue": "Continue",
      "planner.booking.finalize": "Finalize",
      "planner.booking.finish": "Finish",
      "planner.booking.contactInfo": "This information will be used for your booking confirmations.",
      "planner.booking.email": "Email",
      "planner.booking.phone": "Phone",
      "planner.booking.securityNote": "Your data is secure and will only be shared with travel providers.",
      "planner.booking.tripReady": "Your trip is ready!",
      "planner.booking.reservationsConfirmed": "{{count}} reservation confirmed",
      "planner.booking.reservationsConfirmedPlural": "{{count}} reservations confirmed",
      "planner.booking.finalizeBelow": "Finalize your reservations below",
      "planner.booking.confirmedReservations": "Confirmed reservations",
      "planner.booking.toBook": "To book",
      "planner.booking.ref": "Ref",
      "planner.booking.downloadPdf": "Download PDF",
      "planner.booking.sendByEmail": "Send by email",
      "planner.booking.itemSelected": "item selected",
      "planner.booking.itemsSelected": "items selected",
      "planner.booking.readyToBook": "Ready to book",

      // Planner - Flight Comparison
      "planner.comparison.bestPrice": "Best price",
      "planner.comparison.fastest": "Fastest",
      "planner.comparison.mostComfortable": "Most comfortable",
      "planner.comparison.bestSchedule": "Best schedule",
      "planner.comparison.outbound": "Outbound",
      "planner.comparison.return": "Return",
      "planner.comparison.direct": "Direct",
      "planner.comparison.stop": "stop",
      "planner.comparison.stops": "stops",
      "planner.comparison.cheaper": "Cheaper",
      "planner.comparison.faster": "Faster",
      "planner.comparison.select": "Select",
      "planner.comparison.totalDuration": "Total duration",
      "planner.comparison.layovers": "Layovers",
      "planner.comparison.baggage": "Baggage",
      "planner.comparison.included": "Included",
      "planner.comparison.cabinOnly": "Cabin only",
      "planner.comparison.notIncluded": "Not included",
      "planner.comparison.flexibility": "Flexibility",
      "planner.comparison.refundable": "Refundable",
      "planner.comparison.changeable": "Changeable",
      "planner.comparison.notFlexible": "Not flex.",
      "planner.comparison.perPerson": "/pers.",

      // Planner - Hotel Comparison
      "planner.comparison.hotel.bestPrice": "Best price",
      "planner.comparison.hotel.bestRated": "Best rated",
      "planner.comparison.hotel.bestLocation": "Best location",
      "planner.comparison.hotel.bestValue": "Best value",
      "planner.comparison.hotel.recommended": "Recommended",
      "planner.comparison.hotel.reviews": "reviews",
      "planner.comparison.hotel.breakfastIncluded": "Breakfast included",
      "planner.comparison.hotel.freeCancellation": "Free cancellation",
      "planner.comparison.hotel.perNight": "/night",
      "planner.comparison.hotel.total": "Total",
      "planner.comparison.hotel.nights": "nights",
      "planner.comparison.hotel.cheaper": "Cheaper",
      "planner.comparison.hotel.betterRated": "Better rated",
      "planner.comparison.hotel.book": "Book",
      "planner.comparison.hotel.amenities": "Amenities",
      "planner.comparison.hotel.cancellation": "Cancellation",
      "planner.comparison.hotel.free": "Free",
      "planner.comparison.hotel.nonRefundable": "Non refund.",
      "planner.comparison.hotel.payment": "Payment",
      "planner.comparison.hotel.onSite": "On site",
      "planner.comparison.hotel.now": "Now",

      // Planner - Weather
      "planner.weather.noForecast": "No weather forecast available",
      "planner.weather.weatherAt": "Weather in {{location}}",
      "planner.weather.days": "days",
      "planner.weather.avgTemp": "Avg.",
      "planner.weather.rainyDay": "rainy day",
      "planner.weather.rainyDays": "rainy days",
      "planner.weather.precipitation": "Precipitation",
      "planner.weather.wind": "Wind",
      "planner.weather.humidity": "Humidity",
      "planner.weather.today": "Today",
      "planner.weather.tomorrow": "Tomorrow",
      "planner.weather.sunny": "Sunny",
      "planner.weather.partlyCloudy": "Partly cloudy",
      "planner.weather.cloudy": "Cloudy",
      "planner.weather.rainy": "Rainy",
      "planner.weather.stormy": "Stormy",
      "planner.weather.snowy": "Snowy",
      "planner.weather.foggy": "Foggy",
      "planner.weather.windy": "Windy",

      // Planner - Recommendation
      "planner.recommendation.recommendedForYou": "Recommended for you",
      "planner.recommendation.select": "Select",
      "planner.recommendation.details": "Details",
      "planner.recommendation.perPerson": "/pers.",

      // Planner - Calendar
      "planner.calendar.bestPrice": "Best price",
      "planner.calendar.confirmDates": "Confirm dates",
      "planner.calendar.prices": "Prices",
      "planner.calendar.weather": "Weather",
      "planner.calendar.selectAirports": "Select a departure and arrival airport to see prices",
      "planner.calendar.outbound": "Outbound",
      "planner.calendar.return": "Return",

      // Planner - AI Conflict Badge
      "planner.ai.suggests": "AI suggests",
      "planner.ai.detectedValueDifferent": "Detected value different from your selection",
      "planner.ai.applySuggestion": "Apply suggestion",
      "planner.ai.ignore": "Ignore",

      // Planner - Compact Cards
      "planner.flight.direct": "Direct",
      "planner.flight.stopover": "{{count}} stopover",
      "planner.flight.stopovers": "{{count}} stopovers",
      "planner.flight.outbound": "Outbound",
      "planner.flight.return": "Return",
      "planner.common.perPerson": "/person",
      "planner.common.reviews": "reviews",
      "planner.hotel.perNight": "/night",
      "planner.hotel.night": "night",
      "planner.hotel.nights": "nights",
      "planner.hotel.total": "total",
      "planner.activity.instantConfirmation": "Instant confirmation",
      "planner.activity.freeCancellation": "Free cancellation",
      "planner.activity.availableFrom": "Available",

      // Planner - Proactive Alerts
      "planner.alert.historicLow": "Historic low price!",
      "planner.alert.priceDrop": "Price drop!",
      "planner.alert.priceDropMessage": "The price of {{itemType}} \"{{itemName}}\" has dropped.",
      "planner.alert.itemFlight": "the flight",
      "planner.alert.itemHotel": "the hotel",
      "planner.alert.itemActivity": "the activity",
      "planner.alert.viewOffer": "View offer",
      "planner.alert.bookNow": "Book now",
      "planner.alert.priceIncrease": "Price increase",
      "planner.alert.priceIncreaseMessage": "The price has increased by {{percent}}%. Book quickly before another increase.",
      "planner.alert.limitedAvailability": "Limited availability",
      "planner.alert.lastSpots": "Last spots!",
      "planner.alert.spotsRemaining": "Only {{count}} spots remaining.",
      "planner.alert.lastSpotRemaining": "Only {{count}} spot left!",
      "planner.alert.lastSpotsRemaining": "Only {{count}} spots left!",
      "planner.alert.lastMinuteOffer": "Last minute offer",
      "planner.alert.book": "Book",
      "planner.alert.departureClose": "Departure very close!",
      "planner.alert.timeToBook": "Time to book",
      "planner.alert.departureCloseMessage": "Your departure is in {{days}} days and you don't have a flight yet. Prices increase sharply as departure approaches.",
      "planner.alert.timeToBookMessage": "Your departure is in {{days}} days. Book your flights now for the best prices.",
      "planner.alert.searchFlights": "Search flights",
      "planner.alert.peakSeason": "Peak season",
      "planner.alert.highSeason": "High season",
      "planner.alert.peakSeasonMessage": "It's peak season in {{city}}. Expect prices {{percent}}% higher and very crowded sites.",
      "planner.alert.highSeasonMessage": "It's high season in {{city}}. Prices are about {{percent}}% higher than usual.",
      "planner.alert.viewOtherDates": "View other dates",

      // Planner - Contextual Suggestions
      "planner.suggestion.lowSeason": "Good news! You're traveling in low season to {{destination}}. Prices are about {{percent}}% cheaper and sites less crowded.",
      "planner.suggestion.shoulderSeason": "You're traveling in shoulder season to {{destination}}. It's a good balance between price and crowds.",
      "planner.suggestion.highSeasonMessage": "Attention, you're traveling in high season to {{destination}}. Expect prices {{percent}}% higher.",
      "planner.suggestion.peakSeasonMessage": "It's peak season in {{destination}}! Prices are {{percent}}% higher and sites very crowded. Book early!",
      "planner.suggestion.lowSeasonTitle": "Low season 👍",
      "planner.suggestion.shoulderSeasonTitle": "Shoulder season",
      "planner.suggestion.highSeasonTitle": "High season ⚠️",
      "planner.suggestion.peakSeasonTitle": "Peak season 🔥",
      "planner.suggestion.viewOtherDates": "View other dates",
      "planner.suggestion.savingsFlights": "Save on flights",
      "planner.suggestion.savingsFlightsMessage": "Flights are generally 20-30% cheaper mid-week (Tuesday-Wednesday).",
      "planner.suggestion.modifyDates": "Modify dates",
      "planner.suggestion.alternativeAccommodation": "Accommodation alternatives",
      "planner.suggestion.alternativeAccommodationMessage": "More affordable options exist. Apartments and hostels often offer better value for money.",
      "planner.suggestion.earlyBooking": "Early booking",
      "planner.suggestion.earlyBookingMessage": "You're leaving in more than 2 months. The best prices are often available 6-8 weeks before departure.",
      "planner.suggestion.lateBooking": "Late booking",
      "planner.suggestion.lateBookingMessage": "Your departure is approaching! Prices may increase rapidly. Book as soon as possible.",

      // Planner - Step Tips
      "planner.tip.destination": "Tip",
      "planner.tip.destinationMessage": "You can specify a country or region, and I'll suggest the best cities to visit.",
      "planner.tip.datesFlexible": "Flexible dates?",
      "planner.tip.datesFlexibleMessage": "If your dates are flexible, let me know. I can find the cheapest days.",
      "planner.tip.familyTravel": "Family travel?",
      "planner.tip.familyTravelMessage": "If you're traveling with children, I'll prioritize suitable accommodations and activities.",
      "planner.tip.compareOptions": "Compare options",
      "planner.tip.compareOptionsMessage": "Connecting flights are often cheaper. I can show you both options.",
      "planner.tip.locationKey": "Key location",
      "planner.tip.locationKeyMessage": "A well-located hotel can save you on transportation. I consider proximity to sites.",
      "planner.tip.localExperiences": "Local experiences",
      "planner.tip.localExperiencesMessage": "I can suggest activities based on your interests: culture, gastronomy, adventure...",
      "planner.tip.airportTransfers": "Airport transfers",
      "planner.tip.airportTransfersMessage": "Booking a private transfer can be more economical than a taxi, especially for groups.",

      // Planner - Quick Replies
      "planner.quickReply.planTrip": "Plan a trip",
      "planner.quickReply.getInspired": "Get inspired",
      "planner.quickReply.resumeTrip": "Resume my trip",
      "planner.quickReply.beach": "Beach & sun ☀️",
      "planner.quickReply.cityBreak": "City break 🏙️",
      "planner.quickReply.nature": "Nature & adventure 🏔️",
      "planner.quickReply.culture": "Culture & history 🏛️",
      "planner.quickReply.flexibleDates": "Flexible dates",
      "planner.quickReply.nextWeekend": "Next weekend",
      "planner.quickReply.oneWeek": "One week",
      "planner.quickReply.solo": "Solo",
      "planner.quickReply.couple": "As a couple",
      "planner.quickReply.family": "With family",
      "planner.quickReply.group": "In a group",
      "planner.quickReply.cheapest": "Cheapest",
      "planner.quickReply.directFlights": "Direct flights",
      "planner.quickReply.morningDeparture": "Morning departure",
      "planner.quickReply.budget": "Low budget",
      "planner.quickReply.center": "City center",
      "planner.quickReply.fourStar": "4 stars +",
      "planner.quickReply.popular": "Most popular",
      "planner.quickReply.freeActivities": "Free activities",
      "planner.quickReply.skipStep": "Skip this step",
      "planner.quickReply.privateTransfer": "Private transfer",
      "planner.quickReply.sharedShuttle": "Shared shuttle",
      "planner.quickReply.noNeed": "No need",
      "planner.quickReply.modifySomething": "Modify something",
      "planner.quickReply.perfect": "Perfect! ✓",
      "planner.quickReply.bookAll": "Book all",
      "planner.quickReply.bookLater": "Book later",

      // Planner - Missing Fields
      "planner.missing.departure": "departure city",
      "planner.missing.arrival": "destination",
      "planner.missing.departureDate": "departure date",
      "planner.missing.returnDate": "return date",
      "planner.missing.passengers": "number of travelers",
      "planner.missing.legs": "trip legs",
      "planner.missing.readyToSearch": "None - ready to search",

      // Planner - Action Buttons
      "planner.action.added": "Added",
      "planner.action.selectFlight": "Select this flight",
      "planner.action.bookHotel": "Book this hotel",
      "planner.action.addActivity": "Add this activity",
      "planner.action.addToTrip": "Add to trip",
      "planner.action.maxItems": "Maximum {{count}} items",
      "planner.action.removeFromCompare": "Remove from comparison",
      "planner.action.compare": "Compare",
      "planner.action.remove": "Remove",
      "planner.action.removeFromFavorites": "Remove from favorites",
      "planner.action.save": "Save",
      "planner.action.saved": "Saved",
      "planner.action.viewDetails": "View details",
      
      // Planner - Travelers Widget (additional keys)
      "planner.travelers.travelingAlone": "Are you traveling <strong>alone</strong>?",
      "planner.travelers.adultSingular": "{{count}} adult",
      "planner.travelers.adultPlural": "{{count}} adults",
      "planner.travelers.childSingular": "{{count}} child",
      "planner.travelers.childPlural": "{{count}} children",
      "planner.travelers.infantSingular": "{{count}} infant",
      "planner.travelers.infantPlural": "{{count}} infants",
      
      // Planner - Missing Fields Card
      "planner.missingFields.infoMissing": "Missing information",
      "planner.missingFields.readyToSearch": "Ready to search",
      "planner.missingFields.required": "required",
      "planner.missingFields.optional": "Optional",
      "planner.missingFields.fieldRequired": "{{label}} required",
      "planner.missingFields.destination": "Destination",
      "planner.missingFields.departureDate": "Departure date",
      "planner.missingFields.returnDate": "Return date",
      "planner.missingFields.travelersLabel": "Travelers",
      
      // Planner - Trip Summary
      "planner.tripSummary.tripTo": "Trip to {{city}}",
      "planner.tripSummary.yourTrip": "Your trip",
      "planner.tripSummary.nights": "nights",
      "planner.tripSummary.flight": "Flight",
      "planner.tripSummary.hotel": "Hotel",
      "planner.tripSummary.activitiesCount": "{{count}} activity",
      "planner.tripSummary.activitiesCountPlural": "{{count}} activities",
      "planner.tripSummary.total": "Total",
      
      // Planner - Map Preview (additional keys)
      "planner.map.itinerary": "Itinerary",
      "planner.map.yourItinerary": "Your itinerary",
      "planner.map.searchInArea": "Search in this area",
      "planner.map.searchingInArea": "Searching...",
      "planner.map.searchInAreaTitle": "Search for activities in the visible area",
      "planner.map.searchingTitle": "Searching...",
      
      // Planner - Destination Suggestions
      "planner.suggestions.analyzingPreferences": "Analyzing your preferences...",
      "planner.suggestions.searchingDestinations": "Searching for the best destinations",
      "planner.suggestions.noSuggestions": "No suggestions available",
      "planner.suggestions.basedOnProfile": "Recommendations based on your profile",
      "planner.suggestions.profileComplete": "({{score}}% complete)",
      "planner.suggestions.previousDestination": "Previous destination",
      "planner.suggestions.nextDestination": "Next destination",
      "planner.suggestions.goToDestination": "Go to destination {{index}}",
      "planner.suggestions.swipeHint": "← Swipe to see more destinations →",
      
      // Planner - Airport Widgets
      "planner.airport.departure": "Departure",
      "planner.airport.arrival": "Arrival",
      "planner.airport.recommended": "recommended",
      "planner.airport.bestChoice": "Best choice",
      "planner.airport.kmFromCenter": "{{km}} km from center",
      "planner.airport.accept": "Accept",
      "planner.airport.seeOthers": "See others",
      "planner.airport.confirmedAirports": "Confirmed airports",
      "planner.airport.airportSelection": "Airport selection",
      "planner.airport.availableDeparture": "Available departure airports",
      "planner.airport.availableArrival": "Available arrival airports",
      "planner.airport.closest": "Closest",
      "planner.airport.farthest": "Farthest",
      "planner.airport.majorInternational": "Major international airport",
      "planner.airport.moreFlights": "More flights available",
      "planner.airport.betterConnection": "Better connection",
      "planner.airport.quickAccess": "Quick access from center",
      "planner.airport.lessFlightChoice": "Less flight choice",
      "planner.airport.searchingFlights": "Searching...",
      "planner.airport.searchFlights": "Search {{count}} flight",
      "planner.airport.searchFlightsPlural": "Search {{count}} flights",
      
      // Planner - Cabin Class
      "planner.cabin.economy": "Economy",
      "planner.cabin.economyShort": "Eco",
      "planner.cabin.economyDesc": "Best price",
      "planner.cabin.premiumEconomy": "Premium Economy",
      "planner.cabin.premiumShort": "Premium",
      "planner.cabin.premiumDesc": "More space",
      "planner.cabin.business": "Business",
      "planner.cabin.businessDesc": "Superior comfort",
      "planner.cabin.first": "First",
      "planner.cabin.firstShort": "1st",
      "planner.cabin.firstDesc": "Luxury & exclusivity",
      
      // Planner - Budget
      "planner.budget.label": "Budget",
      
      // Planner - Hotel Search
      "planner.hotelSearch.accommodationsIn": "Accommodations in {{destination}}",
      "planner.hotelSearch.searchingInProgress": "Searching...",
      "planner.hotelSearch.resultsCount": "{{count}} results · {{nights}} night",
      "planner.hotelSearch.resultsCountPlural": "{{count}} results · {{nights}} nights",
      
      // Planner - Search Buttons
      "planner.search.searchFlightsNow": "Search flights now",
      "planner.search.search": "Search",
      "planner.search.searching": "Searching...",
      
      // Planner - Inspire Flow
      "planner.inspire.excellentChoice": "Excellent choice! **{{country}}** is a perfect destination for you.",
      "planner.inspire.searchingCities": "Searching for main cities...",
      "planner.inspire.whichCity": "Which city would you like to visit?",
      "planner.inspire.typeCity": "Which city would you like to visit? Type the name in the chat.",
      "planner.inspire.importantCity": "Major city",
      
      // Planner - Navigation
      "planner.nav.tabNavigation": "Tab navigation",
      
      // Planner - Date Picker Labels
      "planner.datePicker.chooseDepartureDate": "Choose departure date",
      "planner.datePicker.chooseReturnDate": "Choose return date",
      
      // Planner - Dual Airport Labels
      "planner.dualAirport.departure": "Departure",
      "planner.dualAirport.arrival": "Arrival",

      // ============================================
      // LANDING PAGE "/" - Complete translations
      // ============================================

      // Landing - Hero Section
      "landing.hero.title": "Where do you want to go?",
      "landing.hero.scrollIndicator": "See how it works",
      "landing.hero.planButton": "Plan",
      "landing.hero.ariaLabel": "Describe your ideal trip",

      // Landing - Quick Actions
      "landing.quickActions.inspireme": "Inspire me",
      "landing.quickActions.inspiremeMsg": "Inspire me for my next trip",
      "landing.quickActions.weekend": "Sunny weekend",
      "landing.quickActions.weekendMsg": "I want to go on a sunny weekend getaway",
      "landing.quickActions.citybreak": "City break Europe",
      "landing.quickActions.citybreakMsg": "City break in Europe, which city do you recommend?",
      "landing.quickActions.romantic": "Romantic getaway",
      "landing.quickActions.romanticMsg": "I'm looking for a romantic destination for 2",
      "landing.quickActions.cheapflight": "Cheap flight",
      "landing.quickActions.cheapflightMsg": "Find me the cheapest flights from Paris",

      // Landing - Destinations
      "landing.destinations.title": "Where to go?",
      "landing.destinations.subtitle": "Click on a destination and let me help you plan your ideal trip",
      "landing.destinations.planAction": "Plan",
      "landing.destinations.barcelona.title": "Barcelona",
      "landing.destinations.barcelona.subtitle": "Cultural city break",
      "landing.destinations.barcelona.duration": "3-5 days",
      "landing.destinations.barcelona.query": "City break in Barcelona, what do you recommend?",
      "landing.destinations.lisbon.title": "Lisbon",
      "landing.destinations.lisbon.subtitle": "Portuguese charm",
      "landing.destinations.lisbon.duration": "4-6 days",
      "landing.destinations.lisbon.query": "Trip to Lisbon, help me plan",
      "landing.destinations.rome.title": "Rome",
      "landing.destinations.rome.subtitle": "History & Gastronomy",
      "landing.destinations.rome.duration": "4-7 days",
      "landing.destinations.rome.query": "Getaway to Rome, itinerary suggestions",
      "landing.destinations.marrakech.title": "Marrakech",
      "landing.destinations.marrakech.subtitle": "Oriental escape",
      "landing.destinations.marrakech.duration": "5-7 days",
      "landing.destinations.marrakech.query": "Trip to Marrakech, I want to discover the souks and riads",
      "landing.destinations.santorini.title": "Santorini",
      "landing.destinations.santorini.subtitle": "Greek islands",
      "landing.destinations.santorini.duration": "5-7 days",
      "landing.destinations.santorini.query": "Santorini for couples, help me organize",
      "landing.destinations.tokyo.title": "Tokyo",
      "landing.destinations.tokyo.subtitle": "Japanese immersion",
      "landing.destinations.tokyo.duration": "10-14 days",
      "landing.destinations.tokyo.query": "Trip to Japan, Tokyo and surroundings",

      // Landing - How It Works
      "landing.howItWorks.title": "How it works (really)",
      "landing.howItWorks.subtitle": "3 steps. One conversation. A trip ready to go.",
      "landing.howItWorks.step1.title": "Tell me what you want",
      "landing.howItWorks.step1.desc": "Destination, dates, budget... in one sentence. No endless forms.",
      "landing.howItWorks.step1.example": "\"Barcelona, 4 days, €700, as a couple\"",
      "landing.howItWorks.step2.title": "I suggest a clear plan",
      "landing.howItWorks.step2.desc": "Flights, hotels, activities — a coherent first version, easy to read.",
      "landing.howItWorks.step2.example": "3 options + recommendations",
      "landing.howItWorks.step3.title": "You adjust, then receive everything",
      "landing.howItWorks.step3.desc": "Modify what you want, then get your itinerary ready to book.",
      "landing.howItWorks.step3.example": "Links + summary (PDF in Pro)",
      "landing.howItWorks.examplePrefix": "Ex:",

      // Landing - Features
      "landing.features.title": "Why Travliaq?",
      "landing.features.subtitle": "Simple, fast, free.",
      "landing.features.free.title": "100% Free",
      "landing.features.free.desc": "No credit card required, no mandatory registration.",
      "landing.features.fast.title": "Results in 2 min",
      "landing.features.fast.desc": "Tell us your wishes, we take care of the rest.",
      "landing.features.custom.title": "100% Custom",
      "landing.features.custom.desc": "A personalized itinerary based on your tastes.",
      "landing.features.benefits.comparison": "Price comparison",
      "landing.features.benefits.spots": "Hidden spots",
      "landing.features.benefits.rhythm": "Adapted to your pace",
      "landing.features.benefits.nosurprise": "No surprises",

      // Landing - Partners
      "landing.partners.title": "Our partners",

      // Landing - Final CTA
      "landing.cta.title": "Tell me where you want to go",
      "landing.cta.subtitle": "I'll take care of the rest. Flight, hotel, activities – everything will be ready in minutes.",
      "landing.cta.free": "100% free",
      "landing.cta.noSignup": "No registration",
      "landing.cta.fastResults": "Results in 2 min",

      // Landing - Animated Placeholders
      "landing.placeholders.0": "Find me a cheap flight to Barcelona...",
      "landing.placeholders.1": "Romantic weekend in Rome in February...",
      "landing.placeholders.2": "Road trip in Spain for 2 weeks...",
      "landing.placeholders.3": "Help me plan a week in Italy...",
      "landing.placeholders.4": "Family trip to Portugal this summer...",
      "landing.placeholders.5": "City break in Lisbon this weekend...",

      // Landing - FAQ
      "landing.faq.title": "Frequently asked questions",
      "landing.faq.subtitle": "Everything you need to know before getting started",
      "landing.faq.q1": "What exactly is Travliaq?",
      "landing.faq.a1": "Travliaq is your personal AI travel assistant. Tell it where you want to go, your budget, your dates, and it creates a custom itinerary with flights, hotels and activities. All in minutes instead of hours.",
      "landing.faq.q2": "Is it free?",
      "landing.faq.a2": "Yes, basic planning is free! You can create itineraries and get recommendations at no cost. Premium options are available for more features like PDF downloads or advanced customization.",
      "landing.faq.q3": "How does it work exactly?",
      "landing.faq.a3": "You chat with me like with a friend. Tell me your wishes (destination, dates, budget, travel style) and I'll suggest a complete itinerary. You can refine, modify, and when you're satisfied, you receive everything by email.",
      "landing.faq.q4": "Can I modify my itinerary afterwards?",
      "landing.faq.a4": "Absolutely! You can come back to it anytime. Change dates, add activities, modify the hotel... I adapt in real-time to your requests.",
      "landing.faq.q5": "Are the prices reliable?",
      "landing.faq.a5": "I compare prices in real-time with major booking platforms. The displayed prices are what you'll find when booking (subject to normal variations).",
      "landing.faq.q6": "Which destinations are available?",
      "landing.faq.a6": "Travliaq covers the entire world! Whether you dream of Tokyo, New York, Marrakech, Bali or a road trip in Patagonia, our AI finds the best options for any destination.",
      "landing.faq.q7": "How long does it take to receive my itinerary?",
      "landing.faq.a7": "Generally, you receive your first proposal within 24 hours of your request. For urgent requests, we can speed up the process.",
      "landing.faq.q8": "Can I travel in a group or with family?",
      "landing.faq.a8": "Of course! Travliaq adapts to all types of travelers: solo, duo, group of friends or family with children. The itinerary will be customized based on the number of participants and their specific needs.",
      "landing.faq.q9": "How is my data protected?",
      "landing.faq.a9": "Your data is secure and never shared with third parties without your consent. We use best security practices and comply with GDPR.",
      "landing.faq.q10": "How do I contact support?",
      "landing.faq.a10": "You can contact us anytime at contact@travliaq.com. Our team typically responds within 24 hours. You can also use the integrated chat for quick questions.",

      // Landing - Footer
      "landing.footer.description": "Your personal AI travel assistant. From inspiration to departure, I'm with you.",
      "landing.footer.navigation": "Navigation",
      "landing.footer.home": "Home",
      "landing.footer.planner": "Plan",
      "landing.footer.blog": "Blog",
      "landing.footer.discover": "Discover",
      "landing.footer.legal": "Legal",
      "landing.footer.cgv": "Terms of Service",
      "landing.footer.privacy": "Privacy Policy",
      "landing.footer.mentions": "Legal Notice",
      "landing.footer.contact": "Contact",
      "landing.footer.followUs": "Follow us",
      "landing.footer.copyright": "© {{year}} Travliaq. All rights reserved.",

      // ============================================
      // PLANNER PAGE "/planner" - Additional translations
      // ============================================

      // Planner - Meta & Page
      "planner.meta.title": "Planner | Travliaq",
      "planner.meta.description": "Plan your trip with our smart assistant. Compare flights, activities and accommodations on an interactive map.",
      "planner.leaveConfirmation": "You have an ongoing conversation. Leave the planner?",

      // Planner - Accommodation Toasts
      "planner.accommodation.toast.synced": "Accommodations synced",
      "planner.accommodation.toast.syncedDesc": "{{count}} destination updated from your flights",
      "planner.accommodation.toast.syncedDescPlural": "{{count}} destinations updated from your flights",
      "planner.accommodation.toast.incompleteDestination": "Incomplete destination",
      "planner.accommodation.toast.incompleteDestinationDesc": "Select a city from the list (not just text) to get the country and coordinates.",
      "planner.accommodation.toast.missingDates": "Missing dates",
      "planner.accommodation.toast.missingDatesDesc": "Choose a check-in and check-out date to search for accommodations.",
      "planner.accommodation.toast.noResults": "No results",
      "planner.accommodation.toast.noResultsDesc": "No hotels found for these criteria",
      "planner.accommodation.toast.searchError": "Unable to search for hotels",
      "planner.accommodation.toast.searchErrorTitle": "Search error",
      "planner.accommodation.toast.locationError": "Location unavailable",
      "planner.accommodation.toast.locationErrorDesc": "Unable to determine the city at this location",
      "planner.accommodation.toast.newArea": "New area",
      "planner.accommodation.toast.newAreaFound": "{{count}} accommodations found in {{city}}",
      "planner.accommodation.toast.noHotelInCity": "No hotels found in {{city}}",
      "planner.accommodation.toast.error": "Error",
      "planner.accommodation.toast.areaSearchError": "Unable to search in this area",
      "planner.accommodation.toast.selectDatesFirst": "Please select dates first",
      "planner.accommodation.toast.destinationAdded": "Destination added",
      "planner.accommodation.toast.destinationAddedDesc": "{{name}} has been added to your accommodations",
      "planner.accommodation.toast.booking": "Booking",
      "planner.accommodation.toast.bookingSoon": "Booking will be available soon!",

      // Planner - PlannerCard
      "planner.card.perNight": "/night",
      "planner.card.fromCity": "From {{city}}",
      "planner.card.duration": "Duration",
      "planner.card.addToTrip": "Add to my trip",

      // Planner - FlightPriceMarkers
      "planner.flights.departureMarker": "Departure",

      // Planner - Chat Messages
      "planner.chat.activitiesContext": "[ACTIVITIES] {{count}} activity(ies) planned",
      "planner.chat.preferencesContext": "[PREFERENCES] Pace: {{pace}}, Style: {{style}}, Interests: {{interests}}, Comfort: {{comfort}}",
      "planner.chat.activityTitle": "Title",
      "planner.chat.activityDescription": "Description",
      "planner.chat.activityHighlights": "Highlights",
      "planner.chat.activityBudget": "Budget",
      "planner.chat.errorMessage": "Sorry, an error occurred. Please try again.",
      "planner.chat.errorOccurred": "Sorry, an error occurred. Please try again.",
      "planner.chat.excellentChoice": "Excellent choice! **{{country}}** is a perfect destination for you.",
      "planner.chat.searchingCities": "Searching for main cities...",
      "planner.chat.importantCity": "Major city",
      "planner.chat.whichCityToVisit": "Which city would you like to visit?",
      "planner.chat.searchFlightsNow": "Search flights now",
      "planner.chat.selectInterests": "Select your interests:",
      "planner.chat.adjustTravelStyle": "Adjust your travel style:",
      "planner.chat.nothingElseToAdd": "Nothing else to add. Give me 3 destination recommendations based on my profile.",
      "planner.chat.specifyInterests": "I'd like to specify my interests.",
      "planner.chat.adjustMyStyle": "I'd like to adjust my travel style.",
      "planner.chat.mandatoryCriteria": "I have mandatory criteria to specify.",
      "planner.chat.dietaryRestrictions": "I have dietary restrictions to specify.",
      "planner.chat.chooseBestDestination": "Choose the best destination for me from those displayed and explain why.",

      // Planner - YouTubeShortsPanel
      "planner.youtube.thingsToDo": "Things to do in {{city}}",
      "planner.youtube.videoPreview": "Video preview {{city}}",

      // Planner - Preferences
      "planner.preferences.wellness": "Wellness",
      "planner.preferences.party": "Party",
      "planner.preferences.remote": "Remote work",
      "planner.preferences.discovery": "Discovery",
      "planner.preferences.accessibility": "Wheelchair accessible",
      "planner.preferences.wifi": "High-speed WiFi",
      "planner.preferences.childFriendly": "Child-friendly",
      "planner.preferences.relaxed": "Relaxed",
      "planner.preferences.intense": "Intense",
      "planner.preferences.vegetarian": "Vegetarian",
      "planner.preferences.vegan": "Vegan",
      "planner.preferences.pescatarian": "Pescatarian",
      "planner.preferences.noEggs": "No eggs",
      "planner.preferences.nuts": "Tree nuts",
      "planner.preferences.criteria": "Criteria",

      // Planner - SmartTags
      "planner.smartTags.adventurer": "#Adventurer",
      "planner.smartTags.explorer": "#Explorer",
      "planner.smartTags.relaxation": "#Relaxation",
      "planner.smartTags.cultural": "#Cultural",
      "planner.smartTags.foodie": "#Foodie",
      "planner.smartTags.nature": "#Nature",
      "planner.smartTags.romantic": "#Romantic",
      "planner.smartTags.family": "#Family",
      "planner.smartTags.budget": "#Budget",
      "planner.smartTags.luxury": "#Luxury",
      "planner.smartTags.generatePrompt": "Generate the 3 hashtags that best describe me.",

    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
